const metalBandsA = [
  'AND OCEANS',
  'A DAY ON EARTH',
  'AARDVARKS',
  'AARNI',
  'AASGARD',
  'AASKEREIA',
  'ABACABB',
  'ABACINATE',
  'ABADDON',
  'ABADDON INCARNATE',
  'ABANDON',
  'ABANDON ALL SHIPS',
  'ABANDON TOMORROW',
  'ABANDONED',
  'ABATED MASS OF FLESH',
  'ABBATH',
  'ABBERANT',
  'ABDULLAH',
  'ABERRANT',
  'ABHORRANCE',
  'ABHORRENCE',
  'ABHORRENT',
  'ABHORRENT DECIMATION',
  'ABIDETHEREIN',
  'ABIGAIL',
  'ABIGAIL WILLIAMS',
  'ABIGOR',
  'ABIOTIC',
  'ABIURA',
  'ABKANIS',
  'ABLAZE IN HATRED',
  'ABLAZE MY SORROW',
  'ABNORMALITY',
  'ABOMINABLE PUTRIDITY',
  'ABOMINANT',
  'ABOMINATION',
  'ABOMINATOR',
  'ABONOS',
  'ABORTED',
  'ABORTUS',
  'ABORYM',
  'ABOVE CITY SKIES',
  'ABOVE THE BROKEN',
  'ABOVE THE STARS',
  'ABOVE THIS',
  'ABOVE THIS FIRE',
  'ABRAMELIN',
  'ABRAXAS',
  'ABRIOSIS',
  'ABROGATION',
  'ABSCESS',
  'ABSENCE',
  'THE ABSENCE',
  'ABSENS',
  'ABSENT DISTANCE',
  'ABSENTIA',
  'ABSINTHIUM',
  'ABSTAIN',
  'THE ABSTRACT',
  'ABSTRACT RAPTURE',
  'ABSTRACT SPIRIT',
  'ABSTRAKT',
  'ABSU',
  'ABSURD',
  'ABSURD CONFLICT',
  'ABSURD UNIVERSE',
  'ABSURDUS',
  'ABUSED MAJESTY',
  'ABUSIVENESS',
  'ABYDOS',
  'ABYSMAL',
  'ABYSMAL DAWN',
  'ABYSMAL GRIEF',
  'ABYSMAL TORMENT',
  'ABYSMALIA',
  'THE ABYSS',
  'ABYSSAL',
  'ABYSSARIA',
  'ABYSSIC HATE',
  'ABYSSOS',
  'ACACIA',
  'THE ACACIA STRAIN',
  'ACCEPT',
  'ACCEPT DEATH',
  'ACCUSER',
  'THE ACCÜSED',
  'ACE AUGUSTINE',
  'ACE FREHLEY',
  'ACHERON',
  'ACHERONTAS',
  'ACHSAR',
  'ACID BATH',
  'ACID DEATH',
  'ACID DRINKERS',
  'ACID KING',
  'ACID TREE',
  'ACID WITCH',
  'ACOUSTIC TORMENT',
  'ACRANIA',
  'ACRANIUS',
  'ACRASSICAUDA',
  'ACRES',
  'ACRID SEMBLANCE',
  'ACRIMONIOUS',
  'ACRIMONY',
  'ACRON',
  'ACROPHET',
  'ACROSS FIVE APRILS',
  'ACROSS SILENT HEARTS',
  'ACROSS THE SUN',
  'ACROSS TUNDRAS',
  'ACROSTICHON',
  'ACT OF DEFIANCE',
  'ACT OF GOD',
  'ACTUS REUS',
  'ACUTOR',
  'AD BACULUM',
  'AD HOMINEM',
  'AD INFERNA',
  'AD NAUSEAM',
  'AD VITAM AETERNAM',
  'ADAGIO',
  'ADALIAH',
  'ADAMAS',
  'ADAMUS EXUL',
  'ADASTREIA',
  'ADDICTION CREW',
  'ADELAIDE',
  'ADEMA',
  'ADEPT',
  'ADESTRIA',
  'ADGAR',
  'ADIAPHORA',
  'ADIASTASIA',
  'ADIMIRON',
  'ADMIRAL ANGRY',
  'ADMONISH',
  'ADOR DORATH',
  'ADORA',
  'ADORNED BROOD',
  'ADRAMELECH',
  'ADRENALINE MOB',
  'ADRENICIDE',
  'ADULTERY',
  'ADVENT',
  'ADVERSARY',
  'ADVERSUS',
  'ADVOCATES',
  'ADX',
  'AEBSENCE',
  'AEGAEON',
  'AENAON',
  'AENIMA',
  'AEON',
  'AEON ZEN',
  'AEONIAN SORROW',
  'AEONS CONFER',
  'AEONS OF CORRUPTION',
  'AEONS OF SILENCE',
  'AERANEA',
  'AERIAL',
  'AEROSMITH',
  'AES DANA',
  'AESMA DAEVA',
  'AETERNAL',
  'AETERNAM',
  'AETERNITAS',
  'AETERNUS',
  'AETHER',
  'AEURTUM',
  'AEVERON',
  'AEVUM',
  'AFFIANCE',
  'AFFLICTED',
  'AFFLICTION',
  'AFGRUND',
  'AFI',
  'AFTER FOREVER',
  'AFTER ME, THE FLOOD',
  'AFTER THE BURIAL',
  'AFTERBLOOD',
  'THE AFTERIMAGE',
  'AFTERLIGHT',
  'AFTERSHOCK',
  'AFTERWORLD',
  'AGAINST THE FLOOD',
  'AGAINST THE PLAGUES',
  'AGALLOCH',
  'AGAMENDON',
  'AGATHOCLES',
  'AGATHODAIMON',
  'AGDRON',
  'AGE OF ARTEMIS',
  'AGE OF NEMESIS',
  'AGE OF SILENCE',
  'AGELAST',
  'AGELESS OBLIVION',
  'AGENT FRESCO',
  'AGENT STEEL',
  'AGENTS OF OBLIVION',
  'AGENTS OF SATAN',
  'AGES',
  'AGGRESSION',
  'AGHAST',
  'AGHORA',
  'AGHOST',
  'AGMEN',
  'AGNOSTIC FRONT',
  'THE AGONIST',
  'AGONIZE',
  'AGONIZER',
  'AGONOIZE',
  'AGONY',
  'THE AGONY SCENE',
  'AGORAPHOBIC NOSEBLEED',
  'AGREGATOR',
  'AGRESSOR',
  'AGRIMONIA',
  'AGRYPNIE',
  'AGUA DE ANNIQUE',
  'AHAB',
  'AHNENSTAHL',
  'AHOORA',
  'AHRIMAN',
  'AHTME',
  'AIM FOR THE SUNRISE',
  'AINA',
  'AION',
  'THE AIR I BREATHE',
  'AIRBOURNE',
  'AIRDASH',
  "AIRGED L'AMH",
  'AJATTARA',
  'AKASHIC',
  'AKELA',
  'AKELEI',
  'AKERCOCKE',
  'AKHERON',
  'AKHKHARU',
  'AKHLYS',
  'AKIN',
  'AKITSA',
  'AKREA',
  'AKROTHEISM',
  'AKTIV DÖDSHJÄLP',
  'AL SIRAT',
  'ALABAMA THUNDERPUSSY',
  'ALARUM',
  'ALAS',
  'ALAS SUICIDAS',
  'ALAS, TYRANNY',
  'ALASTIS',
  'ALASTOR SANGUINARY EMBRYO',
  'ALAYA',
  'AN ALBATROSS',
  'ALBION',
  'ALCATRAZZ',
  'ALCEST',
  'ALCHEMIST',
  'ALCHEMY',
  'ALCOHOLATOR',
  'ALESANA',
  'ALESTORM',
  'ALETHEIAN',
  'ALEXISONFIRE',
  'ALGEBRA',
  'ALGHAZANTH',
  'ALHANA',
  'ALHENA',
  'ALIANZA',
  'ALIASES',
  'ALICE COOPER',
  'ALICE IN CHAINS',
  'ALICE IN DARKLAND',
  'ALIEN WEAPONRY',
  'ALIENGATES',
  'ALIGHIERI',
  'ALIGHT',
  'ALISTER',
  'ALKALOID',
  'ALKEMYST',
  'ALKONOST',
  'ALL BUT SIX',
  'ALL ELSE FAILED',
  'ALL ENDS',
  'ALL HAIL THE YETI',
  'ALL I LOST',
  'ALL IN VAIN',
  'ALL MISERY',
  'ALL OUT WAR',
  'ALL PIGS MUST DIE',
  'ALL SHALL PERISH',
  'ALL THAT I BLEED',
  'ALL THAT REMAINS',
  'ALL THINGS FALLEN',
  'ALL TOMORROWS',
  'ALL-DEVOURING LIGHT',
  'ALLAY THE SEA',
  'ALLDRIG',
  'ALLEGAEON',
  'ALLEGED',
  'ALLEGIANCE',
  'ALLIANCE & TYRANNY',
  'ALLOCHIRIA',
  'ALMA MATER',
  'ALMAFUERTE',
  'ALMAH',
  'THE ALMIGHTY',
  'ALMORA',
  'ALOGIA',
  'ALONE IN THE MORGUE',
  'ALOVE FOR ENEMIES',
  'ALPHA TIGER',
  'ALPHAWOLF',
  'ALTA DENSIDAD',
  'ALTAR',
  'ALTAR OF BETELGEUZE',
  'ALTAR OF PAIN',
  'ALTAR OF PERVERSION',
  'ALTAR OF PLAGUES',
  'ALTARIA',
  'ALTARS',
  'ALTARS OF DESTRUCTION',
  'ALTER BRIDGE',
  'ALTERBEAST',
  'ALTERED AEON',
  'ALTURA',
  'ALUKAH',
  'ALUNAH',
  'ALUSTRIUM',
  'ALVENRAD',
  'ALWAYS WAR',
  'AM I BLOOD',
  'AMADEUS AWAD',
  'AMAGORTIS',
  'AMARAN',
  'AMARANTHE',
  'AMARANTHINE TRAMPLER',
  'AMARNA REIGN',
  'AMAROK',
  'AMASEFFER',
  'AMAZON',
  'AMBEON',
  'AMBERIAN DAWN',
  'AMBERS',
  'AMBUSH',
  'AMEBIX',
  'AMEDERIA',
  'AMEN',
  'AMENAZHA',
  'AMENRA',
  'THE AMENTA',
  'AMERICAN HEAD CHARGE',
  'AMERICAN ME',
  'AMERICAN NIGHTMARE',
  'AMERICAN STANDARDS',
  'AMESOEURS',
  'AMESTIGON',
  'AMETHYST',
  'AMETROPIE',
  'AMIA VENERA LANDSCAPE',
  'AMIENSUS',
  'THE AMITY AFFLICTION',
  'AMKEN',
  'AMNAEON',
  'AMOK',
  'AMON',
  'AMON AMARTH',
  'AMON DIN',
  'AMONG THE THORNS',
  'AMONGRUINS',
  'AMORAL',
  'AMORE AD LUNAM',
  'AMORGEN',
  'AMORPHIS',
  'AMORTIS',
  'AMOS',
  'AMPLEXUS',
  'AMPLIFIER',
  'AMSET',
  'AN ABSTRACT ILLUSION',
  'AN HANDFUL OF DUST',
  'ANA KEFR',
  'ANAAL NATHRAKH',
  'ANABANTHA',
  'ANACHRONAEON',
  'ANACRUSIS',
  'ANAEL',
  'ANAGNORISIS',
  'ANAH AEVIA',
  'ANAL BLASPHEMY',
  'ANAL CUNT',
  'ANAL STENCH',
  'ANAL VOMIT',
  'ANALEPSY',
  'ANALGESIA',
  'ANAMNESIS',
  'ANAPILIN',
  'ANARBOR',
  'ANARCHADIA',
  'ANARCHY',
  'ANASARCA',
  'ANATA',
  'ANATHEMA',
  'ANCESTORS BLOOD',
  'ANCESTRAL',
  'ANCESTRAL DAWN',
  'ANCESTRAL LEGACY',
  'ANCESTTRAL',
  'ANCHOR',
  'ANCHORLINES',
  'ANCHORS OVERBOARD',
  'ANCIENT',
  'ANCIENT BARDS',
  'ANCIENT CEREMONY',
  'ANCIENT DOME',
  'ANCIENT DRIVE',
  'ANCIENT PROPHECY',
  'ANCIENT RITES',
  'ANCIENT SPHERES',
  'ANCIENT VVISDOM',
  'THE ANCIENT WAR',
  'ANCIENT WISDOM',
  "ANCIENT'S REBIRTH",
  'ANCIIENTS',
  'AND CAME BACK BRUTAL',
  'AND HELL FOLLOWED WITH',
  'AND THERE WILL BE BLOOD',
  'ANDI DERIS',
  'ANDRAGONIA',
  'ANDRALLS',
  'ANDRAS',
  'ANDRE ANDERSEN',
  'ANDRE MATOS',
  'ANDREA GAIL',
  'ANDROMEDA',
  'ANEMONIA',
  'ANGANTYR',
  'ANGARA DAMANA',
  'ANGEL CORPSE',
  'ANGEL DUST',
  'ANGEL WITCH',
  'ANGELDARK',
  'ANGELES DEL INFIERNO',
  'ANGELI DI PIETRA',
  'ANGELICA',
  'ANGELLORE',
  'ANGELMAKER',
  'ANGELSCOURGE',
  'ANGELSPIT',
  'ANGELUS APATRIDA',
  'ANGELZOOM',
  'THE ANGER MACHINE',
  'ANGIZIA',
  'ANGKOR WAT',
  'ANGRA',
  'ANGRIFF',
  'ANGTORIA',
  'ANGUISH',
  'ANGUS',
  'ANIHILATED',
  'ANIMA',
  'ANIMA DAMNATA',
  'ANIMAL MAN MACHINE',
  'ANIMALFARM',
  'ANIMATIONS',
  'ANIME FIRE',
  'ANIMOSITY',
  'ANIMUS FALL',
  'ANKHAGRAM',
  'ANKHARA',
  'ANLIPNES',
  'ANNIHILATION',
  'ANNIHILATIONMANCER',
  'ANNIHILATOR',
  'ANNISOKAY',
  'ANNOTATIONS OF AN AUTOPSY',
  'ANNTHENNATH',
  'ANOMALIE',
  'ANOMALOUS',
  'ANONYMUS',
  'ANOREXIA NERVOSA',
  'ANOTHER HERO DIES',
  'ANSIA',
  'ANSOTICCA',
  'ANSUR',
  'ANSWER WITH METAL',
  'ANTAEUS',
  'ANTAGONIST',
  'ANTALGIA',
  'THE ANTARCTICA PROJECT',
  'ANTARKTIS',
  'ANTARKTIS UTOPIA',
  'ANTERIOR',
  'ANTERRABAE',
  'ANTESTOR',
  'ANTHELION',
  'ANTHEMON',
  'ANTHEMS OF ISOLATION',
  'ANTHRAX',
  'ANTHRIEL',
  'ANTHROFUGE',
  'ANTHROPIA',
  'ANTI',
  'ANTI-MORTEM',
  'ANTICHRISIS',
  'ANTIDEMON',
  'ANTIGAMA',
  'ANTIM GRAHAN',
  'ANTIMATERIA',
  'ANTIMATTER',
  'ANTISILENCE',
  'ANTITHESIS',
  'ANTONAMASIA',
  'ANTROPOFAGUS',
  'ANTROPOMORPHIA',
  'ANTZAAT',
  'ANUBI',
  'ANUBIS GATE',
  'ANUNNAKI',
  'ANVIL',
  'ANY GIVEN DAY',
  'ANYONE ANYWAY',
  'AORLHAC',
  'AORNOS',
  'AOSOTH',
  'APATHETIQ',
  'APATI',
  'APE TO GOD',
  'APERION',
  'THE APHORIST',
  'APHOTIC',
  'APHYXION',
  'APOCALYPSE',
  'APOCALYPTIC VISIONS',
  'APOCALYPTICA',
  'APOKRYPHA',
  'APOLLYON',
  'APOPHIS',
  'APOSTASY',
  'APOSTATE',
  'APPALLING SPAWN',
  'APPARITIONS',
  'APPEARANCE OF NOTHING',
  'APPLAUD THE IMPALER',
  'APRAXIA',
  'AQME',
  'AQUARIA',
  'AQUILUS',
  'ARAB ON RADAR',
  'ARACHNES',
  'ARAFEL',
  'ARAKAIN',
  'ARALLU',
  'ARATHORN',
  'ARBITER',
  'ARCANA',
  'ARCANA COELESTIA',
  'ARCANE',
  'THE ARCANE',
  'ARCANE GRAIL',
  'ARCANE SUN',
  'THE ARCANUM EFFECT',
  'ARCH ENEMY',
  'ARCH OF HELL',
  'ARCHAGATHUS',
  'ARCHAIOS',
  'ARCHEON',
  'ARCHETYPE',
  'ARCHGOAT',
  'ARCHITECT',
  'ARCHITECTS',
  'ARCHITECTS OF CHAOZ',
  'ARCHITECTURE OF AGGRESSION',
  'ARCHONS',
  'ARCHONTES',
  'ARCHSPIRE',
  'ARCKANUM',
  'ARCTIC PLATEAU',
  'ARCTURUS',
  'ARDITI',
  'ARDULPH ARDEBAHR WALD',
  'ARENA',
  'ARES KINGDOM',
  'ARFSYND',
  'ARGAR',
  'ARGENTUM',
  'ARGHOSLENT',
  'ARGUS',
  'ARIDA VORTEX',
  'ARION',
  'ARISE',
  'ARISE AND RUIN',
  'ARISTEIA',
  'ARJEN ANTHONY LUCASSEN',
  'ARK',
  'ARK OF THE COVENANT',
  'ARKAEA',
  'ARKAIK',
  'ARKAN',
  'ARKANEN',
  'ARKANGEL',
  'ARKANOS',
  'ARKHA SVA',
  'ARKHAM WITCH',
  'ARKHON INFAUSTUS',
  'ARKHUM',
  'ARKONA',
  'ARMAGEDDA',
  'ARMAGEDDON',
  'ARMAMENT',
  'ARMED FOR APOCALYPSE',
  'ARMOR FOR THE BROKEN',
  'ARMOR OF GOD',
  'ARMORED SAINT',
  'ARMOUR',
  'ARMSBENDBACK',
  'ARNO RUSH',
  'ARPHAEL',
  'THE ARRS',
  'ARS AMANDI',
  'ARS MACABRA',
  'ARS MAGNA UMBRAE',
  'ARSAFES',
  'ARSAMES',
  'ARSANTIQVA',
  'ARSIS',
  'ARSON',
  'ARSON ANTHEM',
  'ARSON OUR SAVIOR',
  'ARSONISTS GET ALL THE GIRLS',
  'ART BY NUMBERS',
  'ART FAR AWAY',
  'ART OF DYING',
  'ARTAS',
  'ARTCH',
  'ARTEFACT',
  'ARTEMESIA',
  'ARTENSION',
  'ARTERY ERUPTION',
  'ARTHEDAIN',
  'ARTHEMESIA',
  'ARTHEMIS',
  'THE ARTIFACT',
  'ARTIFICIAL BRAIN',
  'ARTIFICIAL HEART',
  'ARTILLERY',
  'ARTIMUS PYLEDRIVER',
  'ARTIZAN',
  'ARTROSIS',
  'ARVEN',
  'ARVINGER',
  'ARWEN',
  'AS ARTIFACTS',
  'AS BLOOD RUNS BLACK',
  'AS BOLD AS LIONS',
  'AS CITIES BURN',
  'AS DIVINE GRACE',
  'AS EDEN BURNS',
  'AS ENEMIES ARISE',
  'AS HELL RETREATS',
  'AS HOPE DIES',
  'AS I LAY DYING',
  'AS LIGHT DIES',
  'AS LIONS AND LAMBS',
  'AS OCEANS',
  'AS THEY BURN',
  'AS THEY BURN ALIVE',
  'AS THEY SLEEP',
  'AS WE DRAW',
  'AS WE FIGHT',
  'AS YOU DROWN',
  'ASAGRAUM',
  'ASANGREYFUEGO',
  'ASARU',
  'ASCARIASIS',
  'ASCENSION',
  'ASCENSION OF THE WATCHERS',
  'ASCHENGLAS',
  'ASCRAEUS',
  'ASEIDAD',
  'ASENBLUT',
  'ASES',
  'ASESINO',
  'ASG',
  'ASGAARD',
  'ASGAROTH',
  'ASGARTH',
  'ASGUARD',
  'ASHEN LIGHT',
  'ASHEN MORTALITY',
  'ASHEN REIGN',
  'ASHENDAWN',
  'ASHENGRACE',
  'ASHES',
  'ASHES DIVIDE',
  'ASHES OF ARES',
  'ASHES OF MANY',
  'ASHES TO ASHES',
  'ASHES YOU LEAVE',
  'ASHTAR',
  'ASKA',
  'ASKING ALEXANDRIA',
  'ASMODEUS',
  'ASMODÉE',
  'ASP',
  'ASPECTRA',
  'ASPERA',
  'ASPERITY',
  'ASPHERIUM',
  'ASPHYX',
  'ASPHYXIA',
  'ASRAI',
  'ASSASSIN',
  'ASSASSINS',
  'ASSAULT',
  'ASSEL',
  'ASSORTED HEAP',
  'ASSÜCK',
  'ASTAROTH',
  'ASTARTE',
  'ASTERIALS',
  'ASTERION',
  'ASTRAKHAN',
  'ASTRAL DOORS',
  'ASTRAL SLEEP',
  'ASTRIAAL',
  'ASTROFAES',
  'ASUNDER',
  'AT ALL COST',
  'AT DAWN THEY SLEEP',
  'AT ONE STROKE',
  'AT REST',
  'AT THE GATES',
  'AT THE THRONE OF JUDGMENT',
  'AT VANCE',
  'AT WAR',
  'ATANATOS',
  'ATARAXIA',
  'ATARAXIE',
  'ATARGATIS',
  'ATEM',
  'ATENA',
  'ATERBAN',
  'ATHEIST',
  'ATHENA',
  'ATHERETIC',
  'ATHIMIA',
  'ATHOS',
  'ATLANTEAN KODEX',
  'THE ATLAS MOTH',
  'ATLAS OF ELYSIAN',
  'ATOMA',
  'ATOMIC FACTORY',
  'ATOMIC HEAD',
  'ATOMIC ROAR',
  'ATOMIZER',
  'ATOMSHIP',
  'ATRA HORA',
  'ATRA VETOSUS',
  'ATREYU',
  'ATROCITY',
  'ATROPHY',
  'ATROPOS',
  'ATROX',
  'ATSPHEAR',
  'ATTACK ATTACK',
  'ATTACKER',
  'ATTACKHEAD',
  'ATTIC',
  'ATTICA RAGE',
  'ATTICK DEMONS',
  'ATTIKA',
  'ATTILA',
  'AUDIOMACHY',
  'AUDIOPAIN',
  'AUDIOSLAVE',
  'AUGUR',
  'AUGURY',
  'AUGUST BURNS RED',
  'AURA',
  'AURA NOIR',
  'AURAS',
  'AURI',
  'AURITAR',
  'AURIUM',
  'AURORA',
  'AURORA BOREALIS',
  'AURVANDIL',
  'AUSTERE',
  'AUSTRIAN DEATH MACHINE',
  'AUTHOR & PUNISHER',
  'AUTOPSY',
  'AUTUMN',
  'AUTUMN CLAN',
  'AUTUMN LEAVES',
  'THE AUTUMN OFFERING',
  'AUTUMN TEARS',
  'AUTUMN VERSES',
  'AUTUMNAL',
  'AUTUMNBLAZE',
  'AUTUMNIA',
  'AVA INFERI',
  'AVALANCH',
  'THE AVALANCHE DIARIES',
  'AVALON',
  'AVANDRA',
  'AVANTASIA',
  'AVATAR',
  'AVATARIUM',
  'AVEC TRISTESSE',
  'AVENGE THE THRONE',
  'AVENGED SEVENFOLD',
  'AVENGER',
  'AVENGER OF BLOOD',
  'AVERSE SEFIRA',
  'AVERSED',
  'AVERSION',
  'AVERSIONS CROWN',
  'AVERTIA',
  'AVIAN',
  'AVIANA',
  'AVICHI',
  'AVRIGUS',
  'AVSKY',
  'AVULSED',
  'AWAITING FEAR',
  'AWAITING ONSET',
  'AWAITING THE APOCALYPSE',
  'AWAKE THE DREAMER',
  'AWAKEN DEMONS',
  'AWAKENING SUN',
  'AWAKENING THE REVENANT',
  'AWRIZIS',
  'AXAMENTA',
  'AXECRACK',
  'AXEGRESSOR',
  'AXEHAMMER',
  'AXEL RUDI PELL',
  'AXENSTAR',
  'AXEWOUND',
  'AXIS OF ADVANCE',
  'THE AXIS OF PERDITION',
  'AXXIS',
  'AYAT',
  'AYDRA',
  'AYI',
  'AYREON',
  'AYTHIS',
  'AZAGHAL',
  'AZAMOTH',
  'AZARATH',
  'AZELISASSATH',
  'AZEROTH',
  'AZOOMA',
  'AZRAEL',
  'AZTEC JADE',
  'AZUL LIMÃO',
  'AZURE EMOTE',
  'AZUSA',
  'ABYSSIC',
  'ADVENT SORROW',
  'ALL MY SINS',
  'ALTARS OF GRIEF',
  'AMBROTYPE',
  'ARBOREAL',
  'ARTIDES',
  'AURORA BLACK',
  'ÆNIMUS',
  'ÆTHER REALM',
  'ÆTHERIAL',
  'ÆRA'
];

const metalBandsB = [
  'BABY GODZILLA',
  'BABYLON SAD',
  'BABYLON WHORES',
  'BABYMETAL',
  'BACKJUMPER',
  'BACKTRACK',
  'BACKWORDZ',
  'BAD OMENS',
  'BAD RELIGION',
  'BAD SALAD',
  'BAL-SAGOTH',
  'BALAM AKAB',
  'BALANCE INTERRUPTION',
  'BALANCE OF POWER',
  'BALANCES',
  'BALFOR',
  'BALLAD FOR LAYLA',
  'BALLISTIC',
  'BALSAM GROVE',
  'BAN LESAGE',
  'BANDEMONIC',
  'BANE',
  'BANE OF EXISTENCE',
  'BANE OF WINTERSTORM',
  'THE BANNER',
  'BAPHOMET',
  'BAPTISM',
  'BAPTISTS',
  'BAPTIZED IN BLOOD',
  'BARATHRUM',
  'BARBARIAN PROPHECIES',
  'BARBATOS',
  'BARCODE',
  'BARE INFINITY',
  'BARILARI',
  'BARONESS',
  'BARRACKS',
  'BARRELEYE',
  'BARREN CROSS',
  'BARREN EARTH',
  'BARRICADA',
  'BARRIER',
  'BARROQUEJÓN',
  'BARROW',
  'BARS',
  'BARSHASKETH',
  'BARTHOLOMEUS NIGHT',
  'BARÓN ROJO',
  'BASEMENT',
  'BASTIONS',
  'BATHORY',
  'BATHSHEBA',
  'BATHTUB SHITTER',
  'BATILLUS',
  'BATTALION',
  'BATTERED',
  'BATTLE BEAST',
  'BATTLE OF MICE',
  'BATTLECROSS',
  'BATTLEHEART',
  'BATTLELORE',
  'BATTLELUST',
  'BATTLEMASTER',
  'BATTLERAGE',
  'BATTLEROAR',
  'BATTLESOUL',
  'BAY LAUREL',
  'BAYONET',
  "BE'LAKOR",
  'BEAR WITNESS',
  'BEARDFISH',
  'BEARTOOTH',
  'BEAST IN BLACK',
  'BEAST PETRIFY',
  'THE BEAST REMADE',
  'BEASTANGER',
  'BEASTCRAFT',
  'BEASTMILK',
  'BEATEN BACK TO PURE',
  'BEATRIK',
  'BEAU NAVIRE',
  'BEAUTIFUL SIN',
  'BECOMING A WARDEN',
  'BECOMING THE ARCHETYPE',
  'BEDEMON',
  'BEDLEM',
  'BEEF SUPREME',
  'BEELZEB',
  'BEFORE I TURN',
  'BEFORE THE DAWN',
  'BEFORE THE RAIN',
  'BEFORE THE TORN',
  'BEFORE THEIR EYES',
  'BEFORE THERE WAS ROSALYN',
  'BEGERITH',
  'BEGUILER',
  'BEHAVIOR',
  'BEHEADED',
  'BEHEADING OF A KING',
  'BEHEMOTH',
  'BEHERIT',
  'BEHETH',
  'BEHEXEN',
  'BEHIND THE SCENERY',
  'BEHOLD OBLIVION',
  'BEHOLD THE KINGDOM',
  'BEHOLDER',
  'BEING',
  'BEING AS AN OCEAN',
  'BEJELIT',
  'BEKHIRA',
  'BEL O KAN',
  'BELAY MY LAST',
  'BELENOS',
  'BELFEGOR',
  'BELFRY',
  'BELIE MY BURIAL',
  'BELIEVER',
  'BELL WITCH',
  'BELLADONNA',
  'BELMEZ',
  'BELOW',
  'BELPHEGOR',
  'BELTEZ',
  'BELZEBUBS',
  'BEN BLUTZUKKER',
  'BENDIDA',
  'BENEA REACH',
  'BENEATH',
  'BENEATH OBLIVION',
  'BENEATH THE ASHES',
  'BENEATH THE HORROR',
  'BENEATH THE MASSACRE',
  'BENEATH THE SKY',
  'BENEATH THE SURFACE',
  'BENEATH THE VEIL',
  'BENEDICTION',
  'BENEDICTUM',
  'BENEVOLENT',
  'BENIGHTED',
  'BENIGHTED IN SODOM',
  'BENIGHTED SOUL',
  'BENN',
  'THE BEREAVED',
  'BERESHIT',
  'BERGTHRON',
  'BERMUDA',
  'BERSERK',
  'BERSERKERFOX',
  'BERSERKR',
  'BERZEKER',
  'THE BERZERKER',
  'BESATT',
  'BESEECH',
  'BESIDE',
  'BESIEGED',
  'BESTIAL MOCKERY',
  'BESTIAL WARLUST',
  'BESTIALIT',
  'BESTIALITY BUSINESS',
  'BETHLEHEM',
  'BETHZAIDA',
  'BETO VAZQUEZ INFINITY',
  'BETRAY MY SECRETS',
  'BETRAYAL',
  'BETRAYER',
  "THE BETRAYER'S JUDGEMENT",
  'BETRAYING THE MARTYRS',
  'BETWEEN THE BURIED AND ME',
  'BETWEEN THE FALLEN',
  'BETZEFER',
  'BEVAR SEA',
  'BEWARE THE NEVERENDING',
  'BEWITCHED',
  'BEYOND ALL RECOGNITION',
  'BEYOND BELIEF',
  'BEYOND BLACK VOID',
  'BEYOND CREATION',
  'BEYOND DAWN',
  'BEYOND DEVIATION',
  'BEYOND FEAR',
  'BEYOND SHADOWS',
  'BEYOND SURFACE',
  'BEYOND TERROR BEYOND GRACE',
  'BEYOND THE AFTERMATH',
  'BEYOND THE BLACK',
  'BEYOND THE BRIDGE',
  'BEYOND THE DREAM',
  'BEYOND THE EMBRACE',
  'BEYOND THE FLESH',
  'BEYOND THE SHORE',
  'BEYOND THE SIXTH SEAL',
  'BEYOND THE VOID',
  'BEYOND TWILIGHT',
  'BEYOND WITHIN',
  'BEYOND YE GRAVE',
  'BIBLEBLACK',
  'BIFRÖST',
  'BIG BOSS',
  'BILE',
  'BILL WARD',
  'BILLY IDOL',
  'BILLY THE KID',
  'BILOCATE',
  'BILSKIRNIR',
  'BIO-CANCER',
  'BIOGENESIS',
  'BIOHAZARD',
  'BIOLOGY',
  'BIOMECHANICAL',
  'BIOMIMIC',
  'BIRDFLESH',
  'BIRDS IN ROW',
  'THE BIRTHDAY MASSACRE',
  'BISHOP OF HEXEN',
  'BISON',
  'BISS',
  'BITCH',
  'BITCHHAMMER',
  'BITTENCOURT PROJECT',
  'BITTER END',
  'BITTERDUSK',
  'BLAAST',
  'BLACK ABYSS',
  'BLACK ALTAR',
  'BLACK ANVIL',
  'BLACK BOMB A',
  'BLACK BREATH',
  'BLACK CAPRICORN',
  'BLACK COBRA',
  'BLACK COMEDY',
  'BLACK COUNTESS',
  'BLACK CROWN INITIATE',
  'THE BLACK DAHLIA MURDER',
  'BLACK DAWN',
  'BLACK ELEGY',
  'BLACK EVE',
  'BLACK FAST',
  'BLACK FATE',
  'BLACK FLAG',
  'BLACK FUNERAL',
  'BLACK HORIZONZ',
  'BLACK JESTER',
  'BLACK JULY',
  'BLACK LABEL SOCIETY',
  'THE BLACK LEAGUE',
  'BLACK LIGHT BURNS',
  'BLACK LODGE',
  'BLACK MAGIC',
  'BLACK MAJESTY',
  'BLACK MANTRA',
  'BLACK MASS',
  'BLACK MESSIAH',
  'BLACK MY HEART',
  'BLACK OATH',
  'BLACK OMEN',
  'BLACK ORCHID',
  'BLACK PATH',
  'BLACK PYRAMID',
  'BLACK RIVER',
  'A BLACK ROSE BURIAL',
  'BLACK SABBATH',
  'BLACK SEA DELUGE',
  'BLACK SEPTEMBER',
  'BLACK STAR RIDERS',
  'BLACK STEEL',
  'BLACK STONE CHERRY',
  'BLACK SUN AEON',
  'BLACK SWAN',
  'BLACK TIDE',
  'BLACK TONGUE',
  'BLACK TRIP',
  'BLACK TUSK',
  'BLACK VEIL BRIDES',
  'BLACK WARRANT',
  'BLACK WITCHERY',
  'BLACK WREATH',
  'BLACKCROWNED',
  'BLACKDEATH',
  'BLACKEVIL',
  'BLACKFIELD',
  'BLACKGUARD',
  'BLACKLISTED',
  'BLACKMASS',
  "BLACKMORE'S NIGHT",
  'BLACKSHINE',
  'BLACKSTAR',
  'BLACKSTONE',
  'BLACKTHORN',
  'BLACKTHRONE',
  'BLADEFIRE',
  'BLAKK MARKET',
  'BLASFEMIA',
  'BLASPHEME',
  'BLASPHEMER',
  'BLASPHEMY',
  'BLASTRONAUT',
  'BLAZE',
  'BLAZE BAYLEY',
  'BLAZE OF PERDITION',
  'BLAZING ETERNITY',
  'THE BLED',
  'BLEED FROM WITHIN',
  'BLEED THE SKY',
  'BLEEDING GODS',
  'BLEEDING RED',
  'THE BLEEDING SUN',
  'BLEEDING THROUGH',
  'BLESSED AGONY',
  'BLESSED BY A BROKEN HEART',
  'BLESSED DEATH',
  'BLESSED IN SIN',
  'BLESSLESS',
  'BLESS THE FALL',
  'BLIND DOG',
  'BLIND GUARDIAN',
  'BLIND ILLUSION',
  'BLIND MYSELF',
  'BLIND ORACLE',
  'BLIND SAVIOUR',
  'BLIND STARE',
  'BLIND WITNESS',
  'BLINDEAD',
  'BLINDED BY FAITH',
  'BLINDED COLONY',
  'BLINDED IN BLISS',
  'THE BLINDING LIGHT',
  'BLINDSIDE',
  'BLITZKRIEG',
  'BLIZZARD AT SEA',
  'BLOCKHEADS',
  'BLODEN-WEDD',
  'BLODSGARD',
  'BLODSRIT',
  'BLODULV',
  'BLOOD',
  'THE BLOOD BROTHERS',
  'BLOOD CEREMONY',
  'THE BLOOD DIVINE',
  'BLOOD DUSTER',
  'BLOOD FEAST',
  'BLOOD FOR BLOOD',
  'BLOOD FREAK',
  'BLOOD HAS BEEN SHED',
  'BLOOD INCANTATION',
  'BLOOD ISLAND RAIDERS',
  'BLOOD OF THE BLACK OWL',
  'BLOOD OF THE MARTYRS',
  'BLOOD RED THRONE',
  'BLOOD REVOLT',
  'BLOOD STAIN CHILD',
  'BLOOD SUCKERS',
  'BLOOD THIRSTY',
  'BLOOD THIRSTY DEMONS',
  'BLOOD TSUNAMI',
  'BLOODBATH',
  'A BLOODBATH IN BOSTON',
  'BLOODBOUND',
  'BLOODFLOWERZ',
  'BLOODFORGE',
  'BLOODGOD',
  'BLOODGOOD',
  'BLOODHUNTER',
  'BLOODJINN',
  'BLOODLINE',
  'BLOODLINE SEVERED',
  'BLOODLINED CALLIGRAPHY',
  'BLOODPARADE',
  'BLOODRED BACTERIA',
  'BLOODRED HOURGLASS',
  'BLOODSHED',
  'BLOODSHOT DAWN',
  'BLOODSHOTEYE',
  'BLOODSIMPLE',
  'BLOODSOAKED',
  'BLOODTHORN',
  'BLOODTHRONE',
  'BLOODWORK',
  'BLOODY HAMMERS',
  'BLOODY HOLLY AND THE RICKETZ',
  'BLOODY PANDA',
  'BLOODY SADISM',
  'BLOODY SUNDAY',
  'BLOODY UNICORN',
  'BLOODY VESSEL',
  'BLOODY WINGS',
  'BLUDGEON',
  'BLUE CHEER',
  'BLUES PILLS',
  'BLUT AUS NORD',
  'BLUTTAUFE',
  'BOBAFLEX',
  'BODIES IN THE GEARS OF THE APPARATUS',
  'THE BODY',
  'BODY COUNT',
  'BODYFARM',
  'BOGUS BLIMP',
  'BOISSON DIVINE',
  'BOLT THROWER',
  'BON JOVI',
  'BONDED BY BLOOD',
  'BONE GNAWER',
  'BONGZILLA',
  'BOOK OF BLACK EARTH',
  'BORDERLINES',
  'BOREALIS',
  'BOREWORM',
  'BORIS',
  'BORIS THE BLADE',
  'BORKNAGAR',
  'BORN FROM PAIN',
  'BORN HEADLESS',
  'BORN OF OSIRIS',
  'BORN OF SIN',
  'BORN TO SUFFER',
  'BORN WITH OPEN EYES',
  'BORNHOLM',
  'BOSSK',
  'BOTANIST',
  'BOTCH',
  'BOTCHLING',
  'THE BOY WILL DROWN',
  'BRACHIOSAURIDE',
  'BRAIN DRILL',
  'BRAINSTORM',
  'BRAJANGNGANA',
  'BRAN BARR',
  'BRAND OF SACRIFICE',
  'BRAZEN BULL',
  'A BREACH OF SILENCE',
  'BREACH THE VOID',
  'BREAKDOWN OF SANITY',
  'BREAKER',
  'BREAKING BENJAMIN',
  'A BREATH BEFORE SURFACING',
  'THE BREATHING PROCESS',
  'BREATHING STILL',
  'BREED INFECTION',
  'BRETWALDAS OF HEATHEN DOOM',
  'BREZNO',
  'THE BRIDAL PROCESSION',
  'BRIDE',
  'THE BRIDE',
  'BRIDE ADORNED',
  'BRIDES OF DESTRUCTION',
  'BRIDGE TO SOLACE',
  'BRIGHT OPHIDIA',
  'BRIGHTER THAN A THOUSAND SUNS',
  'BRIMSTONE',
  'BRING ME THE HORIZON',
  'BRING OUT BANE',
  'BRINGING DOWN BROADWAY',
  'BRITISH LION',
  'BRITNY FOX',
  'BROADCAST THE NIGHTMARE',
  'BROCAS HELM',
  'BRODEQUIN',
  'THE BRODERICK',
  'BROKEN & BURNT',
  'BROKEN ARROW',
  'BROKEN DOME',
  'BROKEN FLESH',
  'BROKEN HOPE',
  'BROKEN OATH',
  'THE BROKEN RESULT',
  'BROTHER FIRETRIBE',
  'BROTHER VON DOOM',
  'BROTHERS TILL WE DIE',
  'BROTHERS TILL WE DIE',
  'THE BROWNING',
  'BRUCE BANNER',
  'BRUCE DICKINSON',
  'BRUCE SOORD WITH JONAS RENSKE',
  'BRUJERIA',
  "BRUME D'AUTOMNE",
  'BRUTAL TRUTH',
  'BRUTALITY',
  'BRUTALITY WILL PREVAIL',
  'BRUTE CHANT',
  'BRUTUS',
  'BRYMIR',
  'BRÜNNDL',
  'BSTRDCNT',
  'BUCOVINA',
  'BUDDY LACKEY',
  'BUDGIE',
  'BULLDOZER',
  'BULLET',
  'BULLET FOR MY VALENTINE',
  'A BULLET FOR PRETTY BOY',
  'BUN DEM OUT',
  'BUNKUR',
  'THE BUNNY THE BEAR',
  'BURDEN',
  'BURDEN OF A DAY',
  'BURDEN OF GRIEF',
  'BURDEN OF LIFE',
  'BURDEN RAGE',
  'BURGERKILL',
  'THE BURIAL',
  'BURIAL DREAM',
  'BURIAL EARTH',
  'BURIAL VAULT',
  'BURIED ALIVE',
  'BURIED DREAMS',
  'BURIED GOD',
  'BURIED IN OBLIVION',
  'BURIED IN VERONA',
  'BURIED INSIDE',
  'BURN IN SILENCE',
  'BURN IT TO THE GROUND',
  'BURN THE PRIEST',
  'BURN THE WEAK',
  'BURN TO BLACK',
  'THE BURNING',
  'BURNING CIRCLE',
  'BURNING DAYLIGHT',
  'BURNING IN HELL',
  'BURNING INSIDE',
  'BURNING POINT',
  'THE BURNING SEASON',
  'BURNING SKIES',
  'BURNING TEARS',
  'BURNING THE MASSES',
  'BURNING WITCH',
  'BURNING WITCHES',
  'BURNT BY THE SUN',
  'BURST',
  'BURY THE SILENCE',
  'BURY TOMORROW',
  'BURY YOUR DEAD',
  'BURZ',
  'BURZUM',
  'BUTCHER ABC',
  'BUTCHER BABIES',
  'BUTTERFLY TEMPLE',
  'BY BLOOD ALONE',
  'BYFROST',
  'BYWAR',
  'BYZANTINE',
  'BARBARIAN HERMIT',
  'BATTLAXE',
  'BELOW THE SUN',
  'BESHENITAR',
  'BESTIA ARCANA',
  'BLACK FOREST',
  'BORN IN EXILE',
  'BËEHLER',
  'BÖLZER'
];

const metalBandsC = [
  'CALIBRE',
  'CRRUST',
  'CABLE',
  'CACOPHONY',
  'CADACROSS',
  'CADAVER',
  'CADAVERES DE TORTUGAS',
  'CADAVERIA',
  'CADAVEROUS CONDITION',
  'CADAVRA',
  'CADAVRUL',
  'CAEDERE',
  'CAGE',
  "CAIN'S DINASTY",
  "CAIN'S OFFERING",
  'CALADAN BROOD',
  'CALES',
  'CALIBAN',
  "CALIGULA'S HORSE",
  'CALL OF THE VOID',
  'CALL THE MOTHERSHIP',
  'CALL TO PRESERVE',
  'A CALL TO SINCERITY',
  'CALLEJON',
  'CALLENISH CIRCLE',
  'CALLIGRAM',
  'CALLISTO',
  'CALVARIUM',
  'CAMILLA RHODES',
  'CAMULOS',
  'CANAAN',
  'CANCER',
  'CANCER BATS',
  'CANDIRIA',
  'CANDLEGOAT',
  'CANDLEMASS',
  'CANDLES AND WRAITHS',
  'THE CANDLES BURNING BLUE',
  'CANGRENA',
  'CANINUS',
  'CANNABIS CORPSE',
  'CANNAE',
  'CANNIBAL CORPSE',
  'CANNULA',
  'CANOPY',
  'A CANOROUS QUINTET',
  'CANS',
  'CAPHARNAUM',
  'CAPILLA ARDIENTE',
  'CAPITALIST CASUALTIES',
  'CAPITIS DAMNARE',
  'CAPRICORN',
  'CAPSIZE',
  'CAPTAIN CAVEMAN',
  'CAPTURE THE CROWN',
  'CAR BOMB',
  'CARACH ANGREN',
  'CARAVELLUS',
  'CARBONIZED',
  'CARCASS',
  'CARCER CITY',
  'CARCERI',
  'CARDIANT',
  'CARDINAL SIN',
  'CARDIO KAZAN',
  'CARNAC',
  'CARNAL',
  'CARNAL AGONY',
  'CARNAL DECAY',
  'CARNAL FORGE',
  'CARNAL GRIEF',
  'CARNARIUM',
  'CARNATION',
  'CARNIFEX',
  'CARNIFIED',
  'CARNIVAL IN COAL',
  'CARNIVAL OF FLESH',
  'CARNIVORE',
  'CARNOSUS',
  'CARPATHIAN',
  'CARPATHIAN FOREST',
  'CARPATIA',
  'CARPE TENEBRUM',
  'THE CARRIER',
  'CARRIER FLUX',
  'CARTHAGODS',
  'CARTOGRAPHS',
  'CASEY',
  'CASEY JONES',
  'CASKET OF CASSANDRA',
  'CASKETGARDEN',
  'CAST IRON HIKE',
  'CASTLE',
  'CASTLE OF CLOUDS',
  'CASTRUM',
  'CASUALTIES OF COOL',
  'CASUS BELLI',
  'CATAFALQUE',
  'CATALEPSY',
  'CATAMENIA',
  'CATARACT',
  'CATASEXUAL URGE MOTIVATION',
  'CATASTROPHIC',
  'CATCH THE SUN',
  'CATHARSIS',
  'CATHARSIS THEORY',
  'CATHEDRAL',
  'CATHERINE',
  'CATTLE DECAPITATION',
  'CAULDRON',
  'CAULDRON BORN',
  'CAUSAM',
  'CAVALERA CONSPIRACY',
  'CAVE IN',
  'CAVE STATE',
  'CEA SERIN',
  'CEASE OF BREEDING',
  'CELESTE',
  'CELESTIAL CROWN',
  'CELESTIAL GRAVE',
  'CELESTIAL SEASON',
  'CELESTY',
  'CELLADOR',
  'CELLAR DARLING',
  'CELLAR TWINS',
  'CELLDWELLER',
  'CELTACHOR',
  'CELTIBEERIAN',
  'CELTIC FROST',
  'CELÉNE',
  'CEM KÖKSAL',
  'CEMETARY',
  'CEMETERIUM',
  'CEMETERY OF SCREAM',
  'CENOTAPH',
  'CENTIMANI',
  'CENTINELA',
  'CENTINEX',
  'CENTURIAN',
  'THE CENTURIES',
  'CENTURIES APART',
  'CENTURION',
  'CENTURIONS GHOST',
  'CENTURY',
  'CEPHALECTOMY',
  'CEPHALIC CARNAGE',
  'CEPHALOTRIPSY',
  'CERBER',
  'CEREBRAL BORE',
  'CEREBRAL EFFUSION',
  'CEREBRAL FIX',
  'CEREBRAL TURBULENCY',
  'CEREMONIAL CASTINGS',
  'CEREMONIAL OATH',
  'CEREMONY',
  'CEREMONY OF OPPOSITES',
  'CERNUNNOS',
  'CETI',
  "CH'ASKA",
  'CHAIN',
  'CHAIN COLLECTOR',
  'CHAINSAW PENIS',
  'CHAKAL',
  'CHALICE OF DOOM',
  'CHAMBER OF HORRORS',
  'CHANNEL ZERO',
  'CHAOS',
  'CHAOS BEYOND',
  'CHAOS DIVINE',
  'CHAOS INVOCATION',
  'CHAOSBREED',
  'CHAOSIUM',
  'CHAOSNERVE',
  'CHAOSTAR',
  'CHAOTIC DREAD',
  'CHAOTICA',
  'CHAPTER BLACK',
  'THE CHARIOT',
  'CHARLATAN',
  'THE CHARM THE FURY',
  'CHARME',
  'CHARNEL WINDS',
  'CHARON',
  'CHARRED WALLS OF THE DAMNED',
  'CHASING SAFETY',
  'THE CHASM',
  'CHASTAIN',
  'CHASTISEMENT',
  'CHELSEA GRIN',
  'CHEMIC',
  'CHEMICIDE',
  'CHEVELLE',
  'CHILDERMASS',
  'CHILDREN OF BODOM',
  'CHIMAIRA',
  'CHINCHILLA',
  'CHIODOS',
  'CHOICES',
  'CHOIR',
  'CHOKING VICTIM',
  'CHORDEWA',
  'CHORUS OF RUIN',
  'CHRIS CAFFERY',
  'CHROMA KEY',
  'CHROME DIVISION',
  'CHROMING ROSE',
  'CHROMIUM',
  'THE CHRONICLES PROJECT',
  'CHRONIX REVOLT',
  'CHRONOFORM',
  'CHRONOLOGY',
  'CHRONOLYTH',
  'CHRONOMANCY',
  'CHRONUS',
  'CHTHONIC',
  'CHUGGER',
  'CHUNK NO, CAPTAIN CHUNK',
  'CHURCH OF MISERY',
  'CIANIDE',
  'CIDESPHERE',
  'CIMMERIAN PATH',
  'CINDERELLA',
  'CINEMA STRANGE',
  'CIPHER SYSTEM',
  'CIRCAIC',
  'CIRCLE II CIRCLE',
  'CIRCLE OF CONTEMPT',
  'CIRCLE OF DEAD CHILDREN',
  'CIRCLE OF DEATH',
  'CIRCLE OF GRIEF',
  'CIRCLE OF OUROBORUS',
  'CIRCLE OF VIOLENCE',
  'CIRCLE TAKES THE SQUARE',
  'CIRCLES',
  'CIRCUS MAXIMUS',
  'CIRCUS OF DEAD SQUIRRELS',
  'CIRITH GORGOR',
  'CIRITH UNGOL',
  'CITIES OF DESOLATION',
  'CITIZENS ARREST',
  'CITY IN THE SEA',
  'CITY OF FIRE',
  'CIVIL WAR',
  'CIVILIZATION ONE',
  'CKY',
  'THE CLAN DESTINED',
  'CLANDESTINE',
  'CLANDESTINE BLAZE',
  'CLAUSTROFOBIA',
  'CLAWFINGER',
  'CLAWS',
  'CLAYMORE',
  'THE CLAYMORE',
  'CLAYMOREAN',
  'CLEARER THE SKY',
  'CLEMENCY',
  'CLIFTON',
  'CLIMATE CONTROL',
  'CLINGING TO THE TREES OF A FOREST FIRE',
  'CLIT RIPPER',
  'CLITEATER',
  'CLOAK',
  'CLOAKROOM',
  'CLOSE YOUR EYES',
  'CLOUD RAT',
  'CLOUDS',
  'CLOUDSCAPE',
  'CLOVEN HOOF',
  'CLUTCH',
  'CLUTTER',
  'COAL CHAMBER',
  'COALESCE',
  'COALFIELD',
  'COAT OF ARMS',
  'COBALT',
  'COBALTO',
  'COCK AND BALL TORTURE',
  'CODE',
  'CODE ORANGE',
  'CODE ORANGE KIDS',
  'CODEINE KING',
  'COERCION',
  'COFFINS',
  'COFFINWORM',
  'COHEED AND CAMBRIA',
  'COJONES',
  'COLD',
  'COLD NORTHERN VENGEANCE',
  'COLDBOUND',
  'COLDBURN',
  'COLDNESS',
  'COLDSEED',
  'COLDWORKER',
  'COLDWORLD',
  'COLONIZE THE ROTTING',
  'THE COLOR MORALE',
  'THE COLOR OF VIOLENCE',
  'COLOSSAL',
  'COLOSSEUM',
  'COLOSSUS',
  'COMA ETERNAL',
  'COMADRE',
  'COMANDO NUCLEAR',
  'COMANIAC',
  'COMATOSE VIGIL',
  'COME THE DAWN',
  'COMEBACK KID',
  'COMECON',
  'THE COMMITTEE',
  'COMMON CHOIR',
  'COMMON DEAD',
  'COMMON WAR',
  'COMMUNIC',
  'COMPOS MENTIS',
  'CONAN',
  'CONCEPT OF GOD',
  'CONCEPTION',
  'CONCEPTS',
  'CONCRETE',
  'CONCRETE SUN',
  'THE CONCUBINE',
  'CONDEMNED',
  'CONDEMNED CELL',
  'CONDITION RED',
  'CONDUCTING FROM THE GRAVE',
  'CONE OF SILENCE',
  'CONFESSION',
  'CONFESSIONS OF OBSCURITY',
  'CONFESSOR',
  'CONFIDE',
  'CONFLIGO',
  'CONNATE EXASPERATION',
  'CONQUER DIVIDE',
  'CONQUEST',
  'CONSOLATION',
  'THE CONSPIRACY',
  'CONSPIRANOIA',
  'CONSPIRE',
  'A CONSTANT STORM',
  'CONSTRUCDEAD',
  'CONSTRUCT',
  'CONSTRUCT OF LETHE',
  'CONSUMMATUM EST',
  'CONTINENT',
  'CONTINENTS',
  'THE CONTORTIONIST',
  'CONTRADICTION',
  'CONTROL DENIED',
  'CONTUSIO',
  'CONVERGE',
  'CONVEYER',
  'CONVULSE',
  'CONVULSING',
  'COR SCORPII',
  'CORAM LETHE',
  'CORE SYSTEM',
  'CORELIA',
  'CORMORANT',
  'CORN ON MACABRE',
  'CORNUCOPIA',
  'CORONATUS',
  'CORONER',
  'CORPORATE AVENGER',
  'CORPSE',
  'CORPSEFUCKING ART',
  'CORPSEPAIN',
  'CORPUS OMNI DOMINI',
  'CORROSION OF CONFORMITY',
  'CORRUPTED',
  'CORRUPTUS',
  'CORTEXIPHAN',
  'CORVUS CORAX',
  'THE COSA NOSTRA KLUB',
  'COUGH',
  'COUNT NOSFERATU KOMMANDO',
  'COUNT RAVEN',
  'COUNTDOWN TO ARMAGEDDON',
  'COUNTDOWN TO LIFE',
  'COUNTERPARTS',
  'COUNTESS',
  'THE COUNTY MEDICAL EXAMINERS',
  'COURAGEOUS',
  'COVEN',
  'COVEN',
  'COVENANT',
  'COVER YOUR TRACKS',
  'CRACK JAW',
  'CRACK UP',
  'CRADLE OF FILTH',
  'CRAFT',
  'CRAFTER',
  'CRANELY GARDENS',
  'CRANIUM',
  'CRANIUMBLAST',
  'CRASHDÏET',
  'CRASHED SOULS',
  'CRAWLER',
  'CREATION IS CRUCIFIXION',
  "CREATION'S TEARS",
  'CREATIONS',
  'CREED',
  'CREEPMIME',
  'CREMATORIUM',
  'CREMATORY',
  'CRESCENT SHIELD',
  'THE CREST',
  'CREST OF DARKNESS',
  'CRIMFALL',
  'CRIMINAL',
  'THE CRIMSON ARMADA',
  'CRIMSON FALLS',
  'CRIMSON GLORY',
  'CRIMSON MASSACRE',
  'CRIMSON MOON',
  'CRIMSON MOONLIGHT',
  'CRIMSON RIVERS',
  'CRIMSON SHADOWS',
  'CRIMSON SUN',
  'CRIMSON THORN',
  'CRIMSONFIRE',
  'CRIONICS',
  'CRIPPER',
  'CRIPPLE BASTARDS',
  'CRIPTOFONIA',
  'CRISIS',
  'CRISIX',
  'CRO-MAGS',
  'CROCELL',
  'CROM',
  'CROMM CRUAC',
  'CRONIAN',
  'CRONOS',
  'CROOKS',
  'CROSS',
  'CROSSBREED',
  'CROSSED HANDS',
  'CROSSED OUT',
  'CROSSFADE',
  'CROSSFAITH',
  'CROSSFIRE',
  'CROSSOVER',
  'CROSSWIND',
  'CROTCHDUSTER',
  'CROW BLACK SKY',
  'CROWBAR',
  'THE CROWN',
  'CROWN OF AUTUMN',
  'CROWN OF GLORY',
  'CROWN OF THORNS',
  'CROWN THE EMPIRE',
  'CROWORD',
  'CRUACHAN',
  'THE CRUCIFIED',
  'CRUCIFIED BARBARA',
  'CRUEL FORCE',
  'CRUEL HAND',
  'CRUMBSUCKERS',
  'CRUSADER',
  'CRUSH',
  'CRUSHEM',
  'CRUTCH',
  'CRUX CAELIFERA',
  'CRYFEMAL',
  'CRYHAVOC',
  'CRYONIC TEMPLE',
  'CRYPT OF KERBEROS',
  'CRYPTAL DARKNESS',
  'CRYPTHOWL',
  'CRYPTIC CARNAGE',
  'CRYPTIC CROWN',
  'CRYPTIC SLAUGHTER',
  'CRYPTIC VAMPIRE',
  'CRYPTIC WARNING',
  'CRYPTIC WINTERMOON',
  'CRYPTOPSY',
  'CRYSALYS',
  'CRYSTAL ABYSS',
  'CRYSTAL BALL',
  'CRYSTAL CASTLE',
  'CRYSTAL EYES',
  'CRYSTAL FAIRY',
  'CRYSTAL TEARS',
  'CRYSTAL VIPER',
  'CRYSTALIC',
  'CRYSTALIUM',
  'CRYSTALLION',
  'THE CULT',
  'CULT LEADER',
  'CULT OF LUNA',
  'CULT OF OCCULT',
  'CULTES DES GHOULES',
  'CULTURE KILLER',
  'CULTUS SANGUINE',
  'CUMDEO',
  'THE CUMSHOTS',
  'CUNABULA',
  'THE CURE',
  'CURL UP AND DIE',
  'CURRENTS',
  'CURSED',
  'THE CURSED',
  'CUSTARD',
  'CUT UP',
  'CUTLIESTHROAT',
  'CYCLONE TEMPLE',
  'CYCO MIKO',
  'CYDONIA',
  'CYHRA',
  'CYNIC',
  'CYNICIST',
  'CYNTHESIS',
  'CYPECORE',
  'CYPHILIS',
  'CYPHONISM',
  'CYRAX',
  'CYSTED',
  'CYTOKINE',
  'CYTOTOXIN',
  'CHIRAW',
  'CONJURER',
  'COUNTLESS SKIES',
  'CRASH SYNDROM'
];

const metalBandsD = [
  'DAAT',
  'DAEDALUS',
  'DAEDALVS',
  'DAEMONARCH',
  'DAEMONICIUM',
  'DAEMONLORD',
  'DAGOBA',
  'DAGON',
  'DAGORLAD',
  'DAKRUA',
  'DAKRYA',
  'THE DALI THUNDERING CONCEPT',
  "DALI'S DILEMMA",
  'DALIT',
  'DALRIADA',
  'DAM',
  'DAMAGE',
  'DAMAGED',
  'DAMAGEPLAN',
  'DAMN THE MACHINE',
  'DAMNABLE',
  'DAMNATION',
  'DAMNATION AD',
  'DAMNATION ANGELS',
  'DAMNATION PLAN',
  'DAMNATIONS HAMMER',
  'THE DAMNED THINGS',
  'DAN SWANO',
  'DANCE AT THE CHAPEL HORRORS',
  'DANCE CLUB MASSACRE',
  'DANCE GAVIN DANCE',
  'DANGERKIDS',
  'DANGERS',
  'DANIELE LIVERANI',
  'DANSE MACABRE',
  'DANTALIAN',
  'DANTESCO',
  'DANZIG',
  'DARGAARD',
  'DARGORON',
  'DARK',
  'DARK AGE',
  'DARK ANGEL',
  'DARK APOTHEOSIS',
  'DARK AT DAWN',
  'DARK AVENGER',
  'DARK CASTLE',
  'DARK COVENANT',
  'THE DARK ELEMENT',
  'DARK EMBRACE',
  'DARK EMPIRE',
  'DARK FLOOD',
  'DARK FOREST',
  'DARK FORTRESS',
  'DARK FUNERAL',
  'DARK HALF',
  'DARK HORIZON',
  'DARK LEGACY',
  'DARK LUNACY',
  'DARK MATTER',
  'DARK MILLENNIUM',
  'DARK MIRROR OV TRAGEDY',
  'DARK MOOR',
  'DARK OPERA',
  'A DARK ORBIT',
  'DARK ORDER',
  'DARK PHILOSOPHY',
  'DARK PRINCESS',
  'DARK QUARTERER',
  'DARK REALITY',
  'DARK SANCTUARY',
  'DARK SARAH',
  'DARK SERMON',
  'DARK SERPENT',
  'DARK SUNS',
  'DARK THE SUNS',
  'DARK TRANQUILLITY',
  'DARKANE',
  'DARKCROWN',
  'DARKEND',
  'DARKENED NOCTURN SLAUGHTERCULT',
  'DARKER BY DESIGN',
  'DARKER HALF',
  'DARKEST ERA',
  'DARKEST HOUR',
  'DARKESTRAH',
  'DARKFLIGHT',
  'DARKHER',
  'DARKIFIED',
  'DARKLANDS',
  'DARKLORD',
  'DARKMOON',
  'DARKNESS',
  'THE DARKNESS',
  'DARKNESS DIVIDED',
  'DARKNESS DYNAMITE',
  'DARKNESS REMAINS',
  'DARKNESS SHALL RISE',
  'DARKOLOGY',
  'DARKSEED',
  'DARKSIDE',
  'DARKSIDE OF INNOCENCE',
  'DARKSPACE',
  'DARKSUN',
  'DARKTHRONE',
  'DARKWATER',
  'DARKWELL',
  'DARKWOODS MY BETROTHED',
  'DARNA',
  'DARWIN',
  'DARZAMAT',
  'DAS ICH',
  'DAUDEN I MØRKE',
  'DAUGHTERS',
  'DAUNTLESS',
  'DAVE VAN DETTA',
  'DAVID SHANKLE GROUP',
  'DAWN',
  'DAWN OF A DARK AGE',
  'DAWN OF ASHES',
  'DAWN OF AZAZEL',
  'DAWN OF DEMISE',
  'DAWN OF DESTINY',
  'DAWN OF DISEASE',
  'DAWN OF DREAMS',
  'DAWN OF LEVIATHAN',
  'DAWN OF OBLIVION',
  'DAWN OF RELIC',
  'DAWN OF SILENCE',
  'DAWN OF SOLACE',
  'DAWN OF TEARS',
  'DAWN OF WINTER',
  'DAWN PATROL',
  'DAWN UNDER ECLIPSE',
  'DAWNBRINGER',
  'DAWNLESS',
  'DAWNRIDER',
  'DAX RIGGS',
  'THE DAY IS OURS',
  'DAY OF CONTEMPT',
  'DAY OF MOURNING',
  'A DAY TO REMEMBER',
  'THE DAY WILL COME',
  'DAYDREAM XI',
  'THE DAYLIGHT CURSE',
  'DAYLIGHT DIES',
  'DAYLIGHT MISERY',
  'DAYSEND',
  'DAZZLE VISION',
  'DC COOPER',
  'DE INFERNALI',
  "DE LIRIUM'S ORDER",
  'DE PROFVNDIS CLAMATI',
  'DEAD',
  'DEAD AND DIVINE',
  'DEAD BLUE SKY',
  'DEAD BY APRIL',
  'DEAD BY TOMORROW',
  'DEAD CITY WALKER',
  'DEAD CONGREGATION',
  'DEAD CROSS',
  'DEAD EARTH POLITICS',
  'DEAD EMOTIONS',
  'DEAD END FINLAND',
  'DEAD HORSE',
  'DEAD IN THE DIRT',
  'DEAD INFECTION',
  'DEAD KENNEDYS',
  'DEAD MAN IN RENO',
  'DEAD MARCH',
  'DEAD MIND',
  'DEAD NATURE',
  'THE DEAD RABBITTS',
  'DEAD SAMARITAN',
  'DEAD SILENCE HIDES MY CRIES',
  'DEAD SILENT SLUMBER',
  'DEAD SOUL TRIBE',
  'DEAD TEARS',
  'DEAD TO A DYING WORLD',
  'DEAD TO FALL',
  'DEAD TO THIS WORLD',
  'DEAD WAKE',
  'DEAD WORLD',
  'THE DEAD YOUTH',
  'DEADBOY AND THE ELEPHANTMEN',
  'DEADLOCK',
  'DEADMARSH',
  'DEADSOIL',
  'DEADSQUAD',
  'DEADSTAR ASSEMBLY',
  'DEADSY',
  'DEADWATER DROWNING',
  'DEAFHEAVEN',
  'DEALEY PLAZA',
  'DEALS DEATH',
  'DEARLY BEHEADED',
  'DEATH',
  'DEATH ANGEL',
  'DEATH BECOMES HER',
  'DEATH BEFORE DISHONOR',
  'DEATH BREATH',
  'DEATH DEALER',
  'DEATH DESTRUCTION',
  'DEATH DU JOUR',
  'DEATH OF AN ERA',
  'DEATH OF MILLIONS',
  'DEATH RAY VISION',
  'DEATH REALITY',
  'DEATH REQUISITE',
  'DEATH SS',
  'DEATH STRIKE',
  'DEATH THERAPY',
  'DEATH THREAT',
  'DEATH VOMIT',
  'DEATHBOUND',
  'DEATHBRINGER',
  'DEATHCHAIN',
  'DEATHHAMMER',
  'THE DEATHISODES',
  'DEATHKIN',
  'DEATHLIKE SILENCE',
  'DEATHMARCH',
  'DEATHRAISER',
  'DEATHRITE',
  'DEATHROW',
  'DEATHSPELL OMEGA',
  'DEATHSTARS',
  'DEATHWISH',
  'DEATHWITCH',
  'DEATHWORK',
  'DEBASE',
  'DEBAUCHERY',
  'DECADENCE',
  'DECADES OF DESPAIR',
  'DECAMERON',
  'DECAPITATED',
  'DECAY',
  'DECAYING',
  'DECEASE',
  'DECEASED',
  'DECEIVER',
  'DECEMBER',
  'DECEMBER FLOWER',
  'DECEMBER MOON',
  'DECEMBER WOLVES',
  "DECEMBER'S COLD WINTER",
  "DECEMBER'S FIRE",
  'DECEMBERANCE',
  'DECEPTIC',
  'DECEPTION OF A GHOST',
  'DECEPTIONIST',
  'DECEPTIVE',
  'DECIMATION',
  'DECIMATOR',
  'DECISION-D',
  'DECONTROLLED',
  'DECORYAH',
  'DECREPIT BIRTH',
  'DECRYPT',
  'DEEDS OF FLESH',
  'DEEP ODIUM',
  'DEEP PURPLE',
  'DEEZ NUTS',
  'DEF LEPPARD',
  'THE DEFACED',
  'DEFDUMP',
  'DEFEATED SANITY',
  'DEFEATER',
  'DEFECATION',
  'DEFENESTRATION',
  'DEFIANCE',
  'THE DEFILED',
  'DEFILER',
  'DEFLESHED',
  'DEFTONES',
  'DEGOTTEN',
  'DEGRADE',
  'DEGRADEAD',
  'DEHUMANATION',
  'DEHYDRATED',
  'DEICIDE',
  'DEIFECATION',
  'DEIMOS',
  'DEIN-SCHATTEN',
  'DEINONYCHUS',
  'DEKADENT',
  'DEKAPITATOR',
  'DELAIN',
  'DELICATE NEWS',
  'DELIGHT',
  'DELIRION',
  'DELIRIOUS',
  'DELIRIUM',
  'DELIRIUM X TREMENS',
  'DELIVERANCE',
  'DELORIAN',
  'DELTA',
  'DELTA ENIGMA',
  'DELUSIONS',
  'DELUSIONS OF GODHOOD',
  'DELUSIONS OF GRANDEUR',
  'DELUSIVE',
  'DEMENTED HEART',
  'DEMENTED TED',
  'DEMENTOR',
  'DEMENTRA',
  'DEMETHER',
  'DEMIANS',
  'DEMIGOD',
  'DEMILICH',
  'DEMIRICOUS',
  'DEMISE',
  'DEMISE OF AN ERA',
  'DEMISED',
  'DEMIST',
  'DEMIURG',
  'DEMOLITION HAMMER',
  'DEMON',
  'DEMON ANGELS',
  'DEMON CHILD',
  'DEMON HUNTER',
  'DEMON LUNG',
  'DEMON REALM',
  'DEMONAZ',
  'DEMONCY',
  'DEMONIAC',
  'DEMONIC',
  'DEMONIC RESURRECTION',
  'DEMONIC-EYED',
  'DEMONICA',
  'DEMONICAL',
  'DEMONICIDUTH',
  'DEMONLORD',
  'DEMONOID',
  'DEMONS & WIZARDS',
  'DEMONS OF GUILLOTINE',
  'DEMONSTEALER',
  'THE DEMONSTRATION',
  'DEMONTHOR',
  'DENIAL FIEND',
  'DENIAL MACHINE',
  'DEODIUM',
  'DEPRAVITY',
  'DEPRESSED MODE',
  'DEPRESSIVE AGE',
  'DEPRESSIVE REALITY',
  'DEPRESY',
  'DEPRIVE',
  'DEPTHS',
  'DEPTHS OF HATRED',
  'DEPTHS OF KRONOS',
  'DER WEG EINER FREIHEIT',
  'DERANGED',
  'DERDIAN',
  'DERIDE',
  'DESASTER',
  'DESCEND INTO NOTHINGNESS',
  'DESCENDING',
  'DESCENERY',
  'DESDEMONA',
  'DESDEMONIA',
  'DESECRATION OF SANCTITUDE',
  'DESECRATOR',
  'DESENSITISED',
  'DESERT',
  'DESERTED FEAR',
  'DESERTERS',
  'DESIGN THE SKYLINE',
  'DESIRE',
  'DESOLATED',
  'DESOLATOR',
  'DESPAIR',
  'DESPERADO',
  'DESPERADOS',
  'DESPICABLE HEROES',
  'DESPISE YOU',
  'DESPISED ICON',
  'DESPISING AGE',
  'DESPITE EXILE',
  'DESPITE MY DEEPEST FEAR',
  'DESPOND WOMB',
  'DESTILLERY',
  'DESTINITY',
  'DESTINY',
  'DESTINY POTATO',
  "DESTINY'S END",
  'DESTRAGE',
  'THE DESTRO',
  'DESTROY DESTROY DESTROY',
  'DESTROY REBUILD UNTIL GOD SHOWS',
  'DESTROY THE ADVERSARY',
  'DESTROY THE COLOSSUS',
  'DESTROY THE RUNNER',
  'DESTRUCTION',
  'DESTRUCTION OF A KING',
  'DESTRUCTION OF A ROSE',
  'DESTRUCTOR',
  'DESULTOR',
  'DESULTORY',
  'DETERIORATE',
  'DETERIOROT',
  'DETHKLOK',
  'DETHLEHEM',
  'DETHRONED IN RUINS',
  'DETONATION',
  'DETRITUS',
  'DEUS',
  'DEUS INVICTUS',
  'DEUTERONOMIUM',
  'DEVANATION',
  'DEVAST',
  'THE DEVASTATED',
  'DEVASTATING ENEMY',
  'DEVASTATION',
  'THE DEVASTATOR',
  'DEVIAN',
  'DEVIANT',
  'DEVIATE DAMAEN',
  'DEVIATED PRESENCE',
  'DEVICE',
  'DEVIL ATE MY SON',
  'DEVIL DOLL',
  'DEVIL SOLD HIS SOUL',
  'THE DEVIL WEARS PRADA',
  'DEVIL YOU KNOW',
  "THE DEVIL'S BLOOD",
  'DEVILDRIVER',
  'DEVILISH IMPRESSIONS',
  'DEVILMENT',
  'DEVILYN',
  'DEVIN TOWNSEND',
  'DEVISER',
  'DEVLIN',
  'DEVOID',
  'DEVOLVED',
  'DEVOURMENT',
  'DEW-SCENTED',
  'DEZPERADOZ',
  'DGM',
  'DHARMA',
  'DIABLERIE',
  'DIABLERY',
  'DIABLO',
  'DIABLO SWING ORCHESTRA',
  'DIABOLIC',
  'DIABOLICAL',
  'DIABOLICAL BREED',
  'DIABOLICAL MASQUERADE',
  'DIABOLICUM',
  'DIABOLIQUE',
  'DIABOLOS RISING',
  'DIABULUS IN MUSICA',
  'DIAGNOSTICO FINAL',
  'DIAMOND HEAD',
  'DIAMOND PLATE',
  'DIAMOND SKY',
  'DIARY OF DREAMS',
  'DIATHRA',
  'DIBBUKIM',
  'DIE',
  'DIE APOKALYPTISCHEN REITER',
  'DIE HARD',
  'DIE VERBANNTEN KINDER EVAS',
  'DIECAST',
  'DIES ATER',
  'DIES IRAE',
  'DIESEL MACHINE',
  'A DIFFERENT BREED OF KILLER',
  'DIGITAL RUIN',
  'DIGNITY',
  'DILIGENT',
  'DILLINGER ESCAPE PLAN',
  'DILUVIUM',
  'DIM MAK',
  'DIMENSION',
  'DIMENSION SEVEN',
  'DIMENSION ZERO',
  'DIMHYMN',
  'DIMINISHED',
  'DIMMI ARGUS',
  'DIMMU BORGIR',
  'DIMNESS THROUGH INFINITY',
  'DIN-ADDICT',
  'DIO',
  'DIOCLETIAN',
  'DIONYSUS',
  'DIR EN GREY',
  'DIRGE',
  'DIRGE WITHIN',
  'DIRTY TRASHROAD',
  'DIS PATER',
  'DISAFFECTED',
  'DISARMONIA MUNDI',
  'DISARRAY',
  'DISASTER KFW',
  'DISAVOWED',
  'DISBELIEF',
  'DISCHANGE',
  'DISCHARGE',
  'DISCHORDIA',
  'DISCIPLE',
  'DISCREATION',
  'DISEMBOWELMENT',
  'DISENGAGED',
  'DISENTOMB',
  'DISFEAR',
  'DISFIGUREMENT',
  'DISFIGURING THE GODDESS',
  'DISGORGE',
  'DISGRACE',
  'DISHARMONIC ORCHESTRA',
  'DISHONOUR THE CROWN',
  'DISILLUSION',
  'DISINCARNATE',
  'DISKREET',
  'DISMA',
  'DISMAL EUPHONY',
  'DISMEMBER',
  'DISPATCHED',
  'DISPERSE',
  'DISPHORIA',
  'DISREGARD',
  'DISRUPT',
  'DISSECTION',
  'DISSENSION',
  'DISSIMULATION',
  'DISSIMULATOR',
  'DISSOLVING OF PRODIGY',
  'DISSONANCE IN DESIGN',
  'DISSONANT',
  'THE DISTANCE',
  'DISTANT',
  'DISTANT THUNDER',
  'DISTORIAM',
  'DISTORTED',
  'DISTORTED HARMONY',
  'DISTORTED MIND',
  'DISTURBED',
  'DITCHWATER',
  'DIVERCIA',
  'DIVERGENT',
  'DIVIDED',
  'DIVIDING THE MASSES',
  'DIVINA ENEMA',
  'DIVINA INFERIS',
  'DIVINE ASCENSION',
  'DIVINE EMPIRE',
  'DIVINE HERESY',
  'DIVINE INTERVENTION',
  'DIVINE LUST',
  'DIVINE REGALE',
  'DIVINE SIN',
  'DIVINE SOULS',
  'DIVINE SYNDROME',
  'DIVINE WEEP',
  'DIVINEFIRE',
  'DIVINER',
  'DIVINITY',
  'DIVINITY DESTROYED',
  'DIVINUMX',
  'DIVISION BY ZERO',
  'DIVISION OF MIND',
  'DIZORDER',
  'DJERV',
  'DJEVELKULT',
  'DO OR DIE',
  'DOCTOR BUTCHER',
  'DODECAHEDRON',
  'DODGE',
  "DODGIN' BULLETS",
  'DOFKA',
  'DOG EAT DOG',
  'DOG FASHION DISCO',
  'DOG HEAD',
  'THE DOGMA',
  'DOKKEN',
  'DOL AMMAD',
  'DOLORIAN',
  'DOMAIN',
  'DOMINATION',
  'DOMINATION BLACK',
  'DOMINATION THROUGH IMPURITY',
  'DOMINATOR ET SANCTUM',
  'DOMINE',
  'DOMINIA',
  'DOMINICI',
  'DOMINION',
  'DOMINION III',
  'DOMINIUM',
  'DOMINUS',
  'DOMINUS DOMINANTIUM',
  'DOMINUS NOX',
  'DOMINUS PRAELII',
  "DON'T GIVE A FUCK",
  'DOOM',
  'DOOMED',
  'DOOMED AND DISGUSTING',
  'DOOMRIDERS',
  'THE DOOMSDAY KINGDOM',
  'DOOMSWORD',
  'DOPE',
  'DOPETHRONE',
  'DORDEDUH',
  "DORIAN'S DECAY",
  'DORMANT CARNIVORE',
  'DORMANT ORDEAL',
  'DORN',
  'DORNENREICH',
  'DORO',
  'DOROTHY POLONIUM',
  'DORSAL ATLÂNTICA',
  'DORSO',
  'DOUBLE CHAMBER',
  'DOWN',
  'DOWN & DIRTY',
  'DOWN I GO',
  'DOWN ROYALE',
  'DOWN THE DRAIN',
  'DOWN TO HELL',
  'THE DOWN TRODDENCE',
  'DOWNER',
  'DOWNFALL',
  'DOWNFALL OF GAIA',
  'DOWNLORD',
  'DOWNPRESSER',
  'DOWNSET',
  'DOWNTHESUN',
  'A DOZEN FURIES',
  'DOZER',
  'DRACONIAN',
  'DRACONIS',
  'DRAGGED INTO SUNLIGHT',
  'DRAGON',
  'DRAGONFLY',
  'DRAGONFORCE',
  'DRAGONHAMMER',
  'DRAGONHEART',
  'DRAGONLAND',
  'DRAGONLORD',
  'DRAGONSCLAW',
  'DRAIN STH',
  'DRAIZE',
  'DRAKKAR',
  'DRAKKARA',
  'DRAMA',
  'DRAMATVM',
  'DRAMMAGOTHICA',
  'DRASTIC',
  'DRASTIQUE',
  'DRAWN AND QUARTERED',
  'DRAXSEN',
  'DREAD SOVEREIGN',
  'DREADFUL SHADOWS',
  'DREAM CHILD',
  'DREAM DEATH',
  'DREAM EVIL',
  'DREAM OF LIBERTY',
  'A DREAM OF POE',
  'DREAM ON, DREAMER',
  'DREAM THEATER',
  'DREAMAKER',
  'DREAMGRAVE',
  'DREAMING DEAD',
  'DREAMING MADMEN',
  'DREAMLAND',
  'DREAMLIKE HORROR',
  'DREAMLORE',
  'DREAMS AFTER DEATH',
  'DREAMS IN DARKNESS',
  'DREAMS OF DAMNATION',
  'DREAMS OF SANITY',
  'DREAMSCAPE',
  'DREAMSCAPES OF THE PERVERSE',
  'DREAMSFEAR',
  'DREAMSHADE',
  'DREAMTALE',
  'DREARYLANDS',
  'DREDG',
  'DREMENUART',
  'DRESCHER',
  "DREWSIF STALIN'S MUSICAL ENDEAVORS",
  'DRIFTED',
  'DRIFTER',
  'DRILL LIGHTS',
  'DRILLER KILLER',
  'DRIVEN MACHINE',
  'DROID',
  'DRONE',
  'DROP DEAD, GORGEOUS',
  'DROPBEARS',
  'DROPKICK MURPHYS',
  'DROTTNAR',
  'DROUTH',
  'DROWN',
  'DROWN MY DAY',
  'DROWNED',
  'DROWNING POOL',
  'DROWNING THE LIGHT',
  'DROWNINGMAN',
  'DRUDKH',
  'DRUNKARD',
  'DRUUN',
  'DRY CELL',
  'DRY KILL LOGIC',
  'DRÅPSNATT',
  'DUB BUK',
  'DULCAMARA',
  'DUNDERBEIST',
  'DUNGEON',
  'DUNKELGRAFEN',
  'DUSK',
  'THE DUSKFALL',
  'DUST BOLT',
  'DUST TO DUST',
  'DVNE',
  'DWELLER',
  'DYECREST',
  'DYING BREED',
  'DYING FETUS',
  'DYING PASSION',
  'DYING SILENCE',
  'DYING TEARS',
  'DYING WISH',
  'DYLATH-LEEN',
  'DYNABYTE',
  'DYNAHEAD',
  'DYNAZTY',
  'DYSCARNATE',
  'DYSLESIA',
  'DYSPHORIA',
  'DYSTOPIA',
  'DEAD EYES ALWAYS DREAMING',
  'DEATHWHITE',
  'DEMIURGON',
  'DESCARNADO',
  'DESECRAVITY',
  'DEVILPRIEST',
  'DEVOURING STAR',
  'DYING KINGDOM',
  'DÅÅTH',
  'DÉCEMBRE NOIR',
  'DÉTENTE',
  'DØDHEIMSGARD',
  'DØDSENGEL',
  'DEMOTIONAL'
];

const metalBandsE = [
  'E-TOWN CONCRETE',
  'EAR BLEEDING DISORDER',
  'AN EARLY CASCADE',
  'AN EARLY ENDING',
  'EARLY GRAVES',
  'EARTH',
  'EARTH AND PILLARS',
  'EARTH CRISIS',
  'EARTH FROM ABOVE',
  'EARTHCORPSE',
  'EARTHRIDE',
  'EASE OF DISGUST',
  'EAST OF THE WALL',
  'EASY RIDER',
  'EAT A HELICOPTER',
  'EBONCROWN',
  'EBONY ARK',
  'EBONY LAKE',
  'EBONY TEARS',
  'ECHIDNA',
  'ECHOES OF ETERNITY',
  'ECHOTERRA',
  'ECLIPSE',
  'ECLIPSE ETERNAL',
  'ECLIPSE OF THE SUN',
  'ECLIPTICA',
  'ECNEPHIAS',
  'ECTHIRION',
  'ED GEIN',
  'EDDY ANTONINI',
  'EDELLOM',
  'EDEN MAINE',
  'EDENBEAST',
  'EDENBRIDGE',
  'EDENFALL',
  'EDENIAN',
  'EDENKAISER',
  'EDENWAR',
  'EDGE OF HAZE',
  'EDGE OF PARADISE',
  'EDGE OF SANITY',
  'EDGE OF THORNS',
  'EDGEFLAME',
  'EDGUY',
  'EDU FALASCHI',
  'EERIE VON',
  'EEVIOMORFIA',
  'EFTOS',
  'EGARRA',
  'EGOISTIC',
  'EGONOIR',
  'EGYPT',
  'EIDOLA',
  'EIDOLON',
  'EIGHTEEN VISIONS',
  'EILERA',
  'EINHERJER',
  'EINSTÜRZENDE NEUBAUTEN',
  'EINTRITT',
  'EISBLUT',
  'EISBRECHER',
  'EISENHERZ',
  'EISENKREUZ',
  'EISHEILIG',
  'EISREGEN',
  'EK',
  'EKHO',
  'EKOTREN',
  'EKTOMORF',
  'ELANE',
  'ELBERETH',
  'ELDER',
  'ELDERTALE',
  'ELDERWIND',
  'ELDRITCH',
  'ELECTRIC WIZARD',
  'ELEGEION',
  'ELEGY',
  'ELEINE',
  'ELEMENT',
  'ELEMENT EIGHTY',
  'ELENA SIEGMAN',
  'ELEND',
  'ELENIUM',
  'ELENORA',
  'ELEPHANT',
  'ELESSÄR',
  'ELEVENTH HE REACHES LONDON',
  'ELEXORIEN',
  'ELF',
  'ELGIBBOR',
  'THE ELIJAH',
  'ELIS',
  'ELITARIA',
  'ELITIST',
  'ELIXIR',
  'ELJUDNER',
  'ELLA KAYE',
  'ELUVEITIE',
  'ELVENKING',
  'ELVENPATH',
  'ELVENSTORM',
  'ELVIRA MADIGAN',
  'ELYSIA',
  'ELYSIAN',
  'THE ELYSIAN FIELDS',
  'ELYSION',
  'ELYSIUM',
  'ELZEVIR',
  'EMAROSA',
  'EMBALMER',
  'EMBERS',
  'EMBERSLAND',
  'EMBODYMENT',
  'EMBRACE ETERNITY',
  'EMBRACE THE END',
  'EMBRACED',
  'EMBRACED BY HATRED',
  'EMBRACING',
  'EMBRAZE',
  'EMBRYO',
  'EMERALD',
  'EMERALD MIND',
  'EMERALD SUN',
  'EMERGENCE',
  'EMERGENCY GATE',
  'EMERNA',
  'EMERY',
  'EMETH',
  'EMIGRATE',
  'EMIL BULLS',
  'EMILIE AUTUMN',
  'EMMURE',
  'EMPATHICA',
  'EMPATHY',
  'EMPEROR',
  'EMPIRE',
  'EMPIRE AURIGA',
  'THE EMPIRE SHALL FALL',
  'EMPTINESS',
  'EMPTY GRAVES',
  'EMPYREAN ECLIPSE',
  'EMPYREAN SKY',
  'EMPYRIOS',
  'EMPYRIUM',
  'EMPÜRIOS',
  'EN DECLIN',
  'ENABLER',
  'ENAMORED',
  'ENBOUND',
  'ENCEPHALON',
  'ENCHANT',
  'THE ENCHANTED',
  'ENCHANTMENT',
  'ENCHANTYA',
  'ENCOFFINATION',
  'ENCRYPTOR',
  'END',
  'THE END',
  'END AMEN',
  'END OF AN ERA',
  'END OF GREEN',
  'END OF THE DREAM',
  'END OF YOU',
  'END ZONE',
  'ENDIMION',
  'ENDLESS',
  'ENDLESS DECEMBER',
  'ENDO',
  'ENDSTILLE',
  'ENDTHISDAY',
  'ENDWELL',
  'ENEMY LOGIC',
  'ENEMY OF THE SUN',
  'ENEMY STAR',
  'ENFIELD',
  'ENFOLD DARKNESS',
  'ENFORCER',
  'ENFORSAKEN',
  'ENGEL',
  'ENGINES OF TORTURE',
  'ENGORGED',
  'ENID',
  'ENISUM',
  'ENLIGHTED',
  'ENNUI',
  'ENNUI BREATHES MALICE',
  'ENOCHIAN CRESCENT',
  'ENOLA GAY',
  'ENRAGEMENT',
  'ENRAGER',
  'ENS COGITANS',
  'ENSHADOWED',
  'ENSHINE',
  'ENSIFERUM',
  'ENSLAVED',
  'ENSLAVEMENT OF BEAUTY',
  'ENTER CHAOS',
  'ENTER MY SILENCE',
  'ENTER SHIKARI',
  'ENTERPRISE EARTH',
  'ENTHEOS',
  'ENTHRALLMENT',
  'ENTHRING',
  'ENTHRONED',
  'ENTHRONING SILENCE',
  'ENTHROPE',
  'ENTITIES',
  'ENTOMBED',
  'ENTRAILS',
  'ENTREAT',
  'ENTROPIA',
  'ENTWINE',
  'ENTWINED',
  'EPHEL DUATH',
  'EPHEMERALD',
  'EPHRAT',
  'EPICA',
  'EPICARDIECTOMY',
  'EPICUREAN',
  'EPIDEMIC',
  'EPILEPTICA',
  'EPITOME OF FRAIL',
  'EPOCH OF UNLIGHT',
  'EPYSODE',
  'EQUILIBRIUM',
  'EQUINOX OV THE GODS',
  'EQUINOXEM',
  'EQUIPOISE',
  'EQUIRHODONT',
  'ERA VULGARIS',
  'EREB ALTOR',
  'EROS NECROPSIQUE',
  'ERRA',
  'ESCAPE THE FATE',
  'ESCAPIST',
  'ESCHATOS',
  'ESKIMO CALLBOY',
  'ESO CHARIS',
  'ESODIC',
  'ESOTERIC',
  'ESQARIAL',
  'ESSENCE',
  'ESSENCE OF EXISTENCE',
  'ESSENTIA',
  'ESSENZ',
  'ESTATIC FEAR',
  'ETERNAL',
  'THE ETERNAL',
  'ETERNAL ARMAGEDDON',
  'ETERNAL CANDLE',
  'ETERNAL CHAMPION',
  'ETERNAL DECISION',
  'ETERNAL DEFORMITY',
  'ETERNAL DIRGE',
  'ETERNAL DREAM',
  'ETERNAL GRAY',
  'ETERNAL HELCARAXE',
  'ETERNAL LORD',
  'ETERNAL MALEDICTION',
  'ETERNAL MOURNING',
  'ETERNAL OATH',
  'ETERNAL REIGN',
  'ETERNAL RETURNS',
  'ETERNAL RYTE',
  'ETERNAL SILENCE',
  'ETERNAL STORM',
  'THE ETERNAL SUFFERING',
  'ETERNAL TEARS OF SORROW',
  'ETERNAL THIRST',
  'ETERNE',
  'ETERNITY',
  'ETERNITY X',
  'ETHEREAL',
  'ETHEREAL PANDEMONIUM',
  'ETHEREALITY',
  'ETHERIAL WINDS',
  'ETHNOR',
  'ETHS',
  'ETWAS',
  'EUCHARIST',
  'EUCRASIA',
  'EUDAIMONY',
  'EUGENIC DEATH',
  'EUGENIK',
  'EULEN',
  'EUMERIA',
  'EUPHOREON',
  'EUROPE',
  'EUTHANASIA',
  'EVADING DOWNFALL',
  'EVADNE',
  'EVANESCENCE',
  'EVEMASTER',
  'EVEN SONG',
  'EVEN VAST',
  'EVENFALL',
  'EVENTIDE',
  'EVER FORTHRIGHT',
  'EVER SINCE',
  'EVERCLEAR',
  'EVERDARK',
  'EVEREVE',
  'EVERGRACE',
  'EVERGREEN TERRACE',
  'EVERGREY',
  'EVERLOOK',
  'EVERON',
  'EVERSHINE',
  'EVERSIN',
  'EVERWAITING SERENADE',
  'EVERY HAND BETRAYED',
  'EVERY PASSING DREAM',
  'EVERY TIME I DIE',
  'EVERYONE DIES IN UTAH',
  'EVERYTHING IN SLOW MOTION',
  'EVIDENCE ONE',
  'EVIG NATT',
  'EVIL ARMY',
  'EVIL EMPEROR',
  'EVIL INVADERS',
  'EVIL MASQUERADE',
  'EVIL POETRY',
  'EVIL SCARECROW',
  'EVIL WHIPLASH',
  'EVIL WINGS',
  'EVILDEAD',
  'EVILE',
  'EVILFEAST',
  'EVILWAR',
  'EVISCERATE',
  'EVISCERATE CARNAGE',
  'EVITA',
  'EVOCATION',
  'EVOKEN',
  'EVOL',
  'EVOLVENT',
  'EVTHANAZIA',
  'EWIGES REICH',
  'EWIGHEIM',
  'EWIGKEIT',
  'EWINIAR',
  'EX DEO',
  'EXALTER',
  'EXCALION',
  'EXCEL',
  'EXCELSIS',
  'EXCESS PRESSURE',
  'EXCITER',
  'EXCOMMUNION',
  'EXCREMENTORY GRINDFUCKERS',
  'EXCRETED ALIVE',
  'EXCRUCIATING PAIN',
  'EXECUTE MY LIBERTY',
  'EXECUTIVE',
  'EXETHERIS',
  'EXGENESIS',
  'EXHALE',
  'EXHALE MY OZONE',
  'EXHORDER',
  'EXHUMATION',
  'EXHUMATOR',
  'EXHUMED',
  'EXILE',
  'EXILIA',
  'EXISES',
  'EXIST',
  'EXISTANCE',
  'EXISTEM',
  'EXISTENCE',
  'EXISTENCE HAS FAILED',
  'EXIT EMPIRE',
  'EXIT TEN',
  'EXLIBRIS',
  'EXMORTEM',
  'EXMORTIS',
  'EXMORTUS',
  'EXOCRINE',
  'EXODUS',
  'EXOTYPE',
  'EXPIRE',
  'EXSANGUINATION THRONE',
  'EXSECRATUS',
  'EXSECROR VECORDIA',
  'EXTERMINATION DISMEMBERMENT',
  'EXTINCTION OF MANKIND',
  'EXTOL',
  'EXTORTION',
  'EXTORTIONIST',
  'EXTREME',
  'EXTREME NOISE TERROR',
  'EXTREME VIOLENCE',
  'EXUMER',
  'EXXOCET',
  'EXXPLORER',
  'THE EYE',
  'EYE OF ASCENDANCY',
  'EYE OF DECEIT',
  'EYE OF HORUS',
  'EYE OF ODIN',
  'EYE OF SOLITUDE',
  'EYE OF THE ENEMY',
  'EYECONOCLAST',
  'EYEFEAR',
  'EYEHATEGOD',
  'EYES LIKE DIAMONDS',
  'THE EYES OF A TRAITOR',
  'EYES OF EDEN',
  'EYES OF FIRE',
  'EYES OF LIGEIA',
  'EYES OF SHIVA',
  'EYES OF THE DEFILED',
  'EYES SET TO KILL',
  'EYES SHUT TIGHT',
  'EYES UPON SEPARATION',
  'EYES WIDE OPEN',
  'EZURATE',
  'EDGAR ALLAN POE',
  'ELEPHANT WATCHTOWER',
  'ENTERING POLARIS',
  "ETERNITY'S END",
  'ETHEREAL DARKNESS',
  'ETHEREAL FOREST',
  'EVERLOST',
  'EÏS',
  '[EVERTRAPPED]',
  'ÉNTOMOS'
];

const metalBandsF = [
  'FABULAE DRAMATIS',
  'FACE DOWN',
  'FACE THE FACT',
  'FACE YOUR MAKER',
  'FACEBREAKER',
  'THE FACELESS',
  'FACING THE GALLOWS',
  'FACTORY OF ART',
  'FADED LINE',
  'THE FADING',
  'FADING AZALEA',
  'FAERGHAIL',
  'FAHRENHEIT',
  'FAILURE IN VANITY',
  'FAIR TO MIDLAND',
  'FAIR WARNING',
  'FAIRYLAND',
  'FAIRYTALE ABUSE',
  'FAITH NO MORE',
  'FAITH OR FEAR',
  'FAITHFUL DARKNESS',
  'FAITHFUL UNTO DEATH',
  'FALCHION',
  'FALCONER',
  'FALKENBACH',
  'FALL BEHIND',
  'FALL CITY FALL',
  'FALL IN ARCHAEA',
  'FALL OF CARTHAGE',
  'FALL OF EFRAFA',
  'FALL OF EMPYREAN',
  'THE FALL OF EVERY SEASON',
  'FALL OF SERENITY',
  'FALL OF THE ALBATROSS',
  'FALL OF THE LEAFE',
  'THE FALL OF TROY',
  'FALLEN ARISE',
  'FALLEN FIGURE',
  'FALLEN JOY',
  'A FALLEN MIND',
  'FALLEN TO',
  'FALLEN VICTIM',
  'FALLENLIGHT',
  'FALLENSUN',
  'FALLING IN REVERSE',
  'FALLING LEAVES',
  'FALLOCH',
  'FALLOUT',
  'FALLS OF RAUROS',
  'FALLSTAR',
  'FALLUJAH',
  'FALSE TYRANTS',
  'FALSIFIER',
  'THE FAMINE',
  'FAMOUS LAST WORDS',
  'FANTOMAS',
  'FAR FROM NOTHING',
  'FARMAKON',
  'FARMER BOYS',
  'FARSOT',
  'FASE DOWN',
  'FASTER PUSSYCAT',
  'FASTKILL',
  'FASTWAY',
  'FATAL',
  'FATAL CRISIS',
  'FATAL EMBRACE',
  'FATE',
  'FATE OF PYRE',
  'FATE WEAVER',
  'THE FATEFUL HOUR',
  'FATELESS TEARS',
  'FATES WARNING',
  'FATHER HORROR',
  'THE FATHER OF SERPENTS',
  'FATHOMS',
  'FAUN',
  'FAUST',
  'FAUST AGAIN',
  'FAUSTIAN SLIP',
  'FAVOR THE BRAVE',
  'A FAYLENE SKY',
  'FEAR BEFORE THE MARCH OF FLAMES',
  'FEAR FACTORY',
  'FEAR MY THOUGHTS',
  'FEAR OF DOMINATION',
  'FEAR OF GOD',
  'FEAR OF NONE',
  'FEAR THE CONCEPT',
  'FEAR THE DAWN',
  'FEAR THY NAME',
  'FEAST ETERNAL',
  'A FEAST FOR KINGS',
  'FEASTEM',
  'FEED HER TO THE SHARKS',
  'FEED THE RHINO',
  'FEIGD',
  'FEIGN',
  'FEJD',
  'FELLSILENT',
  'FELO DE SE',
  'FELONY',
  'FEN',
  'FERAL BIRTH',
  'FERMENTO',
  'FESTER',
  'FESTIVAL OF MUTILATION',
  'FEUERSCHWANZ',
  'THE FEVERED',
  'THE FEW AGAINST MANY',
  'FFERYLLT',
  'FG',
  'FIABA',
  'FIELDS OF THE NEPHILIM',
  'FIFTH ANGEL',
  'THE FIFTH SEASON',
  'FIGHT',
  'FIGHT BACK',
  'FIGHT PRETTY',
  'FIGURE FOUR',
  'FIGURE OF SIX',
  'FILII NIGRANTIUM INFERNALIUM',
  'FILTH',
  'FIMBULTHIER',
  'FIMBULTYR',
  'THE FINAL BURDEN',
  'FINAL CHAPTER',
  'FINAL DEPRAVITY',
  'FINAL PRAYER',
  'FINAL RESISTANCE',
  'FINAL TRAGEDY',
  'FINAL WORDS OF SORROW',
  'FINIST',
  'FINITE AUTOMATA',
  'FINNTROLL',
  'FINNUGOR',
  'FINSTERFORST',
  'FINSTERNIS',
  'FIRE FROM THE GODS',
  'FIRE GARDEN',
  'FIRE IN THE SKIES',
  'FIREBALL MINISTRY',
  'FIREFORCE',
  'FIREHOUSE',
  'FIRELAKE',
  'FIRESPAWN',
  'FIREWIND',
  'FIRST BLOOD',
  'FIRST FRAGMENT',
  'THE FIRSTBORN',
  'FISSION',
  'FISSURE',
  'FISTHAMMER',
  'FIT FOR A KING',
  'FIT FOR AN AUTOPSY',
  'FIVE FINGER DEATH PUNCH',
  'FIVE FOOT THICK',
  'FIVE POINTE O',
  'FIVE PSYCHOSIS',
  'FJORSVARTNIR',
  'FLACHENBRAND',
  'FLAMING ROW',
  'FLASH BEFORE MY EYES',
  'FLASHBACK OF ANGER',
  'FLAW',
  'FLESH',
  'FLESH CONSUMED',
  'THE FLESH OF KINGS',
  'FLESHCRAWL',
  'FLESHGOD APOCALYPSE',
  'FLESHGORE',
  'FLESHGRIND',
  'FLESHLESS',
  'FLESHPRESS',
  'FLESHTIZED',
  'FLESHWROUGHT',
  'FLEURETY',
  'THE FLIGHT OF SLEIPNIR',
  'FLIPTOP BOX',
  'FLOAT FACE DOWN',
  'FLOOD',
  'FLOODGATE',
  'FLOODGATES',
  "THE FLOOR'S EMBRACE",
  'FLOTSAM & JETSAM',
  'A FLOURISHING SCOURGE',
  'FLOWING TEARS',
  'FLOWING TEARS AND WITHERED FLOWERS',
  'FLUISTERWOUD',
  'FLYING',
  'FLYING COLORS',
  'FLYLEAF',
  'FOG',
  'FOGALORD',
  'FOLK STONE',
  'FOLKEARTH',
  'FOLKLORD',
  'FOLKODIA',
  'FOLLY',
  'FOOTPRINTS IN THE CUSTARD',
  'FOR ALL ETERNITY',
  'FOR ALL I AM',
  'FOR ALL THOSE SLEEPING',
  'FOR THE FALLEN DREAMS',
  'FOR TODAY',
  'FORBIDDEN',
  'FORBIDDEN SITE',
  'FORCE OF EVIL',
  'FORCED ENTRY',
  'FOREFATHER',
  'FORENSEAR',
  'FORENSIC CLINIC',
  'THE FORERUNNER',
  'THE FORESHADOWING',
  'FOREST OF IMPALED',
  'FOREST OF SHADOWS',
  'A FOREST OF STARS',
  'FOREST STREAM',
  'FOREVER IN COMBAT',
  'FOREVER IN TERROR',
  'FOREVER ORION',
  'FOREVER SLAVE',
  'FOREVER STORM',
  "FOREVER'S EDGE",
  'FOREVERMORE',
  'FORGE',
  'FORGIVE ME',
  'FORGIVE-ME-NOT',
  'FORGOTTEN TALES',
  'FORGOTTEN TOMB',
  'FORGOTTEN WOODS',
  'FORLORN',
  'FORLORN LEGACY',
  'FORLORN PATH',
  'FORLORN SEAS',
  'FORLORN SUFFERING',
  'FORMLESS TERROR',
  'FORMORKET',
  'FORSAKEN',
  'THE FORSAKEN',
  'FORSAKEN WORLD',
  'FORTHANGEL',
  'FORTY FATHOMS',
  'FORWARD UNTO DAWN',
  'FOUNDATION',
  'FOUR QUESTION MARKS',
  'FOURTH DIMENSION',
  'FOZZY',
  'FRACTAL GATES',
  'FRACTALIA',
  'FRAGILE NOVA',
  'FRAGILE VASTNESS',
  'FRAGMENTS OF UNBECOMING',
  'FRAILTY',
  'FRAMESHIFT',
  'FRANK NEEDS HELP',
  'FRANKENBOK',
  'FRANTIC AMBER',
  'FRATER',
  'FREAK KITCHEN',
  'FRED NAGEL',
  "FREDRIK THORDENDAL'S SPECIAL DEFECTS",
  'FREE RIDE',
  'FREEDOM CALL',
  "FREHLEY'S COMET",
  'FREITOD',
  'FREQUENCY OF BUTTERFLY WINGS',
  'FRETERNIA',
  'FREYA',
  'FRIEND FOR A FOE',
  'FRIGHTMARE',
  'FRIJGARD',
  'FROM A SECOND STORY WINDOW',
  'FROM ATLANTIS',
  'FROM AUTUMN TO ASHES',
  'FROM FIRST TO LAST',
  'FROM HERE ON',
  'FROM NORTH',
  'FROM SORROW TO SERENITY',
  'FROM THE DEPTH',
  'FROM THE HEART',
  'FROM THE SHALLOWS',
  'FRONT LINE ASSEMBLY',
  'FRONTSIDE',
  'FROST',
  'FROST LIKE ASHES',
  'FROSTMOON',
  'FROSTMOON ECLIPSE',
  'FROSTTIDE',
  'FROWN',
  'FROZEN DAWN',
  'FROZEN INFINITY',
  'FROZEN SUN',
  'FU MANCHU',
  'FUCK THE FACTS',
  'FUCK YOU LAS VEGAS',
  'THE FUCKING WRATH',
  'FUELED BY FIRE',
  'FUGHU',
  'FUKPIG',
  'FULL BLOWN CHAOS',
  'FULL OF HELL',
  'FULL STRIKE',
  'FULLFORCE',
  'FUNERAL',
  'FUNERAL DINER',
  'FUNERAL FOG',
  'FUNERAL FOR A FRIEND',
  'FUNERAL FORNICATION',
  'FUNERAL MIST',
  'FUNERAL MOURNING',
  'THE FUNERAL PYRE',
  'FUNERAL REQUIEM',
  'FUNERAL RITES',
  'FUNERAL WINDS',
  'FUNERALIUM',
  'FUNERARIUM',
  'FUNERARY DIRGE',
  'FUNERIS NOCTURNUM',
  'FURAN',
  'FURIA',
  'FURIA ANIMAL',
  'THE FUROR',
  'FUROR GALLICO',
  'FURTHERIAL',
  'FURZE',
  'FUSION BOMB',
  'FELLWARDEN',
  'FLESHKILLER',
  'FLOWERLEAF',
  'FRACTAL UNIVERSE',
  'FROZEN DREAMS',
  'FUNERAL SPEECH',
  'FÄULNIS'
];

const metalBandsG = [
  'GADGET',
  'GAIA EPICUS',
  'GAIAS PENDULUM',
  'GALACTIC COWBOYS',
  'GALADRIEL',
  'GALAR',
  'GALDERIA',
  'GALGERAS',
  'THE GALLERY',
  'GALLHAMMER',
  'GALLOGLASS',
  'GALLOWBRAID',
  'GALLOWER',
  'GALLOWS',
  'GALNERYUS',
  'GALSKAP',
  'GAMA BOMB',
  'GAMMA RAY',
  'GAMMA SECTOR',
  'GAMMACIDE',
  'GANDALF',
  'GARDEN OF EDEN',
  'GARDEN OF SHADOWS',
  'GARDENIAN',
  'GARDENS OF GEHENNA',
  'GARHELENTH',
  'GARMENHORD',
  'GARRA',
  'GARY HUGHES',
  'GATECREEPER',
  'GATES OF AARU',
  'GATES OF ISHTAR',
  'THE GATES OF SLUMBER',
  'THE GATHERING',
  'GAUNTLET',
  "GAUNTLET'S SWORD",
  'GAZA',
  'GEASA',
  'GEHENNA',
  'GEHENNAH',
  'GEIST',
  'GEMINI SYNDROME',
  'GENERAL SURGERY',
  'GENERATION KILL',
  'GENGHIS TRON',
  'GENITORTURERS',
  'GENOCIDE DISTRICT',
  'THE GENTLE STORM',
  'GEOFF TATE',
  'GEORGE KOLLIAS',
  'GERNOTSHAGEN',
  'GET DESTROYED',
  'GET SCARED',
  'GET UP TEXAS',
  'GEVOLT',
  'GHAMOREAN',
  'GHAST',
  'GHOLGOTH',
  'GHOST',
  'GHOST BATH',
  'GHOST BRIGADE',
  "THE GHOST I'VE BECOME",
  'THE GHOST INSIDE',
  'GHOST MACHINERY',
  'GHOST WARFARE',
  'GHOSTS OF BLACK RIVER',
  'GHOUL',
  'GIANT SQUID',
  'GIDEON',
  'GIFT GIVER',
  'GIGAN',
  'GIGATRON',
  'GILLMAN',
  'GIRE',
  'GIRLSCHOOL',
  'GIUNTINI PROJECT',
  'GIVE UP THE GHOST',
  'GIZMACHI',
  'GLACIAL FEAR',
  'GLASS CASKET',
  'GLASS CLOUD',
  'GLASSJAW',
  'GLENN TIPTON',
  'GLITTERTIND',
  'GLOBUS',
  'THE GLOOM IN THE CORNER',
  'GLOOMY GRIM',
  'GLORIA MORTI',
  'GLORIOR BELLI',
  'GLORY OPERA',
  'GLORYHAMMER',
  'GLUM',
  'GNOB',
  'GNOSTIC',
  'GO AHEAD AND DIE',
  'GOAT HORN',
  'GOAT OF MENDES',
  'GOATLORD',
  'GOATMOON',
  'GOATSNAKE',
  'GOATWHORE',
  'GOB',
  'GOD',
  'GOD AMONG INSECTS',
  'GOD DETHRONED',
  'GOD FORBID',
  'GOD FORSAKEN',
  'GOD MACABRE',
  'GOD MOTHER',
  'GOD OF NOTHING',
  'GOD SEED',
  "GOD'S AWAY ON BUSINESS",
  "GOD'S HATE",
  'GODDAMN',
  'GODDEFIED',
  'GODDESS OF DESIRE',
  'GODEATER',
  'GODFLESH',
  'GODGORY',
  'GODHAND',
  'GODHATE',
  'GODHEAD',
  'GODIVA',
  'GODKILLER',
  'GODLESS CRUSADE',
  'GODLESS THRONE',
  'GODS OF EDEN',
  'GODS TOWER',
  'GODSEND',
  'GODSLAVE',
  'GODSMACK',
  'GODSTOMPER',
  'GOETHES ERBEN',
  'GOETIA',
  'GOJIRA',
  'GOLDEN DAWN',
  'GOLDEN RESURRECTION',
  'GOLEM',
  'GOLLUM',
  'GOMORRAH',
  'GOMORRAN',
  'GONKULATOR',
  'GOOD TIGER',
  'GORATH',
  'GORATORY',
  'GORE',
  'GORE PRIEST',
  'GOREFEST',
  'GOREFUCK',
  'GORELORD',
  'GOREROTTED',
  'GORESLEEPS',
  'GORETRADE',
  'GORGASM',
  'GORGOROTH',
  'GORGUTS',
  'GORMATHON',
  'GOROD',
  'GORY BLISTER',
  'GOSPEL OF THE HORNS',
  'GOTHIC',
  'GOTHIC KNIGHTS',
  'GOTHICA',
  'GOTHMINISTER',
  'GOTHËRFALL',
  'GOTMOOR',
  'GOTTHARD',
  'GRABNEBELFÜRSTEN',
  'GRACE GALE',
  'GRAFVITNIR',
  'GRAILKNIGHTS',
  'GRAND ALCHEMIST',
  "GRAND BELIAL'S KEY",
  'GRAND MAGUS',
  'GRAUPEL',
  'GRAVE',
  'GRAVE DIGGER',
  'GRAVE FLOWERS',
  'GRAVE MAKER',
  'GRAVE MIASMA',
  'GRAVEL SHORES',
  'GRAVELAND',
  'GRAVES AT SEA',
  'GRAVEWORM',
  'GRAVEYARD',
  'GRAVITATIONAL DISTORTION',
  'GRAVITY KILLS',
  'GRAYCEON',
  'GRAYSCALE',
  'THE GREAT AIRPORT MYSTERY',
  'THE GREAT COMMISSION',
  'THE GREAT DECEIVER',
  'THE GREAT EQUALISER',
  'GREAT GRIEF',
  'GREAT HORN',
  'THE GREAT KAT',
  'GREAT MASTER',
  'THE GREAT OLD ONES',
  'GREAT SORROW',
  'GREAT VAST FOREST',
  'THE GREATNESS DESIGN',
  'GREELEY ESTATES',
  'GREEN CARNATION',
  'GREEN CATHEDRAL',
  'GREEN JELLY',
  'THE GREEN LUNG GRINDERS',
  'THE GREEN RIVER BURIAL',
  'GREENFLY',
  'GREENLEAF',
  'GRENDEL',
  'GRENOUER',
  'GREY SKIES FALLEN',
  'GRIDIRON',
  'GRIDLINK',
  'GRIEF',
  'GRIEF OF EMERALD',
  'GRIEVED',
  'GRIFFIN',
  'GRIFT',
  'GRIFTEFRID',
  'GRIFTEGÅRD',
  'GRIM REAPER',
  'GRIMA',
  'GRIMFAITH',
  'GRIMFIST',
  'GRIMFORST',
  'GRIMLET',
  'GRIMLORD',
  'GRIMNER',
  'GRINDER',
  'GRINKIS',
  'GRIS',
  'GRIZZLYMAN',
  'GROL',
  'GROTESQUE',
  'GROZA',
  'GRUESOME',
  'GRUESOME STUFF RELISH',
  'GUARDIANS OF MANKIND',
  'GUARDIANS OF TIME',
  'GUARNERIUS',
  'GUILLOTINE',
  'GUILT MACHINE',
  'GUILTHEE',
  'GUN BARREL',
  'THE GUN SHOW',
  "GUNS N' ROSES",
  'GURD',
  'GUTFUCKED',
  'GUTTED',
  'GUTTER SIRENS',
  'GUTTROLL',
  'GUTTURAL SECRETE',
  'GWAR',
  'GWEN STACY',
  'GWYDION',
  'GWYLLION',
  'GWYNBLEIDD',
  'GYRE',
  'GYZE',
  'GHOSTHEART NEBULA',
  'GODHEAD MACHINERY',
  'GREEN LUNG',
  'GRIMAZE'
];

const metalBandsH = [
  'THE HAARP MACHINE',
  'HAAT',
  'HABITUAL',
  'HACAVITZ',
  'HACKNEYED',
  'HACKSAW TO THE THROAT',
  'HACRIDE',
  'HADEA',
  'HADES',
  'HAEMORRHAGE',
  "HAGALAZ' RUNEDANCE",
  'HAGEN',
  'HAGGARD',
  'HAGL',
  'HAIL OF BULLETS',
  'HAIL SPIRIT NOIR',
  'HAIL TO THE KING',
  'HAILSTONE',
  'HAK-ED DAMM',
  'HAKEN',
  'HALCYON WANDER',
  'HALCYON WAY',
  'HALESTORM',
  'HALFORD',
  'HALLOWS EVE',
  'HALO OF GUNFIRE',
  'HALO OF SHADOWS',
  'HALOR',
  'HAMLET',
  'HAMMER HORDE',
  'HAMMER OF THE GODS',
  'HAMMERCULT',
  'HAMMERFALL',
  'HAMMERS OF MISFORTUNE',
  'HAND OF MERCY',
  'HANDS',
  'HANDS LIKE HOUSES',
  'HANDS UPON SALVATION',
  'HANDSXFEET',
  'HANG THE BASTARD',
  'HANGAR',
  'HANGING GARDEN',
  'HANK WILLIAMS III',
  'HANKER',
  'HANNES GROSSMANN',
  'HANZEL UND GRETYL',
  'HAPPY DAYS',
  'HARAKIRI FOR THE SKY',
  'HARASAI',
  'HARBINGER',
  'HARDCORE SUPERSTAR',
  'HARDINGROCK',
  'HARDLINE',
  'HARLOTS',
  "HARM'S WAY",
  'HARMANIC',
  'HARMONY',
  'HARMONY BREAKS',
  'HARMONY DIES',
  'HARPUN',
  'HARROW',
  'HARTMANN',
  'HARVEST',
  'HARVIST',
  'HASTE',
  'HASTE THE DAY',
  'HAT',
  'HATCHET',
  'HATE',
  'HATE ETERNAL',
  'HATE MACHINE',
  'HATE PLOW',
  'HATE SQUAD',
  'HATEBOMB',
  'HATEBREED',
  'HATECRAFT',
  'HATECROWNED',
  'HATEFUL',
  'HATEFUL DESOLATION',
  'HATEISM',
  'HATEPULSE',
  'HATESKOR',
  'HATESPHERE',
  'HATEWORLD',
  'HATRED SURGE',
  'HATRIOT',
  'HATRIX',
  'THE HAUNTED',
  'HAUNTED CELLAR',
  'HAUNTED SHORES',
  'HAVAYOTH',
  'HAVE HEART',
  'HAVENSIDE',
  'HAVOC MASS',
  'HAVOK',
  'HAWSER',
  'HAYWORTH',
  'HAZY HAMLET',
  'HB',
  'HE IS LEGEND',
  'HE THE DECEIVER',
  'HEAD',
  'HEAD WITH WINGS',
  'HEADHUNTER',
  'HEADSHOT',
  'HEADSPACE',
  'HEADSTONE EPITAPH',
  'HEADWOUND THE PONY',
  'HEARSE',
  'HEART IN HAND',
  'HEART OF A COWARD',
  'HEART OF CYGNUS',
  'HEARTIST',
  'HEARTS & HANDS',
  'HEARTWOOD',
  'HEATHEN',
  'HEATHEN BEAST',
  'HEATHEN FORAY',
  'HEAVATAR',
  'HEAVEN & HELL',
  'HEAVEN ABLAZE',
  'HEAVEN FALLS',
  'HEAVEN GREY',
  'HEAVEN SHALL BURN',
  "HEAVEN'S BASEMENT",
  "HEAVEN'S CRY",
  "HEAVEN'S GATE",
  'HEAVENBLAST',
  'HEAVENLY',
  'HEAVENWOOD',
  'HEAVY HEAVY LOW LOW',
  'HEAVY LOAD',
  'HEAVY METAL PERSE',
  'HEAVYWEIGHT DIVISION',
  'HECATE',
  'HECATE ENTHRONED',
  'HECATOMB',
  'HECK',
  'HEDON CRIES',
  'HEED',
  'HEFEYSTOS',
  'HEGEMON',
  'HEIDEVOLK',
  'HEIGHTS',
  'HEIMDALL',
  'HEIMDALLS WACHT',
  'HEIMWEH',
  'HEIR APPARENT',
  'HEL',
  'HELALYN FLOWERS',
  'HELENGARD',
  'HELEVORN',
  'HELHEIM',
  'HELICON',
  'HELJAREYGA',
  'HELL',
  'THE HELL',
  'HELL IN THE CLUB',
  'HELL WITHIN',
  "HELL'S ISLAND",
  'HELLCHILD',
  'HELLEBORUS',
  'HELLENNIUM',
  'HELLGRIND',
  'HELLHAMMER',
  'HELLION',
  'HELLIONS',
  'HELLISH WAR',
  'HELLIUM',
  'HELLKRUSHER',
  'HELLOWEEN',
  'HELLPATH',
  'HELLREIGN',
  'HELLSAW',
  'HELLSPAWN',
  'HELLTRAIN',
  'HELLWELL',
  'HELLYEAH',
  'HELMET',
  'HELRUNAR',
  'HELSTAR',
  'HELSÓTT',
  'HEMDALE',
  'HEMINA',
  'HEMLOCK',
  'HEMOPTYSIS',
  'HENCEFORTH',
  'HENRY METAL',
  'HER NIGHTMARE',
  'HERE COMES THE KRAKEN',
  'HERESIAE',
  'HERESIARH',
  'HERETOIR',
  'HERICI',
  'HERJALF',
  'HERMETIC VASTNESS',
  'HERMETICA',
  'HERMH',
  'HERMIT AGE',
  'A HERO A FAKE',
  'HEROD',
  'HESPERIAN',
  'HESPERUS DIMENSION',
  'HESTER PRYNNE',
  'HETROERTZEN',
  'HEVEIN',
  'HEVISAURUS',
  'HEXEN',
  'HEXENHAUS',
  'HEXVESSEL',
  'HEXX',
  'HIBAKUSHA',
  'HIBRIA',
  'HIDEOUS DIVINITY',
  'HIERONYMUS BOSCH',
  'HIEROPHANT',
  'HIGH CARD',
  'HIGH ON FIRE',
  'HIGHLAND GLORY',
  'HIGHLORD',
  'A HILL TO DIE UPON',
  'HILLBILLY DEATHRIDE',
  'HILLS HAVE EYES',
  'HIM',
  'HIMINBJØRG',
  'HIMSA',
  'HIN ONDE',
  'HINDER',
  'HIRAX',
  'HIRILORN',
  'HIROSHIMA WILL BURN',
  'HIS STATUE FALLS',
  'HITHLUM',
  'HITTMAN',
  "HOBBS' ANGEL OF DEATH",
  'HOLINESS',
  'HOLLENTHON',
  'HOLLOW',
  'HOLLOW BONES',
  'THE HOLLOW EARTH THEORY',
  'HOLLOW FRONT',
  'HOLLOW LIKE ME',
  'HOLLOW POINT',
  'HOLLOW PROPHET',
  'HOLLOW VESSELS',
  'HOLLYWOOD UNDEAD',
  'HOLOCAUST',
  'HOLOCHAUST',
  'HOLTER',
  'HOLY DEATH',
  'HOLY FORCE',
  'HOLY GRAIL',
  'THE HOLY GUILE',
  'HOLY KNIGHTS',
  'HOLY MARTYR',
  'HOLY MOSES',
  'HOLY MOTHER',
  'HOLY SAGGA',
  'HOLY TERROR',
  'HOLYHELL',
  'HOMEWARDS',
  'HOMO IRATUS',
  'HONDO MACLEAN',
  'HONOUR CREST',
  'HOODED MENACE',
  'HOODS',
  'THE HOPE CONSPIRACY',
  'A HOPE FOR HOME',
  'HOPE FOR THE DYING',
  'HOPE IN HAND',
  'A HOPE NOT FORGOTTEN',
  'HOPES DIE LAST',
  'HOPESFALL',
  'HORA SUPREMA',
  'HORCAS',
  'HORDE',
  'HORIZONS',
  'HORN',
  'HORN OF THE RHINO',
  'HORNA',
  'HORNCROWNED',
  'HORRENDOUS',
  'HORRIFIED',
  'HORRIFIER',
  'HORROR SHOW',
  'HORSE THE BAND',
  'HORTUS ANIMAE',
  'HOSTAGE OF FATE',
  'HOUR OF PENANCE',
  'THE HOURGLASS',
  'HOUWITSER',
  'HOW LIKE A WINTER',
  'HOWL',
  'HOWLING SYN',
  'THE HOWLING VOID',
  'HROSSHARSGRANI',
  'HTETHTHEMETH',
  'HUGHES TURNER PROJECT',
  'HULDRA',
  'THE HUMAN ABSTRACT',
  'HUMAN ERROR',
  'HUMAN FACTOR',
  'HUMAN FORTRESS',
  'HUMAN GROUND',
  'HUMAN IMPROVEMENT PROCESS',
  'HUMAN MINCER',
  'HUMAN REMAINS',
  'HUMAN SERPENT',
  'HUMAN TEMPLE',
  'HUMANIMAL',
  "HUMANITY'S LAST BREATH",
  'HUMMANO',
  'HUNDREDTH',
  'HUNG',
  'HUNG',
  'HUNTER',
  'HUNTRESS',
  'HURRICANE',
  'HYADES',
  'HYBERNOID',
  'HYBRID CIRCLE',
  'HYBRID SHEEP',
  'HYBRIS',
  'HYDRIA',
  'HYPERBOREA',
  'HYPERION',
  'HYPNOS',
  'HYPNOSIA',
  'HYPNOSIS',
  'HYPOCRISY',
  'HYPONIC',
  'HYPOTHERMIA',
  'HYSTERICA',
  'HYUBRIS',
  'HADAL MAW',
  'HALLATAR',
  'HATCHLING',
  'HAVAMAL',
  'HEIDRA',
  'HURTLOCKER',
  'HYPOXIA',
  'HÄMATOM',
  'HÄVOK ÜNIT',
  'HÚSAR'
];

const metalBandsI = [
  'I AM ABOMINATION',
  'I AM HAUNTED',
  'I AM HUNGER',
  'I AM I',
  'I AM KING',
  'I AM THE OCEAN',
  'I AM THE SUN',
  'I AM WAR',
  'I BUILT THE CROSS',
  'I DECLARE WAR',
  'I EXIST',
  'I HATE SALLY',
  'I KEPT SILENT',
  'I KILLED EVERYONE',
  'I KILLED THE PROM QUEEN',
  'I LEGION',
  'I PROMISED ONCE',
  'I SEE STARS',
  'I SET MY FRIENDS ON FIRE',
  'I SHALL DEVOUR',
  'I SHALT BECOME',
  'I SPIT ASHES',
  "I'LL BE AN EMPIRE",
  "I'M IN A COFFIN",
  "I'MMORTAL",
  'I, DELUSIONIST',
  'I, OF HELIX',
  'I, OMEGA',
  'I, REVIVAL',
  'I, THE BREATHER',
  'I, VALIANCE',
  'I-TERRA',
  'IAMTHESHOTGUN',
  'IAMÍ',
  'IAN HIGHHILL',
  'IAN PARRY',
  'IAPETHOS',
  'THE ICARUS LINE',
  "ICARUS' DOWNFALL",
  'ICE AGES',
  'ICE DRAGON',
  'ICE NINE KILLS',
  'ICED EARTH',
  'ICEWIND',
  'ICON',
  'ICON AND THE BLACK ROSES',
  'ICON IN ME',
  'ICONIC VIVISECT',
  'ICOSIAN',
  'ICP',
  'ICS VORTEX',
  'ICYCORE',
  'IDEAS',
  'IDOLS',
  'IDOLS OF APATHY',
  'IF HOPE DIES',
  'IF I WERE YOU',
  'IFING',
  'IFRID',
  'IGNEA',
  'IGNIS FATUU',
  'IGNITE',
  'IGNOMINIOUS INCARCERATION',
  'IGNOTUS ENTHROPYA',
  'IHATE',
  'IHSAHN',
  'II DAWN',
  'IKU-TURSO',
  'IKUINEN KAAMOS',
  'ILIUM',
  'ILL NINO',
  'ILLDISPOSED',
  'ILLIDIANCE',
  'ILLNATH',
  'ILLOGICIST',
  'ILLUMINATA',
  'ILLUMINATUS',
  'ILLUSION FORCE',
  'ILLUSION SUITE',
  'ILLYRIA',
  'ILUMINATO',
  'IMAGES OF EDEN',
  'IMAGIKA',
  'IMAGO MORTIS',
  'IMMEMOREAL',
  'IMMER',
  'IMMERSED',
  'IMMOLATION',
  'IMMORALIST',
  'IMMORTAL',
  'IMMORTAL CHOIR',
  'IMMORTAL RITES',
  'IMMORTAL SOULS',
  'IMPALED',
  'IMPALED NAZARENE',
  'IMPALER',
  'IMPELLITTERI',
  'IMPENDING DOOM',
  'IMPERANON',
  'IMPERATOR',
  'IMPERIA',
  'IMPERIAL',
  'IMPERIAL AGE',
  'IMPERIAL CRYSTALLINE ENTOMBMENT',
  'IMPERIAL TRIUMPHANT',
  'IMPERIOUS MALEVOLENCE',
  'IMPERIUM DEKADENZ',
  'IMPERIUM INFERNALE',
  'IMPETIGO',
  'IMPIETY',
  'IMPIOUS',
  'IMPIOUS HAVOC',
  'IMPLORE',
  'IMPROVIDENCE',
  'IMPURE',
  'IMPURITY',
  'IMPURITY OF MRIYA',
  'IN AETERNUM',
  'IN AEVUM AGERE',
  'IN APOSTASIA',
  'IN ARKADIA',
  'IN BATTLE',
  "IN BEAST'S EMBRACE",
  'IN DREAD RESPONSE',
  'IN DYING ARMS',
  'IN ELEMENT',
  'IN EXTREMO',
  'IN FEAR AND FAITH',
  'IN FLAMES',
  'IN GREY',
  'IN HEARTS WAKE',
  'IN HEAVEN',
  'IN LACRIMAES ET DOLOR',
  'IN LEGEND',
  'IN LOVING MEMORY',
  'IN MEMORIUM',
  'IN MOTION',
  'IN MOURNING',
  'IN MY EMBRACE',
  'IN PIECES',
  'IN REFERENCE TO A SINKING SHIP',
  'IN RUINS',
  'IN SEARCH OF SOLACE',
  'IN SOLITUDE',
  'IN SOULITARY',
  'IN SPADES',
  'IN THA UMBRA',
  'IN THE BURIAL',
  'IN THE EYES OF A MISTRESS',
  'IN THE MIDST OF LIONS',
  'IN THE PRESENCE OF WOLVES',
  'IN THE SILENCE',
  'IN THIS CHEST',
  'IN THIS MOMENT',
  'IN TORMENTATA QUIETE',
  'IN VAIN',
  'IN VICTORY',
  'IN VIRTUE',
  'IN-QUEST',
  'INACTIVE MESSIAH',
  'INANIMATE EXISTENCE',
  'INANNA',
  'INBORN SUFFERING',
  'INBREEDING REDNECKS',
  'INCANTATION',
  'INCARNIA',
  'INCIDENCE',
  'INCINERATING PROPHECIES',
  'INCUBATOR',
  'INCUBUS',
  'INCUBUS',
  'INCURSED',
  'INDESINENCE',
  'INDESTROY',
  'INDIAN FALL',
  'INDICA',
  'INDIGNITY',
  'INDUKTI',
  'INDUNGEON',
  'INDWELLING',
  'INEXIST',
  'INFAMUS',
  'INFANT ANNIHILATOR',
  'INFANTICIDE',
  'INFECTED',
  'INFECTED AUTHORITAH',
  'INFECTED RAIN',
  'INFECTED TRANSISTOR',
  'INFERI',
  'INFERIS',
  'INFERNAEON',
  'INFERNAL',
  'INFERNAL DOMINION',
  'INFERNAL GATES',
  'INFERNAL MAJESTY',
  'INFERNAL MALICE',
  'INFERNAL POETRY',
  'INFERNAL TORMENT',
  'INFERNAL WAR',
  'INFERNO',
  'INFERNUM',
  'INFERNÖ',
  'INFERZENAL',
  'INFEST',
  'INFESTDEAD',
  'INFESTED',
  'INFESTER',
  'INFESTUM',
  'INFESTUS',
  'INFINITE DENSITY',
  'INFINITE DESIGN',
  'INFINITE SPECTRUM',
  'INFINITY',
  'INFLICTION',
  'INGESTED',
  'INGRIMM',
  'INGROWING',
  'INGURGITATING OBLIVION',
  'INHALE EXHALE',
  'INHERIT DISEASE',
  'INIQUITY',
  'INISHMORE',
  'INITIAL STATE',
  'INITIATOR',
  'INJUSTICE',
  'INKED IN BLOOD',
  'INKUBUS SUKKUBUS',
  'INMORIA',
  'INNER FEAR',
  'INNER MISSING',
  'INNER SANCTUM',
  'INNER SHRINE',
  'INNER THOUGHT',
  'INNER VISIONS',
  'INNERBEAUTY',
  'INNERWISH',
  'INNOCENS',
  'INNZMOUTH',
  'INPATHOS',
  'INQUISICION',
  'INQUISITION',
  'INSANIA',
  'INSANIA TRIVIUM',
  'INSANITY REIGNS SUPREME',
  'INSECT WARFARE',
  'INSENSE',
  'INSIDEAD',
  'INSIDIOUS DECREPANCY',
  'INSIDIOUS PROCESS',
  'INSISION',
  'INSISTENCE',
  'INSOMNIUM',
  'INSPIRED BY YOU',
  'INSTANZIA',
  'INSTINCT OF SURVIVAL',
  'INTEGRITY',
  'INTENSE',
  'INTENT',
  'INTER ARMA',
  'THE INTERBEING',
  'INTERCEPTOR',
  'INTERFECTOR',
  'INTERITUS DEI',
  'INTERMENT',
  'INTERNAL BLEEDING',
  'INTERNAL DEVOUR',
  'INTERNAL SUFFERING',
  'INTERVALLE BIZARRE',
  'INTERVALS',
  'INTERVOID',
  'INTESTINAL DISGORGE',
  'INTESTINE BAALISM',
  'INTO ETERNITY',
  'INTO THE FLOOD',
  'INTO THE MOAT',
  'INTOXXXICATED',
  'INTRAVOID',
  'INTROITUS',
  'INTRONAUT',
  'INTRUDER',
  'INVENT, ANIMATE',
  'INVERACITY',
  'INVERSUM',
  'INVERTED PENTAGRAM',
  'INVICTUS',
  'INVISIUS',
  'INVIVO',
  'INVOCATION OF NEHEK',
  'INVOCATOR',
  'INVOKER',
  'ION DISSONANCE',
  'IONIC BOND',
  'IPERYT',
  'IQ',
  'IRA',
  'IRON FIRE',
  'IRON LUNG',
  'IRON MAIDEN',
  'IRON MAN',
  'IRON MASK',
  'IRON MONKEY',
  'IRON REAGAN',
  'IRON SAVIOR',
  'IRON THRONES',
  'IRONSWORD',
  'IRONWARE',
  'IRONY DESTROYED',
  'IRREVERENCIA',
  'IRREVERSIBLE MECHANISM',
  'IRRITA',
  'ISA',
  'ISACAARUM',
  'ISANMAA',
  'ISAZ CORP',
  'ISENBURG',
  'ISENGARD',
  'ISFET',
  'ISHIMO',
  'ISIS',
  'ISKALD',
  'ISLE',
  'ISOLE',
  'ISOTOPES',
  'ISSOS',
  'ISSUES',
  'ISTAPP',
  'ISVIND',
  'IT DIES TODAY',
  'IT PREVAILS',
  'IT WILL COME',
  'ITHDABQUTH QLIPHOTH',
  'ITHILIEN',
  'IUVENES',
  'IVANHOE',
  'IVENBERG',
  'IVORY TOWER',
  'IWRESTLEDABEARONCE',
  'IXXI',
  'IZAKARON',
  'IZEGRIM',
  'ICY STEEL',
  'IMMENSITY',
  'INKVISITOR',
  'ÍON'
];

const metalBandsJ = [
  'JACK FROST',
  'JACK KETCH',
  'JACK OFF JILL',
  'JACK SLATER',
  "JACK STARR'S BURNING STARR",
  'JACKYL',
  "JACOB'S DREAM",
  'JADED STAR',
  'JAG PANZER',
  'JAILBIRD',
  'JAIRUS',
  'JALDABOATH',
  'JAMES LABRIE',
  'JAMES MURPHY',
  "JAMIE'S ELSEWHERE",
  'JAPANISCHE KAMPFHÖRSPIELE',
  'JAPUNGA',
  'JARED DINES',
  'JASAD',
  'JASTA',
  'A JEALOUSY ISSUE',
  'JEFF LOOMIS',
  'JEFFREY NOTHING',
  'THE JELLY JAM',
  "JENNIE TEBLER'S OUT OF OBLIVION",
  'JERK',
  'JESS AND THE ANCIENT ONES',
  "JESTER'S FUNERAL",
  "JESTER'S MARCH",
  'JESU',
  'JETHRO TULL',
  'JEX THOTH',
  'JIHAD',
  'JINJER',
  'JIODA',
  'JOB FOR A COWBOY',
  'JOHANSSON',
  'JOHARI',
  'JOHN ARCH',
  'JOHN WEST',
  'JOHNNY BOOTH',
  'JON OLIVA',
  "JON OLIVA'S PAIN",
  'THE JONBENÉT',
  'JORDAN RUDESS',
  'JORN',
  'JORN LANDE & TROND HOLTER',
  'JOSE ANDREA',
  'JOTUNSPOR',
  'JOURNEY',
  'THE JUDAS FACTOR',
  'JUDAS ISCARIOT',
  'JUDAS PRIEST',
  'JUDGE',
  'JUDGE MINOS',
  'JUDICATOR',
  'JULIE LAUGHS NOMORE',
  'JUNGBLUTH',
  'JUNGLE ROT',
  'JUNIUS',
  'JUSTICE',
  'JUTE GYTE',
  'JOY'
];

const metalBandsK = [
  'KAAMOS',
  'KADATH',
  'KADAVRIK',
  'KADENZZA',
  'KAFIRUN',
  'KAI',
  'KAL-EL',
  'KALAS',
  'KALEDON',
  'KALISIA',
  'KALL',
  'KALMAH',
  'KALMANKANTAJA',
  'KAMBRIUM',
  'KAMELOT',
  'KAMIKABE',
  'KAMPFAR',
  'KANDIA',
  'KANSAS',
  'KAOSPILOT',
  'KAOTEON',
  'KAPEL MAISTER',
  'KARDASHEV',
  'KARELIA',
  'KARELIAN WARCRY',
  'KARI RUESLATTEN',
  'KARKADAN',
  'KARMA TO BURN',
  'KARNIVOOL',
  'KARST',
  'KARTIKEYA',
  'KAT',
  'KATAFALK',
  'KATAHDIN',
  'KATAKLYSM',
  'KATALEPSY',
  'KATAPLEXIA',
  'KATAPLEXIS',
  'KATARSIS',
  'KATATONIA',
  'KATAVASIA',
  'KATAXU',
  'KATHAARIA',
  'KATHARSIS',
  'KATRA',
  'KAUAN',
  'KAWIR',
  'KAYO DOT',
  'KEEL',
  'KEEN HUE',
  'KEEP OF KALESSIN',
  'KEEP SAKE',
  'KEILLEN ALLITH',
  'KEKAL',
  'KELDIAN',
  'KELLS',
  'KELTHUZZAR',
  'KEMET',
  'KEN MODE',
  'KENN NARDI',
  'KENSHIRO',
  'KENZINER',
  'KEPT INSIDE',
  'KERION',
  'KEROSENE',
  'KETZER',
  'KEVORKIAN',
  'KEY OF MYTHRAS',
  'KEYVANOTH',
  'KHAEL',
  'KHAFRA',
  'KHALLICE',
  'KHANATE',
  'KHAOSICK',
  'KHARMA CODE',
  'KHEMMIS',
  'KHOLD',
  'KHOMA',
  'KHORS',
  'KHRAWKUPAR NONGLAIT',
  'KICK AXE',
  'KICKBACK',
  'KID GORGEOUS',
  'KIDNEYTHIEVES',
  'KILCROPS',
  'THE KILL',
  'KILL DEVIL HILL',
  'KILL II THIS',
  'KILL THE CLIENT',
  'KILL THE KONG',
  'KILL THE LYCAN',
  'KILL THE ROMANCE',
  'KILLAMAN',
  'KILLEM',
  'KILLER BE KILLED',
  "A KILLER'S CONFESSION",
  'KILLERY',
  'KILLING JOKE',
  'KILLING MACHINE',
  'KILLING THE DREAM',
  'KILLING TOUCH',
  'KILLITOROUS',
  'KILLKOUNT',
  'KILLSWITCH ENGAGE',
  'KILLUS',
  'KILLWHITNEYDEAD',
  'KILPI',
  'KIMAERA',
  'KINETIC',
  'KING CONQUER',
  'KING CRIMSON',
  'KING DIAMOND',
  'KING GOAT',
  'KING KOBRA',
  'KING NINE',
  'KING OF ASGARD',
  'KING PARROT',
  'KING SATAN',
  "KING'S EVIL",
  "KING'S X",
  'KINGCROW',
  'KINGCRUSHER',
  'KINGDOM COME',
  'KINGDOM OF GIANTS',
  'KINGDOM OF SORROW',
  'KINGMAKER',
  'KINGSTON FALLS',
  'KIRKKOPALOVAROITUS',
  'KISS',
  "KISSIN' DYNAMITE",
  'KISTVAEN',
  'KITCHEN KNIFE CONSPIRACY',
  'KITTIE',
  'KIUAS',
  'KIVIMETSÄN DRUIDI',
  'KIX',
  'KLABAUTAMANN',
  'KLAMM',
  'KLONE',
  'KMFDM',
  "KNA'AN",
  'KNELL',
  'KNIGHT AREA',
  'KNIGHT ERRANT',
  'KNIGHTS OF ROUND',
  'KNIGHTS OF THE ABYSS',
  'KNIVES EXCHANGING HANDS',
  'KNIVES OUT',
  'KNOCKED LOOSE',
  'KNORKATOR',
  'KNUCKLEDUST',
  'KOBRA AND THE LOTUS',
  'KOLDBORN',
  'KONGH',
  'KONKHRA',
  'KONTRAVOID',
  'KONTRUST',
  'THE KOREA',
  'KORGONTHURUS',
  'KORN',
  'KOROVA',
  'KOROVAKILL',
  'KOROZY',
  'KORPIKLAANI',
  'KORSELD',
  'KORY CLARKE',
  'KORZUS',
  'KOTIPELTO',
  'KOTITEOLLISUUS',
  'KOUEN',
  'THE KOVENANT',
  'KOZELJNIK',
  'KOZIAK',
  'KRAANIUM',
  'KRABATHOR',
  'KRAKEN',
  'KRALJEVSKI APARTMAN',
  'KRALLICE',
  'KRAMP',
  'KRANTHOR',
  'KRASH RIDERS',
  'KRATORNAS',
  'KRATOS',
  'KREATOR',
  'KREIGEN',
  'KREYSKULL',
  'KRIEG',
  'KRIEGSMASCHINE',
  'KRIGERE WOLF',
  'KRISIUN',
  'KRODA',
  'KROH',
  'KROHM',
  'KROKODIL',
  'KROKUS',
  'KROMLEK',
  'KRONOS',
  'KROSIS',
  'KRUGER',
  'KRUOR',
  'KRUX',
  'KRYOBURN',
  'KRYPTERIA',
  'KRYPTOS',
  'KRYST THE CONQUEROR',
  'KRYSTOS',
  'KRÅKE',
  'KUAZAR',
  'KUBLAI KHAN',
  'KULL',
  'KULT OV AZAZEL',
  'KUOLEMANLAAKSO',
  'KUTSCHURFT',
  'KVELERTAK',
  'KVIST',
  'KWEIZAR',
  'KYLESA',
  'KYMATICA',
  'KYNG',
  'KYPCK',
  'KYUSS',
  'KYYRIA',
  'KOWAI',
  'KÄLTER'
];

const metalBandsL = [
  'LA DISPUTE',
  'LA HOGUERA',
  'LABRAT',
  'LABYRINTH',
  'LABYRINTH OF ABYSS',
  'LABYRINTHE',
  'LABYRINTHUS NOCTIS',
  'LACERATED AND CARBONIZED',
  'LACERHATE',
  'LACK OF INTEREST',
  'LACRIMAS PROFUNDERE',
  'LACRIMOSA',
  'LACRYMA SANGUINE',
  'LACUNA COIL',
  'LADY SADNESS',
  'LAETHORA',
  'LAGRIMA',
  'LAHMIA',
  'LAIBACH',
  'LAIR OF THE MINOTAUR',
  'LAKE OF TEARS',
  'LAKUPAAVI',
  'LALU',
  'LAMB OF GOD',
  'LAMENT',
  'LAMENTARI',
  'LAMENTED SOULS',
  'THE LAMP OF THOTH',
  'LAMPRAY',
  'LAND OF CHARON',
  'LANDEVIR',
  'LANDGUARD',
  'LANDMINE MARATHON',
  'LANDS OF PAST',
  'LANFEAR',
  'LANTERN',
  'LANTLÔS',
  'LAPSUS DEI',
  "LASCAILLE'S SHROUD",
  'LASH OUT',
  'THE LAST ALLIANCE',
  'LAST CHANCE TO REASON',
  'LAST CHAPTER',
  'THE LAST DAWN',
  'LAST DAYS OF HUMANITY',
  'THE LAST FELONY',
  'LAST IN LINE',
  'THE LAST KING',
  'LAST KINGDOM',
  "LAST MAN'S BREATH",
  'LAST MINUTE SEDATIVE',
  'THE LAST OF LUCY',
  'LAST ONE DYING',
  'LAST PROPHECY',
  'THE LAST TEN SECONDS OF LIFE',
  'LAST TRIBE',
  'THE LAST VOID',
  'LAVOS BECKON',
  'LAWNMOWER DETH',
  'LE GRAND GUIGNOL',
  'LEAD US FORTH',
  'LEAD WEIGHT',
  'LEADERS',
  'LEAH',
  'LEANDER RISING',
  'LEATHER NUN AMERICA',
  'LEATHERWOLF',
  "LEAVES' EYES",
  'LED ZEPPELIN',
  'LEFAY',
  'LEFT BEHIND',
  'LEFT HAND SOLUTION',
  'LEFT IN TORMENT',
  'LEFT TO THE WOLVES',
  'LEGEND',
  'LEGEND MAKER',
  'LEGENDA',
  'LEGENDA AUREA',
  'LEGENDS SHALL FALL',
  'LEGION',
  'THE LEGION',
  'THE LEGION OF DOOM',
  'THE LEGION OF HETHERIA',
  'LEGION OF THE DAMNED',
  'LEHAVOTH',
  'LEICHENZUG',
  'LELAHELL',
  'LEMUR VOICE',
  'LEMURIA',
  "LENG TCH'E",
  'LENGSEL',
  'LENORE CULT',
  'LEO JIMÉNEZ',
  'LEPROSY',
  'LEPROUS',
  'LES DISCRETS',
  'LESION',
  'LET IT FLOW',
  'LETHAL',
  'LETHARGIA',
  'LETHIAN DREAMS',
  'LETLIVE',
  'LETTER TO THE EXILES',
  'LETTERS FROM THE COLONY',
  'LETZTE INSTANZ',
  'LEVANIA',
  'LEVEL THE CITY',
  'LEVERAGE',
  'LEVIATHAN',
  'LEVITATED',
  'LEVITICUS',
  'LEX TALION',
  'LEX TALIONIS',
  'LEYENDA',
  'LIAR OF GOLGOTHA',
  'LIBERTAD O MUERTE',
  'LIBERTEER',
  'LICH KING',
  'LICKGOLDENSKY',
  'A LIE NATION',
  'LIEGE LORD',
  'LIERS IN WAIT',
  'LIES OF NAZCA',
  'LIEVEIL',
  'LIFE AS A GHOST',
  'LIFE CRIED',
  'A LIFE DIVIDED',
  'LIFE OF AGONY',
  'A LIFE ONCE LOST',
  'LIFEFORMS',
  'LIFELOVER',
  'LIFERUINER',
  'LIFVSLEDA',
  'LIGEIA',
  'LIGHT AMONG SHADOWS',
  'LIGHT BEARER',
  'LIGHT FORCE',
  'LIGHT OF DISASTER',
  'LIGHT OF NOVA',
  'THE LIGHT THE DARK',
  'LIGHT THE TORCH',
  'LIGHT THIS CITY',
  'LIK',
  'LIKE MOTHS TO FLAMES',
  'LIKE VULTURES',
  'LILITH',
  'LILITU',
  'LILLIAN AXE',
  'LILLITH',
  'LIMBONIC ART',
  'LIMP BIZKIT',
  'LINDEMANN',
  'LINE OF SCRIMMAGE',
  'LINEBACKER',
  'LINGUA MORTIS ORCHESTRA',
  'LINKIN PARK',
  "THE LION'S DAUGHTER",
  "LION'S PRIDE",
  "LION'S SHARE",
  'LIONHEART',
  'LIONS AMONG US',
  'LITA FORD',
  'LITURGY',
  'LIV KRISTINE',
  'LIVA',
  'LIVID HALCYON',
  'LIVIDITY',
  'LIVING DEATH',
  'LIVING EYES',
  'LIVING SACRIFICE',
  'LIVING VOID',
  'LIVORES MORTIS',
  'LIZZARD WIZZARD',
  'LIZZY BORDEN',
  'LO',
  'LO-PRO',
  'LOBOTOMY',
  'LOCH VOSTOK',
  'LOCK & KEY',
  'LOCK UP',
  'LOCRACY',
  'THE LOCUST',
  "LOGAR'S DIARY",
  'LOGIC OF DENIAL',
  'LOGICAL RIDDLE',
  'LOGOS',
  'LOITS',
  'LOLLIPOP LUST KILL',
  'LONDON AFTER MIDNIGHT',
  'LONEWOLF',
  'LONG DISTANCE CALLING',
  'LONGED FOR FUSION',
  'LONGFULNESS',
  'LONGING FOR DAWN',
  'LOOKING FOR AN ANSWER',
  'LOOSE LIPS SINK SHIPS',
  'LORD',
  'LORD AZMO',
  'LORD BANE',
  'LORD BELIAL',
  'LORD DYING',
  'LORD GORE',
  'LORD KAOS',
  'LORD MANTIS',
  'LORD OF THE LOST',
  'LORD VAMPYR',
  'THE LORD WEIRD SLOUGH FEG',
  'LORD WIND',
  'LORDE OF ALL DESIRES',
  'LORDES WERRE',
  'LORDI',
  'LORDIAN GUARD',
  'LORDS OF BLACK',
  'LORELEI',
  'LORIEN',
  'LORNA SHORE',
  'LOS BASTARDOS',
  'LOSS',
  'LOST EDEN',
  'LOST FORTUNE',
  'LOST HORIZON',
  'LOST IN TEARS',
  'LOST IN THOUGHT',
  'LOST INFINITY',
  'LOST SERENITY',
  'LOST SOCIETY',
  'LOST SOUL',
  'LOST SOULS',
  'LOSTPROPHETS',
  'LOTHLORIEN',
  'LOUDBLAST',
  'LOUDNESS',
  'LOVE AND DEATH',
  'LOVE HISTORY',
  'LOVE IS RED',
  'LOVE LIES BLEEDING',
  'LOVE LIKE BLOOD',
  'LOVE LOST BUT NOT FORGOTTEN',
  'THE LOVECRAVE',
  'THE LOVELESS',
  'LOVEX',
  'LUCA TURILLI',
  "LUCA TURILLI'S DREAMQUEST",
  "LUCA TURILLI'S RHAPSODY",
  'LUCIDITY',
  'LUCIFER',
  'LUCIFERIAN',
  'LUCIFERION',
  'LUCIFUGUM',
  'LUCYFIRE',
  'LUDDITE CLONE',
  'LUDICRA',
  'LUGBURZ',
  'LUGUBRUM',
  'LUJURIA',
  'LULLACRY',
  'LUMINARIA',
  'THE LUMINARY',
  'LUMINE CRIPTICA',
  'LUMSK',
  'LUNA AD NOCTUM',
  'LUNA OBSCURA',
  'LUNACYST',
  'LUNAR AURORA',
  'LUNARIS',
  'LUNATIC BRIGADE',
  'LUNATIC GODS',
  'LUNATIC SOUL',
  'LUNATICA',
  'LUNOCODE',
  'THE LURKING FEAR',
  'LUROR',
  'THE LUST I SEEK',
  'LUSTRE',
  'LUTEMKRAT',
  'LUTI-KRISS',
  'LUX FERRE',
  'LUX OCCULTA',
  'LUZBEL',
  'LVZBEL',
  'LYCANTHROPHY',
  'LYCHGATE',
  'LYCUS',
  'LYFTHRASYR',
  'LYKATHEA AFLAME',
  'LYMPHATIC PHLEGM',
  'LYRIEL',
  'LYRINX',
  'LYZANXIA',
  'LACHRIMA CORPHUS DISSOLVENS',
  'LADY MORTIS',
  'LEGADO DE UNA TRAGEDIA',
  'LÄÄZ ROCKIT',
  'LÖRIHEN'
];

const metalBandsM = [
  'MACABRA',
  'MACABRE',
  'MACABRE MINSTRELS',
  'MACABRE OMEN',
  'MACBETH',
  'MACHINAE SUPREMACY',
  'MACHINE HEAD',
  'MACHINE MEN',
  'MACHINEMADE GOD',
  'MACHINERY',
  'MACHINES OF GRACE',
  'MACTATUS',
  'MAD ARCHITECT',
  'MAD AT GRAVITY',
  'MAD JOHN THE WISE',
  'MAD SEASON',
  'MADBALL',
  'MADDER MORTEM',
  'MADE OF HATE',
  'MADINA LAKE',
  'MADRIGAL',
  'MAELSTROM',
  'MAESTRICK',
  'MAGELLAN',
  'MAGIC KINGDOM',
  'MAGICA',
  'MAGISTER DIXIT',
  'A MAGNIFICENT COLD',
  'MAGNUM FORCE',
  'MAGOR',
  'MAGRUDERGRIND',
  'MAHAKALA',
  'MAIDEN VOYAGE',
  'MAJESTIC',
  'MAJESTIC DOWNFALL',
  'MAJESTIC VANGUARD',
  'MAJESTY',
  'MAKE ME FAMOUS',
  'MAKE THEM SUFFER',
  'MAKERS',
  'MALAS',
  'MALEFACTOR',
  'MALEFICE',
  'MALEFICENTIA',
  'MALEFICUS ANGELUS',
  'MALEVOLENCE',
  'MALEVOLENT CREATION',
  'MALEVOLENTIA',
  'MALFEITOR',
  'MALICE',
  'THE MALICE',
  'MALICIA',
  'MALIGN',
  'MALIGNANCY',
  'MALIGNANT TUMOUR',
  'MALIGNO',
  'MALING',
  'MALISON ROGUE',
  'MALKUTH',
  'MALLEUS MALEFICARUM',
  'MALMONDE',
  'MALNÀTT',
  'MALPRACTICE',
  'MALÓN',
  'MAMES VINCENT',
  'MAMMOTH MAMMOTH',
  'MAMMOTH STORM',
  'MAN IS THE BASTARD',
  'MAN MUST DIE',
  'MAN TILL GOD',
  'THE MAN-EATING TREE',
  'MANDATOR',
  'MANDRAGORA SCREAM',
  'MANDRAGORE',
  'MANDROID ECHOSTAR',
  'MANES',
  'MANGLED CARPENTER',
  'MANIAC BUTCHER',
  'MANIGANCE',
  'MANILLA ROAD',
  'MANIMAL',
  'MANITOU',
  'MANNERS',
  'MANNTIS',
  'MANOWAR',
  'MANTAK',
  'MANTIC RITUAL',
  'MANTICORA',
  'MANTRIC',
  'MANTUS',
  'MANZANA',
  'MAPLE CROSS',
  'MAR DE GRISES',
  'MARAMON',
  'MARAS',
  'MARBLE ARCH',
  'MARCHE FUNÈBRE',
  'MARDUK',
  'MARE',
  'MARE COGNITUM',
  'MARFEDELOM',
  'MARIA ESCARLATA',
  'MARILLION',
  'MARILYN MANSON',
  'MARIONETTE',
  'MARKO HIETALA',
  'MAROON',
  'MARS RED SKY',
  'THE MARS VOLTA',
  'MARSHALL LAW',
  'MARTILA',
  'MARTYR',
  'MARTYR DEFILED',
  'MARTYRDOM',
  'MARTYRIUM',
  'MARUTA',
  'MARY FIELDS',
  'MASACHIST',
  'MASACRE',
  'THE MASS',
  'MASS EXTINCTION',
  'MASS HYPNOSIS',
  'MASSACRA',
  'MASSACRATION',
  'MASSACRE',
  'MASSAKRE',
  'MASSEMORD',
  'MASSGRAVE',
  'MASSIVE SLAVERY',
  'MASTER',
  'MASTER DY',
  "MASTER'S HAMMER",
  'MASTERCASTLE',
  'MASTERMIND',
  'MASTERPLAN',
  'MASTIC SCUM',
  'MASTIFAL',
  'MASTIPHAL',
  'MASTODON',
  'MASTORD',
  'MAT SINNER',
  'MATANZA',
  'MATANZICK',
  'MATRAZ',
  'MATRIARCH',
  'MATTERHORN',
  'MAUDLIN OF THE WELL',
  'MAULBURY HILL',
  'MAY RESULT',
  'MAYAN',
  'MAYHEM',
  'MAYLENE AND THE SONS OF DISASTER',
  'MAYSALOON',
  'THE MAZEIST',
  'ME AND HIM CALL IT US',
  'ME IN A MILLION',
  'THE MEADS OF ASPHODEL',
  'MEANS END',
  'MEAT MY MUM',
  'MEAT SHITS',
  'MEATHOOK SEED',
  'MEATLOCKER SEVEN',
  'MECHANICAL POET',
  'MECHANIGOD',
  'MECHINA',
  'MEDEA',
  'MEDEA RISING',
  'MEDEIA',
  'MEDIALUNA',
  'MEDICAL NEGLIGENCE',
  'MEDICATION',
  'MEDIEVAL ART',
  'MEDULLA NOCTE',
  'MEDUZA',
  'MEGADETH',
  'MEGAHERZ',
  'MEHIDA',
  'MEKANISM',
  'MEKONG DELTA',
  'MELANCHOLY CRY',
  'MELANCHOLY PESSIMISM',
  'MELANKOLY',
  'MELBA CULP',
  'MELECHESH',
  'MELIAH RAGE',
  'MELISSA',
  'MELVINS',
  'MEMENTO',
  'MEMENTO MORI',
  'A MEMORIA BROODED',
  'MEMORIAL',
  'MEMORIAM',
  'MEMORY GARDEN',
  'MEMPHIS MAY FIRE',
  'MENAM',
  'MENDEED',
  'MENHIR',
  'MENTAL CRYPT',
  'MENTAL DEMISE',
  'MENTAL HOME',
  'MEPHISTOPHELES',
  'MERAUDER',
  'MERCENARY',
  'MERCILESS',
  'MERCILESS DEATH',
  'THE MERCURY ARC',
  'MERCURY RISING',
  'MERCURY TIDE',
  'MERCY SCREAMS',
  'MERCYFUL FATE',
  'MERESSIN',
  'MERIDIAM',
  'MERKURY',
  'MERLIN',
  'MESHIAAK',
  'MESHUGGAH',
  'MESRINE',
  'MESSA',
  'MESSENGER',
  'MESSIAH',
  'MESSIAH COMPLEX',
  'MESSIAH FORCE',
  "MESSIAH'S KISS",
  'METAKIX',
  'METAL ALLEGIANCE',
  'METAL CHURCH',
  'METAL COMANDO',
  'METAL KING',
  'METALETY',
  'METALIUM',
  'METALLICA',
  'METALUCIFER',
  'METANOIA',
  'METAPRISM',
  'METEORA',
  'METH MOUTH',
  'METHYSOS',
  'METSATÖLL',
  'MEWITHOUTYOU',
  'MEZARKABUL',
  'MEZZERSCHMITT',
  'MGŁA',
  'MIASMAL',
  'MIASTHENIA',
  'MICHAEL KISKE',
  'MICHAEL SWEET',
  'MIDGARD',
  'MIDNATTSOL',
  'MIDNIGHT',
  'MIDNIGHT FUNERAL',
  'MIDNIGHT ODYSSEY',
  'MIDNIGHT REALM',
  'MIDNIGHT SUN',
  'MIDVINTER',
  'MIDWINTER',
  "MIKE LEPOND'S SILENT ASSASSINS",
  'MILES BEYOND',
  'MILES OF GRACE',
  'MILLENNIAL REIGN',
  'MINAS MORGUL',
  'MIND ASSAULT',
  'MIND COLOUR',
  'MIND ECLIPSE',
  'MIND KEY',
  'MIND ODYSSEY',
  'MIND RIOT',
  "MIND'S EYE",
  'MINDFEED',
  'MINDFIELD',
  'MINDFLOW',
  'MINDGRINDER',
  'MINDROT',
  'MINDSET',
  'MINDSNARE',
  'MINDSTAB',
  'MINDWORK',
  'MINENWERFER',
  'MINISTRY',
  'MINNERIKET',
  'MINOR THREAT',
  'MINSK',
  'MINUS',
  'MINUSHUMAN',
  'MIRROR OF DEAD FACES',
  'MIRROR OF DECEPTION',
  'MIRRORBLAZE',
  'MIRRORTHRONE',
  'MIRZADEH',
  'MISANTHROPE',
  'MISANTHROPE MONARCH',
  'MISCREANT',
  'MISERATION',
  'MISERICORDIAM',
  'MISERIUM',
  'MISERY CHASTAIN',
  'MISERY INDEX',
  'MISERY LOVES CO',
  'MISERY SIGNALS',
  'MISFITS',
  'MISFORTUNATE SONS',
  'MISS MAY I',
  'MISSA MERCURIA',
  'MISSOURI QUIET',
  'THE MIST',
  'THE MIST AND THE MORNING DEW',
  'MIST OF AVALON',
  'MIST OF THE MAELSTROM',
  'MISTELTEIN',
  'MISTERIA',
  'MISTHERIA',
  'MISTIGO VARGGOTH DARKESTRA',
  'MISTRESS',
  'MISTWEAVER',
  'MISTYFATE',
  'MISÞYRMING',
  'MITHOTYN',
  'MITHRA',
  'MITHRAS',
  'MITOCHONDRION',
  'MJÖLNIR',
  'MJØD',
  'MNEMIC',
  'THE MOANING',
  'MOB RULES',
  'MOBILE DEATHCAMP',
  'MOBY DICK',
  'THE MODERN AGE SLAVERY',
  'MODERN LIFE IS WAR',
  'MOI DIX MOIS',
  'MOKER',
  'MOKOMA',
  'MOLOTOV SOLUTION',
  'MONARCH',
  'MONARCH WOODS',
  'MONASTERY',
  'MONASTERYUM',
  'MONDSTILLE',
  'MONOLICHT',
  'MONOLITH',
  'THE MONOLITH DEATHCULT',
  'MONOLITHE',
  'MONOLORD',
  'MONSTER',
  'MONSTER MAGNET',
  'MONSTER TRUCK',
  'MONSTER VOODOO MACHINE',
  'MONSTERS',
  'MONSTROSITY',
  'MONSTRUM',
  'MONTE PITTMAN',
  'MONTULN',
  'MONUMENTAL TORMENT',
  'MONUMENTS',
  'MONUMENTUM',
  'MOON',
  'MOON OF STEEL',
  'MOONBLOOD',
  'MOONLIGHT',
  'MOONLIGHT AGONY',
  'MOONLIGHT ASYLUM',
  'MOONLIGHT AWAKENING',
  'MOONSHADE',
  'MOONSKIN',
  'MOONSORROW',
  'MOONSPELL',
  'MOONWAY',
  'MOR',
  'MORBID',
  'MORBID ANGEL',
  'MORBID DEATH',
  'MORBID REMAINS',
  'MORBID SAINT',
  'MORBOSIDAD',
  'MORBUS CHRON',
  "MORD'A'STIGMATA",
  'MORDA',
  'MORDECAI',
  'MORDOR',
  'MORDRED',
  'MORE THAN A THOUSAND',
  'MORE THAN LIFE',
  'MORGAIN',
  'MORGANA LEFAY',
  'MORGENSTERN',
  'MORGION',
  'MORGOTH',
  'MORGUL',
  'MORIA',
  'MORIFADE',
  'MORK',
  'MORK GRYNING',
  'MORKE',
  'MORKRIKET',
  'MORNE',
  'MORNING',
  'MORNING STAR',
  'THE MORNINGSIDE',
  'MORNINGSTAR',
  'MORPHIA',
  'MORRAH',
  'MORRIGAN',
  'MORS PRINCIPIUM EST',
  'MORS SUBITA',
  'MORTA SKULD',
  'MORTAL',
  'MORTAL DECAY',
  'MORTAL LOVE',
  'MORTAL SIN',
  'MORTAL TREASON',
  'MORTEM',
  'MORTEMIA',
  'MORTHEM',
  'MORTICIAN',
  'MORTIFICATION',
  'MORTIIS',
  'MORTILLERY',
  'MORTON',
  'MORTUARY',
  'MORTUARY DRAPE',
  'MORTUORIAL ECLIPSE',
  'MORTUUS',
  'MOSE GIGANTICUS',
  'MOSS',
  'MOSS OF MOONLIGHT',
  'MOST PRECIOUS BLOOD',
  'THE MOTH GATHERER',
  'MOTHER OF MERCY',
  'MOTHRA',
  'MOTIONLESS IN WHITE',
  'MOTLEY CRUE',
  'MOTOGRATER',
  'MOTORHEAD',
  'MOURN CODE',
  'MOURN IN SILENCE',
  'MOURNFUL CONGREGATION',
  'MOURNFUL GUST',
  'MOURNING BELOVETH',
  'MOURNING CARESS',
  'MOURNING HOURS',
  'MOUTH OF THE ARCHITECT',
  'MOUTH OF THE SERPENT',
  'MOUTH OF THE SOUTH',
  'MOVE LIKE ATTIS',
  'MUCKY PUP',
  'MUDVAYNE',
  'MULLMUZZLER',
  'MUMAKIL',
  'MUNDANUS IMPERIUM',
  'MUNICIPAL WASTE',
  'MURDER DEATH KILL',
  'MURDER KING',
  'THE MURDER OF MY SWEET',
  'THE MURDER OF ROSA LUXEMBURG',
  'MURDER RAPE',
  'MURDER SQUAD',
  'MURDER THERAPY',
  'MURDERDOLLS',
  'MUREAU',
  'MURK BLARE',
  'MURO',
  'MUSHROOMHEAD',
  'MUSPELHEIM',
  'MUST DIE',
  'MUSTA SURMA',
  'MUSTAN KUUN LAPSET',
  'MUSTASCH',
  'MUTED',
  'MUTIILATION',
  'MUTILATION',
  'MUTINY WITHIN',
  'MVP',
  'MY AUTUMN',
  'MY BITTER END',
  'MY CHEMICAL ROMANCE',
  'MY DARKEST DAYS',
  'MY DARKEST HATE',
  'MY DEAR ADDICTION',
  'MY DEMISE',
  'MY DYING BRIDE',
  'MY ENEMIES & I',
  'MY FAVORITE SCAR',
  'MY FAVOURITE NEMESIS',
  'MY FINAL SECOND',
  'MY FUNERAL',
  'MY HANDS ARE TIED',
  'MY HEART TO FEAR',
  'MY INSANITY',
  'MY LIFE IN RUINS',
  "MY LIFE'S DESPAIR",
  'MY OWN GRAVE',
  'MY OWN LIES',
  'MY OWN PRIVATE ALASKA',
  'MY OWN WILL',
  'MY RANSOMED SOUL',
  'MY RUIN',
  'MY SHAMEFUL',
  'MY SILENT WAKE',
  'MY SIXTH SHADOW',
  'MY THRENODY',
  'MY TICKET HOME',
  'MYCHILDREN MYBRIDE',
  'MYDGARD',
  'MYGRAIN',
  'MYKA, RELOCATE',
  'MYLIDIAN',
  'MYNDSNARE',
  'MYRATH',
  'MYRIADS',
  'MYRIDIAN',
  'MYRKGRAV',
  'MYRKSKOG',
  'MYRKUR',
  'MYSTERIIS',
  'MYSTIC CHARM',
  'MYSTIC CIRCLE',
  'MYSTIC FOREST',
  'MYSTIC PROPHECY',
  'MYSTICUM',
  'MYSTIFIER',
  'MYSTIRIUM',
  'MYTHERINE',
  'MYTHIKA',
  'MYTHOLOGICAL COLD TOWERS',
  'MYTHOPOEIA',
  'MYTHOS',
  'MYTHOSIS',
  'MALACODA',
  'MANSION',
  'MASK OF SEMBLANT',
  'METAL DESTROYER',
  'MICHAEL ROMEO',
  'MISTVEIL',
  'MONOLITH CULT',
  'MONUMENT OF MISANTHROPY',
  'MORBID PROTOTYPE',
  'MORTIFIX',
  'MÄGO DE OZ',
  'MÅNEGARM',
  'MÖNGÖL HÖRDE',
  'MØRKE',
  'MØRKET'
];

const metalBandsN = [
  'NAAKHUM',
  'NAAMAH',
  'NACHTBLUT',
  'NACHTFALKE',
  'NACHTMYSTIUM',
  'NADER SADEK',
  'NADJA',
  'NAER MATARON',
  'NAERVAER',
  'NAGELFAR',
  'NAGLFAR',
  'NAHEMAH',
  'NAIL WITHIN',
  'NAILBOMB',
  'NAILDOWN',
  'NAILS',
  'NAKKIGA',
  'NALVAGE',
  'NAMELESS ONE',
  'NANCIAL',
  'NANOWAR',
  'NANOWAR OF STEEL',
  'NAPALM DEATH',
  'NAPOLEON',
  'NARBELETH',
  'NARCOTIC WASTELAND',
  'NARGAROTH',
  'NARGATHROND',
  'NARNIA',
  'NARROWS',
  'NARZISS',
  'NASAV',
  'NASHEIM',
  'NASTY',
  'NASTY SAVAGE',
  'NASUM',
  'NATASTOR',
  'NATIONAL NAPALM SYNDICATE',
  'NATIVE CONSTRUCT',
  'NATRIUM',
  'NATTEFROST',
  'NATTFOG',
  'NATTSMYG',
  'NATTVINDENS GRAT',
  'NATURAL DEMENTIA',
  'NATURUS',
  'NAUMACHIA',
  'NAUTILUS',
  'NAUTILUZ',
  'NAYSAYER',
  'NAZGHOR',
  'NAZGUL',
  'NAZXUL',
  'NAÏVE',
  'NE OBLIVISCARIS',
  'NEAERA',
  'NEAL MORSE',
  'NEAR DEATH CONDITION',
  'NEBELHORN',
  'NEBULAR MOON',
  'NECARE',
  'NECK DEEP',
  'NECRO FOREST',
  'NECROCOCK',
  'NECRODEATH',
  'NECRODEMON',
  'NECROMANTHER',
  'NECROMANTIA',
  'NECROMASS',
  'NECRONAUTICAL',
  'NECRONOMICON',
  'NECROPHAGIA',
  'NECROPHAGIST',
  'NECROPHOBIC',
  'NECROSANCT',
  'NECROSE',
  'NECROSHINE',
  'NECROT',
  'NECROTIZE',
  'NECROVERDOSE',
  'NECROWRETCH',
  'NEED',
  'NEFARIOUS ASCENDENCY',
  'NEFARIUM',
  'NEFILIM',
  'NEFORMAT',
  'NEGATIONIST',
  'NEGATIVA',
  'NEGATIVE',
  'NEGATIVE PLANE',
  'NEGATOR',
  'NEGLECTED FIELDS',
  'NEGLIGENT GENOCIDE',
  'NEGURA BUNGET',
  'NEHËMAH',
  'NEKROGOBLIKON',
  'NEKROKRAFT',
  'NEKROMANTHEON',
  'NEMBIENCE',
  'NEMBRIONIC',
  'NEMBRIONIC HAMMERDEATH',
  'NEMECIC',
  'NEMESEA',
  'NEMESIS',
  'NEOANDERTALS',
  'NEOGENESIS',
  'NEOLITH',
  'NEOLITHIC',
  'THE NEOLOGIST',
  'THE NEON HOOKERS',
  'NEON SYNTHESIS',
  'NEONIRICO',
  'NEOPLASMAH',
  'NEOSIS',
  'NEPHASTH',
  'NEPHELIUM',
  'NEPHENZY CHAOS ORDER',
  'NEPHTYS',
  'NEPTUNIZE',
  'NERANATURE',
  'NERGARD',
  'NERO DI MARTE',
  'NERO ORDER',
  'NERON KAISAR',
  'NERVE END',
  'NERVECELL',
  'NERVOSA',
  'NETFASTCORE',
  'NETHERBIRD',
  'NETHERION',
  'THE NETWORK',
  'NEURALIZER',
  'NEURAXIS',
  'NEURONSPOILER',
  'NEUROSIS',
  'NEUROTECH',
  'NEUROTIC',
  'NEUROTIC MIRAGE',
  'NEVEA TEARS',
  'NEVERBORNE',
  'NEVERLAND',
  'NEVERMORE',
  'A NEW CHALLENGER APPROACHES',
  'A NEW DAWN',
  'NEW DAWN FOUNDATION',
  'NEW EDEN',
  'THE NEW ESCAPE',
  'NEW WORLD ORDER',
  'NEW YORK',
  'NEWSTED',
  'NEXILVA',
  'NEXUS INFERIS',
  'NICODEMUS',
  'NIDINGR',
  'NIGH UNGODLY',
  'NIGHT CONQUERS DAY',
  'NIGHT DEMON',
  'NIGHT IN GALES',
  'A NIGHT IN TEXAS',
  'NIGHTBRINGER',
  'NIGHTCHAINS',
  'NIGHTFALL',
  'NIGHTINGALE',
  'NIGHTKARNATION',
  'NIGHTKIN',
  'NIGHTLAND',
  'NIGHTLY GALE',
  'NIGHTMARE',
  'NIGHTRAGE',
  'NIGHTREALM',
  'NIGHTS LIKE THESE',
  'NIGHTS OF MALICE',
  'NIGHTSHADE',
  'NIGHTSIDE',
  'NIGHTSTICK',
  'NIGHTWISH',
  'NIGHTWÖLF',
  'NIHIL OBSTAT',
  'NIHILI LOCUS',
  'NIHILISTIKRYPT',
  'NIHTERNNES',
  'NILE',
  'NINE',
  'NINE INCH NAILS',
  'NINGIZZIA',
  'NINNGHIZHIDDA',
  'NINNUAM',
  'NIOBETH',
  'NIRVANA',
  'NIVAIRA',
  'NIÐAFJÖLL',
  'NO ALTARS',
  'NO BRAGGING RIGHTS',
  'NO COMMENT',
  'NO INNOCENT VICTIM',
  'NO LIVING WITNESS',
  'NO OMEGA',
  'NO REASON TO LIVE',
  'NO RETURN',
  'NO VALUE',
  'NO VICTORY',
  'NO ZODIAC',
  'NOCTE OBDUCTA',
  'NOCTEM',
  'NOCTEM AETERNUS',
  'NOCTERNITY',
  'NOCTES',
  'NOCTIFERIA',
  'NOCTIS INVOCAT',
  'NOCTUARY',
  'NOCTURNAL BREED',
  'NOCTURNAL DEPRESSION',
  'NOCTURNAL DEVOTION',
  'NOCTURNAL FEAR',
  'NOCTURNAL RITES',
  'NOCTURNAL SACRIFICE',
  'NOCTURNAL WINDS',
  'NOCTURNAL WORSHIPPER',
  'NOCTURNUS',
  'NODE',
  'NODES OF RANVIER',
  'NOEKK',
  'NOGROD',
  'NOHESTH DE GROTH',
  'NOISE THERAPY',
  'NOISEM',
  'NOITUMA',
  'NOKTURNAL MORTUM',
  'NOKTURNEL',
  'NOLI ME TANGERE',
  'NOMAD',
  'NOMANS LAND',
  'NOMENMORTIS',
  'NOMENTORY',
  'NOMINON',
  'NON SERVIAM',
  'NONEXIST',
  'NONEXISTENCE',
  'NONPOINT',
  'NOOSE',
  'NORA',
  'NORDAVIND',
  'NORDGLANZ',
  'NORDHEIM',
  'NORDIC UNION',
  'NORDJEVEL',
  'NORDVYKK',
  'NORMA JEAN',
  'NORTH',
  'NORTHER',
  'NORTHERN GHOST',
  'NORTHERN KINGS',
  'THE NORTHERN ONTARIO BLACK METAL PRESERVATION SOCIETY',
  'NORTHLAND',
  'NORTHLANE',
  'NORTHWIND WOLVES',
  'NORTT',
  'NOSFERATU',
  'NOSTRADAMEUS',
  'NOSTROMO',
  'NOT ONE IS UPRIGHT',
  'NOTHGARD',
  'NOTHING LEFT',
  'NOTHING MORE',
  'NOTHING REMAINS',
  'NOTHING TIL BLOOD',
  'NOTHINGFACE',
  'NOTRE DAME',
  'NOTT',
  'NOTURNALL',
  'NOUMENA',
  'NOVARUPTA',
  'NOVELISTS',
  'NOVEMBERS DOOM',
  'NOVEMBRE',
  'NOW EVERYTHING FADES',
  'NOX',
  'NOX AUREA',
  'NOX INTEMPESTA',
  'NOXIOUS',
  'NOYE',
  'NUCLEAR',
  'NUCLEAR ASSAULT',
  'NUCLEAR BLACK',
  'NUCLEAR BLAST ALLSTARS',
  'NUCLEAR DEATH',
  'NUGENT, TED',
  'NUIT NOIRE',
  'NUM SKULL',
  'THE NUMBER TWELVE LOOKS LIKE YOU',
  'NUMBERS',
  'NUMEN',
  'NUMINOUS',
  'NUNSLAUGHTER',
  'NUX VOMICA',
  'NYAME',
  'NYDVIND',
  'NYKTALGIA',
  'NEONFLY',
  'NORTHERN GENOCIDE',
  'NUREZ',
  'NÀTTSÒL',
  'NÉANT',
  'NÍUNDI',
  'NÖRTHWIND'
];

const metalBandsO = [
  'OF THE WAND AND THE MOON',
  "O'BROTHER",
  "O'KINGDOM",
  'OAK PANTHEON',
  'OAKENSHIELD',
  'OAKHELM',
  'THE OATH',
  'OATHBREAKER',
  'OATHEAN',
  'OBERRIS',
  'OBEY THE BRAVE',
  'OBITUARY',
  'OBLITERATE',
  'OBLITERATIONS',
  'OBLIVEON',
  'OBLIVION',
  'OBLOMOV',
  'OBNOXIOUS',
  'OBRERO',
  'OBSCENE EULOGY',
  'OBSCURA',
  'OBSCURCIS ROMANCIA',
  'AN OBSCURE SIGNAL',
  'OBSCURITY',
  'OBSEQUIAE',
  'THE OBSESSED',
  'OBSIDIAN GATE',
  'OBSIDIAN KINGDOM',
  'OBSIDIAN SHELL',
  'OBSIDIAN TIDE',
  'OBSKURE TORTURE',
  'OBSOLETE THEORY',
  'OBTAINED ENSLAVEMENT',
  'OBTEST',
  'OBVURT',
  'OBÚS',
  'OCCULT',
  'THE OCEAN',
  'AN OCEAN BETWEEN US',
  'OCEANA',
  'OCEANO',
  'OCEANS ATE ALASKA',
  'OCEANS OF SADNESS',
  'OCEANS RED',
  'OCTAVIA SPERATI',
  'OCTINOMOS',
  'OCTOBER FALLS',
  'OCTOBER TIDE',
  'OCTOPUS LILIUM',
  'ODD CREW',
  'ODD PROJECT',
  'ODDLAND',
  'ODES OF ECSTASY',
  "ODIN'S COURT",
  'ODIO SU TELA',
  'ODIOUS',
  'ODIOUS MORTEM',
  'ODIOUS SANCTION',
  'ODIUM',
  'ODIØ',
  'ODROERIR',
  'ODYSSEA',
  'OF DIVINITY',
  'OF GLACIERS',
  'OF GRAVES AND GODS',
  'OF INFINITY',
  'OF MAN AND MACHINE',
  'OF MICE & MEN',
  'OF VIRTUE',
  'OFERMOD',
  'OFFERTORIUM',
  'OFFICIUM TRISTE',
  'THE OFFSPRING',
  'OFÄRD',
  'OGARYA',
  'OGRATH',
  'OGRE',
  'OH, SLEEPER',
  'OHGR',
  'OKSANAT',
  'OKULAR',
  'OLD',
  'THE OLD DEAD TREE',
  'OLD FOREST',
  'OLD FUNERAL',
  'OLD MAN GLOOM',
  "OLD MAN'S CHILD",
  'OLD NIGHT',
  'OLD SEASON',
  'OLD WOUNDS',
  'OLIVER MAGNUM',
  'OLYMPOS MONS',
  'OM',
  'OMARI',
  'OMEGA CENTAURI',
  'THE OMEGA EXPERIMENT',
  'OMEGA LITHIUM',
  'THE OMEGA MAN',
  'OMEN',
  'OMINOUS GRIEF',
  'OMNIA',
  'OMNICIDE',
  'OMNISPAWN',
  'OMNIUM GATHERUM',
  'ON BROKEN WINGS',
  'ON SOLID GROUND',
  'ON THORNS I LAY',
  'ONCE DEAD',
  'ONCE FORGOTTEN',
  'ONCE HUMAN',
  'ONDSKAPT',
  'ONE DEAD THREE WOUNDED',
  'ONE KING DOWN',
  'ONE LAST LOOK',
  'ONE MAN ARMY AND THE UNDEAD QUARTET',
  'ONE MINUTE SILENCE',
  'ONE MORE VICTIM',
  'ONE MORNING LEFT',
  'ONE SENSE TOO MUCH',
  'ONE TRUE REASON',
  'ONE WITHOUT',
  'ONE YEAR LATER',
  'ONE-EYED DOLL',
  'ONESIDEZERO',
  'THE ONGOING CONCEPT',
  'ONIRICIDE',
  'ONIRIK',
  'ONLY LIVING WITNESS',
  'ONMYOUZA',
  'ONSLAUGHT',
  'ONWARD',
  'ONWARD TO OLYMPAS',
  'ONYRIA',
  'OOMPH',
  'OPERA DIABOLICUS',
  'OPERA IX',
  'OPERA MAGNA',
  'OPETH',
  "THE OPHELIA'S REVENGE",
  'OPHIDIAN I',
  'OPHIS',
  'OPHTHALAMIA',
  'OPPRESSOR',
  'THE OPPRESSOR',
  'OPUS DORIA',
  'ORACLE',
  'ORAKLE',
  'ORAL FISTFUCK',
  'ORANGE GOBLIN',
  'ORANSSI PAZUZU',
  'ORATOR',
  'ORATORY',
  'ORBIT CULTURE',
  'ORCHID',
  'ORCIVUS',
  'ORCLÄND',
  'ORDALIUM',
  'ORDEN OGAN',
  'ORDER FROM CHAOS',
  'THE ORDER OF ELIJAH',
  'ORDER OF ENNEAD',
  'ORDER OF ISAZ',
  'ORDER OF THE EBON HAND',
  'ORDINANCE',
  'ORDO DRACONIS',
  'ORDO EQUILIBRIO',
  'ORDOG',
  'ORESTES',
  'ORGANIC INFEST',
  'ORGANIZED CHAOS',
  'ORGONE',
  'ORIENT FALL',
  'ORIGIN',
  'ORION RIDERS',
  "ORION'S REIGN",
  'ORKRIST',
  'ORODRUIN',
  'ORPHAN',
  'ORPHANAGE',
  'ORPHANED LAND',
  'ORPHEUS BLADE',
  'ORPHEUS OMEGA',
  'ORPHONIC ORCHESTRA',
  'ORTHANC',
  'ORTHODOX',
  'OSCULUM INFAME',
  'OSI',
  'OSIAH',
  'OSIAN',
  'OSSASTORIUM',
  'OSTURA',
  'OTARGOS',
  'OTEP',
  'OTYG',
  'OUR ANCHORED HEARTS',
  'OUR CITY SKYLINE',
  'OUR HAUNTED KINGDOM',
  'OUR HOLLOW, OUR HOME',
  'OUR LAST CRUSADE',
  'OUR LAST NIGHT',
  'OUROBOROS',
  'OURS',
  'OUTLINE IN COLOR',
  'OUTRUN THE SUNLIGHT',
  'THE OUTSIDE',
  'OUTWORLD',
  'OV DUST',
  'OV HELL',
  'OVERCAST',
  'OVERCOME',
  'OVERDOSE',
  'OVERDREAM',
  'OVERFLASH',
  'OVERHAUL',
  'OVERKILL',
  'OVERLIFE',
  'OVERLORDE',
  'OVERMASTER',
  'THE OVERMIND',
  'OVERPAIN',
  'THE OVERSEER',
  'OVERSOUL',
  'OVERTHROW',
  'OVERTHROWER',
  "OVID'S WITHERING",
  'OWN OMNIPRESENCE',
  'OXIDANT',
  'OZ',
  'OZZY OSBOURNE',
  'OBSIDIAN SEA',
  'OMICIDA',
  'ONYSUS',
  'ØSCILLATÖR'
];

const metalBandsP = [
  'PAEAN',
  'PAGAN ALTAR',
  'PAGAN LORN',
  'PAGAN MEGALITH',
  'PAGAN SPIRIT',
  "PAGAN'S MIND",
  'PAGANIZER',
  'PAIN',
  'PAIN CONFESSOR',
  'PAIN OF SALVATION',
  'PAINFUL MEMORIES',
  'PAINGOD',
  'PAINTED IN EXILE',
  'PAKISTUF',
  'PALACE',
  'PALANTIR',
  'PALE DIVINE',
  'PALE FOREST',
  'A PALE HORSE NAMED DEATH',
  'PALEHORSE',
  'PALISADES',
  'PALLBEARER',
  'PALMS',
  'PANDAEMONIUM',
  'PANDEMIA',
  'PANDEMONIUM',
  'PANOPTICON',
  'PANTERA',
  'PANTHEIST',
  'PANTOKRATOR',
  'PANTOMMIND',
  'PANZER',
  'PAPA ROACH',
  'PARADIGMA',
  'PARADISE IN EXILE',
  'PARADISE LOST',
  'PARADOX',
  'PARAGON',
  'PARAGON OF BEAUTY',
  'PARAGON ZERO',
  'PARALITIKOS',
  'PARALLEL MINDS',
  'PARALYSIS',
  'PARAMAECIUM',
  'THE PARAMEDIC',
  'PARIAH',
  'PARISH',
  'PARKWAY DRIVE',
  'PAROXYSM',
  'PASSAGE',
  'PASSENGER',
  'A PAST UNKNOWN',
  'PATH OF DESTINY',
  'PATH OF GOLCONDA',
  'PATH OF NO RETURN',
  'PATH OF RESISTANCE',
  'PATHFINDER',
  'PATHOGEN',
  'PATHOLOGIST',
  'PATHOLOGY',
  'PATHOS',
  'PATHS OF POSSESSION',
  'PATRIA',
  "PAUL DI'ANNO",
  'PAUL STANLEY',
  'PAY NO RESPECT',
  "PAYNE'S GRAY",
  "PAYSAGE D'HIVER",
  'PAZUZU',
  'PEARL JAM',
  'PECCATUM',
  'PEGASUS',
  'PEGAZUS',
  'PELLEK',
  'PENANCE',
  'PENDRAGON',
  'PENETRALIA',
  'PENITENT',
  'PENNYWISE',
  'PENSÉES NOCTURNES',
  'PENTACLE',
  'PENTAGRAM',
  'PENTAKILL',
  'PENUMBRA',
  'PERDITION',
  'PERDITOR',
  'PERENNIAL ISOLATION',
  'A PERFECT CIRCLE',
  'A PERFECT MURDER',
  'PERGAMUM',
  'PERGANA',
  'PERIHELION',
  'PERIPHERY',
  'PERSEFONE',
  'PERSEUS',
  'PERSEVERANCE',
  'PERSEVERER',
  'PERSONA',
  'PERSONAL WAR',
  'PERSUADER',
  'PERTNESS',
  'PERVY PERKIN',
  'PERZONAL WAR',
  'PESSIMIST',
  'PEST',
  'PESTE NOIRE',
  'PESTILENCE',
  'PETRICHOR',
  'PETRICOR',
  'PETROGLYPHS',
  'PETTALOM',
  'PHALLUSKULT',
  'PHANTASM',
  'PHANTASMA',
  'PHANTASMA',
  'PHANTOM',
  'PHANTOM BLUE',
  'PHANTOM ELITE',
  'PHANTOM SERENADE',
  'PHARAOH',
  'PHASE',
  'PHILM',
  'PHILOSOPHER',
  'PHINEHAS',
  'PHLEBOTOMIZED',
  'PHOBIA',
  'PHOENIX MOURNING',
  'PHOENIX REIGN',
  'PHOENIX RISING',
  'PHOENIX RIZING',
  'PHOTOPHOBIA',
  'PHYREXIA',
  'PHYSICAL NOISE',
  'PIANOS BECOME THE TEETH',
  'PICTURE',
  'PIERCE THE VEIL',
  'PIG',
  'PIG DESTROYER',
  'PIK',
  'PILEDRIVER',
  'PILGRIM',
  'PILLORIAN',
  'PIN DROP VIOLENCE',
  'PIN-UP WENT DOWN',
  'PINKLY SMOOTH',
  'PISSING RAZORS',
  'PITBULLS IN THE NURSERY',
  'PITCH BLACK',
  'PITCHSHIFTER',
  'PIVUT',
  'PLACE OF SKULLS',
  'PLACE VENDOME',
  'PLAGA',
  'PLAGIS',
  'PLAGUE',
  'THE PLAGUE',
  'PLAGUE BEARER',
  'PLAGUE THROAT',
  'PLAGUE WIDOW',
  'PLAGUEIST',
  'PLANET AIDS',
  'PLANETARY COLLISION',
  'PLANETARY DIVIDE',
  'PLANKS',
  'THE PLASMARIFLE',
  'PLASTICBAG FACEMASK',
  'PLATITUDE',
  'A PLEA FOR PURGING',
  'PLEBEIAN GRANDSTAND',
  'PLETHORA',
  'PLEYMO',
  'THE PLOT IN YOU',
  'PLOWSHARE',
  'PNEUMA',
  'POCCOLUS',
  'POEMA ARCANUS',
  'POETS OF THE FALL',
  'POINT BELOW ZERO',
  'POINTED MUTATION',
  'POISON',
  'POISON THE WELL',
  'POISONBLACK',
  'POLARIS',
  'POLKADOT CADAVER',
  'POLLUTED INHERITANCE',
  'POLTERGEIST',
  'THE POODLES',
  'POP EVIL',
  'PORCUPINE TREE',
  'PORTAL',
  'PORTRAIT',
  'POSMRTNA LITURGIJA',
  'POSSESSED',
  'POSTHUMAN ABOMINATION',
  'THE POSTMAN SYNDROME',
  'POSTMORTEM',
  'POSTMORTEM PROMISES',
  'POTENTIAM',
  "POVERTY'S NO CRIME",
  'POWER',
  'POWER OF GROUND',
  'POWER OF OMENS',
  'POWER QUEST',
  'POWER SYMPHONY',
  'POWER TRIP',
  'POWERGOD',
  'POWERMAD',
  'POWERWOLF',
  'POWERWORLD',
  'PRAETORIAN PLATOON',
  'PRAY FOR LOCUST',
  'PRAY FOR MERCY',
  'PRAY FOR PAIN',
  'PRAY FOR THE KING',
  'PRAYER FOR CLEANSING',
  'PRAYING MANTIS',
  'PREMONITIONS OF WAR',
  'PREPARED LIKE A BRIDE',
  'PRESUMPTION ARC',
  'PRETTY MAIDS',
  'THE PRETTY RECKLESS',
  'PREVAIL IN DARKNESS',
  'PREY FOR NOTHING',
  'PRICE OF BLOOD',
  'PRIDE & GLORY',
  'PRIDELANDER',
  'PRIESTESS',
  'PRIMAL FEAR',
  'PRIMAL ROCK REBELLION',
  'PRIMAL SCREAM',
  'PRIMATE',
  'PRIME TIME',
  'PRIMITIVE MAN',
  'PRIMORDIAL',
  'PRIMUS',
  'PRISON',
  'THE PRISONERS DILEMMA',
  'PRO-PAIN',
  'PROBOT',
  'PROCAOS',
  'PROCESS OF GUILT',
  'PROCESSION',
  'PROCREATOR',
  'PRODUCT OF HATE',
  'PROFANE OMEN',
  'PROFANUM',
  'PROFECIA',
  'PROFESSOR PRESTOME UNGYOBROCK',
  'PROFETUS',
  'PROFOUND',
  'PROFUGUS MORTIS',
  'PROGHMA-C',
  'PROGNOSIS',
  'PROJECT BEASTS',
  'THE PROJECT HATE MCMXCIX',
  'PROJECT SILENCE',
  'PROJECTO',
  'PROLETARIAT',
  'PROMONTORY',
  'PRONG',
  'PROPHANITY',
  'PROPHECY',
  'THE PROPHECY',
  'PROPHECY OF DOOM',
  'PROPHETIC AGE',
  'PROPHETS OF RAGE',
  'PROPHILAX',
  'PROSTITUTE DISFIGUREMENT',
  'PROTEAN',
  'PROTECTOR',
  'PROTEST THE HERO',
  'PROTOTYPE',
  'PROVECTUS',
  'THE PROVENANCE',
  'PRYMARY',
  'PSALM',
  'PSICORRAGIA',
  'PSILOCYBE LARVAE',
  'PSYBORG CORP',
  'PSYCHO',
  'PSYCHO MOTEL',
  'PSYCHOGOD',
  'PSYCHOSTICK',
  'PSYCHOTIC WALTZ',
  'PSYCLON NINE',
  'PSYCRENCE',
  'PSYCROPTIC',
  'PSYKDOM',
  'THE PSYKE PROJECT',
  'PSYOPUS',
  'PUISSANCE',
  'PULLING TEETH',
  'PULVIS ET UMBRA',
  'PUNCH',
  'PUNGENT STENCH',
  'PURGATOIRE',
  'PURGATORY',
  'PURGE',
  'PURIFIED IN BLOOD',
  'PURITY',
  'PURTENANCE',
  'PURULENT MUTATION',
  'PURULENT SPERMCANAL',
  'PURUSAM',
  'PUTRID CUNT',
  'PUTRID PILE',
  'PUTRIDITY',
  'PYOGENESIS',
  'PYRAMAZE',
  'PYREXIA',
  'PYRITHION',
  'PYROPHOBIA',
  'PYRRHON',
  'PYTHIA',
  'PYTHON',
  'PALESLOTH',
  'PHENOMY',
  'POWER WITHIN',
  'PRESSOR',
  'PROMETHEAN',
  'PUREST OF PAIN'
];

const metalBandsQ = [
  'QANTICE',
  'QNTAL',
  'QUADRIVIUM',
  'QUALM',
  'QUANTICE NEVER CRASHED',
  'QUEENS OF THE STONE AGE',
  'QUEENSRYCHE',
  'QUICKSAND DREAM',
  'QUIET RIOT',
  'THE QUILL',
  'QUORTHON',
  'QUO VADIS'
];

const metalBandsR = [
  'RAATE',
  'RAATOMIELI',
  'RABIES CASTE',
  'RACCOON CITY MASSACRE',
  'RACER X',
  'RADAKKA',
  'RADIGOST',
  'RADOGOST',
  'RAFFLESIA',
  'RAGE',
  'RAGE AGAINST THE MACHINE',
  'RAGE NUCLÉAIRE',
  'RAGE OF ANGELS',
  'RAGEBORNE',
  'RAGING SPEEDHORN',
  'RAGNAROK',
  'THE RAGNAROK PROPHECY',
  'RAHOWA',
  'RAIJU',
  'RAIN DELAY',
  'RAIN FELL WITHIN',
  'RAINBOW',
  'RAINTIME',
  'RAISE HELL',
  'RAISED FIST',
  'RAISING FEAR',
  'RAISING THE VEIL',
  'RAISM',
  'RAKOTH',
  'RAM',
  'RAM-ZET',
  'RAMALLAH',
  'RAME',
  'RAMESSES',
  'RAMMING SPEED',
  'RAMMSTEIN',
  'RAMP',
  'RANDOMWALK',
  "RAPHEUMET'S WELL",
  'RAPID STRIKE',
  'RAPTURE',
  'RASTA',
  'RATA BLANCA',
  'RATOS DE PORÃO',
  'RATT',
  'RAUBTIER',
  'RAUHNÅCHT',
  'THE RAUNCHOUS BROTHERS',
  'RAUNCHY',
  'RAVAGER',
  'RAVEN',
  'THE RAVEN AUTARCHY',
  'RAVEN WOODS',
  'RAVENCULT',
  'RAVENFACE',
  'RAVENIA',
  'RAVENLAND',
  'THE RAVENOUS',
  'RAVENS THRONE',
  'RAVENSIRE',
  'RAVENTHRONE',
  'RAWHEAD REXX',
  'RAXAR',
  'RAY ALDER',
  'RAZONES CONCIENTES',
  'RAZOR',
  'RAZOR INC',
  'RE-ARMED',
  'REACH THE SHORE',
  'REALM',
  'REALMBUILDER',
  'REASON',
  'REBAELLIUN',
  'REBEL MEETS REBEL',
  'REBELLION',
  'REBIRTH THE AEONS',
  'REBOOT THE SYSTEM',
  'RECIPROCAL',
  'RECKONING HOUR',
  'RECON',
  'RECYCLING THE DEAD',
  'RED',
  'THE RED CHORD',
  'RED CIRCUIT',
  'THE RED DEATH',
  'RED DESCENDING',
  'RED FANG',
  'RED FLAG CREW',
  'RED HARVEST',
  'RED HILLS',
  'THE RED JUMPSUIT APPARATUS',
  'RED KUNZ',
  'A RED NIGHTMARE',
  'RED SEAS FIRE',
  'THE RED SHORE',
  'RED SKIES',
  'RED TIDE',
  'RED WINE',
  'REDEEMER',
  'REDEMPTION',
  'REDFOG',
  'REFLECTION',
  'REFLECTIONS',
  'REFLEXION',
  'REFLUX',
  'REFORMERS',
  'REGAIN THE LEGACY',
  'REGARDE LES HOMME TOMBER',
  'REGIONS',
  'REGNUM UMBRA IGNIS',
  'REGURGITATE',
  'REIGN',
  'REIGN OF THE ARCHITECT',
  'REIGN SUPREME',
  'REINFECTION',
  'REINKAOS',
  'REINXEED',
  'RELLIK',
  'REMEMBERING NEVER',
  'REMEMBRANCE',
  'REMOVER',
  'RENASCENT',
  'RENOUNCED',
  'REPTILE',
  'REPTILIAN',
  'REPUGNANT',
  'REPULSION',
  'REQUIEM',
  'REQUIEM AETERNAM',
  'RESIGN FIRST RESPONDER',
  'RESIST THE THOUGHT',
  'THE RESISTANCE',
  'RESISTENSI',
  'REST AMONG RUINS',
  'REST IN DUST',
  'RESTLESS',
  'RESURRECTION',
  'RESURRECTURIS',
  'RETALIATION',
  'RETCONSTRUCT',
  'RETURN FROM EXILE',
  'RETURN TO INNOCENCE',
  'RETURNING WE HEAR THE LARKS',
  'REV THEORY',
  'REVAMP',
  'REVEILLE',
  'REVEL IN FLESH',
  'REVELATION',
  'REVENANCE',
  'REVENGE',
  'THE REVENGE PROJECT',
  'REVENWOLF',
  'REVEREND',
  'REVEREND BIZARRE',
  'REVOCATION',
  'REVOLTED MASSES',
  'REVOLTONS',
  'REVOLUTION RENAISSANCE',
  'REVOLUTION WITHIN',
  'REVONTULET',
  'REX',
  'REYTORO',
  'RHAPSODY',
  'RHAPSODY OF FIRE',
  'RHASALON',
  'RHINO',
  'RHYMES OF DESTRUCTION',
  'RIBSPREADER',
  'RIDDLEBREAK',
  'RIDE THE SKY',
  'RIFFTERA',
  'RIFLES AT RECESS',
  'RIGER',
  'RIGHTEOUS PIGS',
  'RIGHTEOUS VENDETTA',
  'RIGOR MORTIS',
  'RIGOR SARDONICOUS',
  'RIMFROST',
  'RING OF FIRE',
  'RINGS OF SATURN',
  'RINGWORM',
  'RINOA',
  'RIOT',
  'RIOT GAMES',
  'RIOTGOD',
  'RIPIO',
  'RIPPER',
  'RIPPING CORPSE',
  'RISE AGAINST',
  'RISE AND SHINE',
  'RISE OF ALARIC',
  'RISE OF THE NORTHSTAR',
  'RISE TO FALL',
  'RISE TO REMAIN',
  'RISHLOO',
  'RISING',
  'RISK',
  'THE RISK TAKEN',
  'RITUAL',
  'THE RITUAL',
  'RITUAL CARNAGE',
  'RIUL DOAMNEI',
  'RIVAL',
  'RIVAL CHOIR',
  'RIVENDELL',
  'RIVER OF CHANGE',
  'RIVERS OF NIHIL',
  'RIVERSIDE',
  'ROADRUNNER UNITED',
  'ROB ROCK',
  'ROB ZOMBIE',
  'THE ROCKING DILDOS',
  'THE RODS',
  'ROGUE EMPIRE',
  'ROLAND GRAPOW',
  'ROLO TOMASSI',
  'ROMEO MUST DIE',
  'ROMERO',
  'ROMPEPROP',
  'THE ROOM COLORED CHARLATAN',
  'ROOM WITH A VIEW',
  'ROOT',
  'RORSCHACH TEST',
  'ROSE FUNERAL',
  'ROSETTA',
  'ROSICRUCIAN',
  'ROSS THE BOSS',
  'ROSSOMAHAAR',
  'THE ROTTED',
  'ROTTEN SOULS',
  'ROTTEN SOUND',
  'ROTTENNESS',
  'ROTTENPERISH',
  'ROTTREVORE',
  'ROUGH SILK',
  'ROUTASIELU',
  'ROUTES',
  'THE ROYAL',
  'ROYAL HUNT',
  'ROYAL JESTER',
  'ROYAL THUNDER',
  'RUDHIRA',
  'RUDRA',
  'RUINATION',
  'THE RUINS OF BEVERAST',
  'RUINTHRONE',
  'RUMBLE MILITIA',
  'RUMPELSTILTSKIN GRINDER',
  'RUNE',
  'RUNEMAGICK',
  'RUNIC',
  'RUNNING WILD',
  'RUOSKA',
  'RUPTURE',
  "RUSSELL ALLEN'S ATOMIC SOUL",
  'RUTHLESS',
  'RWAKE',
  'RXYZYXR',
  'RYTMIHÄIRIÖ',
  'RIOT V',
  'RISE OF AVERNUS',
  'RIVERWOOD',
  'ROTTING FLESH',
  'RUE',
  'RÊVERIE'
];

const metalBandsS = [
  'SAATTUE',
  'SABAOTH',
  'SABATON',
  'SABBAT',
  'SABERTOOTH ZOMBIE',
  'SABHANKRA',
  'SABRETOOTH',
  'SACRAMENTO',
  'SACRAMENTUM',
  'SACRED OATH',
  'SACRED REICH',
  'SACRED RITE',
  'SACRED STEEL',
  'SACRED WARRIOR',
  'SACRIFICE',
  'SACRIFICIUM',
  'SACRIFICIUM CARMEN',
  'SACRILEGE',
  'SACRIPHYX',
  'SACRIST',
  'SAD THEORY',
  'SAD WHISPERINGS',
  'SADGIQACEA',
  'SADIST',
  'SADISTIC INTENT',
  'SADNESS',
  'SADUS',
  'SAETIA',
  'THE SAFETY FIRE',
  'SAFFAR',
  'SAHG',
  'SAIDIAN',
  'SAIGON KICK',
  'SAILLE',
  'SAINT',
  'SAINT AVARICE',
  'SAINT DEAMON',
  'SAINT VITUS',
  'SAINTS OF EDEN',
  'SALACIOUS GODS',
  'SALAMANDRA',
  'SALDUIE',
  'SALEM',
  'SALIVA',
  'SALOME',
  'SALT THE WOUND',
  'SALTATIO MORTIS',
  'SALTUS',
  'SAMAEL',
  'SAMHAIN',
  'SAMIR YILMAZ',
  'SAMMATH',
  'SAMOTHRACE',
  'SAMSAS TRAUM',
  'SAMSON',
  'SANATORIUM',
  'SANCTIFICA',
  'SANCTIFICATION',
  'SANCTIFIER',
  'SANCTIMONY',
  'SANCTITY',
  'SANCTUARY',
  'SANGRE MALDITA',
  'SANGUIS',
  'SANHEDRIN',
  'SANISICKATION',
  'SAOR',
  'SAPROFFAGO',
  'SAQQARA',
  'SARAH JEZEBEL DEVA',
  'SARAH WHERE IS MY TEA',
  'SARATOGA',
  'SARCASTIC',
  'SARCOLYTIC',
  'SARCOPHAGUS',
  'THE SARCOPHAGUS',
  'SARCÓFAGO',
  'SARDONYX',
  'SAREA',
  'SARGATANAS REIGN',
  'SARGEIST',
  'SARKE',
  'SAROF',
  'SARPA',
  'SARPANITUM',
  'SATAN',
  "SATAN'S BLOOD",
  "SATAN'S HOST",
  "SATAN'S MORGUE",
  "SATAN'S PENGUINS",
  'SATANI INFERNALIS',
  'SATANIC HATRED',
  'SATANIC WARMASTER',
  'SATARIAL',
  'SATARIEL',
  'SATHANAS',
  'SATIFER',
  'SATURNUS',
  'SATYRASIS',
  'SATYRIAN',
  'SATYRICON',
  'SAUROM',
  'SAUROM LAMDERTH',
  'SAURUXET',
  'SAVAGE',
  'SAVAGE CIRCUS',
  'SAVAGE GRACE',
  'SAVAGE MESSIAH',
  'SAVAOTH',
  'SAVATAGE',
  'THE SAVING',
  'SAVING GRACE',
  'SAVIOUR',
  'SAVIOUR MACHINE',
  'SAWHILL SACRIFICE',
  'THE SAWTOOTH GRIN',
  'SAXON',
  'SAYYADINA',
  'SAÜC',
  'SCALPTURE',
  'SCAMP',
  'SCANNER',
  'SCAPEGOAT',
  'SCAR CULTURE',
  'SCAR OF THE SUN',
  'SCAR SYMMETRY',
  'SCAR THE MARTYR',
  'SCAR THE SURFACE',
  'SCARAB',
  'SCARCROSS',
  'SCARDUST',
  'SCARIOT',
  'SCARLET',
  "SCARLETT O'HARA",
  'SCARPOINT',
  'SCARS OF CHAOS',
  'SCARS OF LIFE',
  'SCARS OF PHOENIX',
  'SCARS OF TOMORROW',
  'SCARS ON BROADWAY',
  'SCARVE',
  'SCATHEWORN',
  'SCATTERBRAIN',
  'SCENT OF FLESH',
  'SCEPTER',
  'SCEPTIC',
  'SCHAFT',
  'SCHALIACH',
  'SCHAMMASCH',
  'SCHANDMAUL',
  'SCHEEPERS',
  'SCHEITAN',
  'SCHIZMA',
  'SCHIZO',
  'SCHIZOID LLOYD',
  'SCHLAFES BRUDER',
  'SCHOLOMANCE',
  'SCHYSMA',
  'SCIENCE OF LOGIC',
  'SCIENCE OF SLEEP',
  'SCISSORFIGHT',
  'SCORCHED-EARTH',
  'SCORPIONS',
  'SCOURGE',
  'SCRAMBLED DEFUNCTS',
  'SCREAM SILENCE',
  'SCREAMING FOREST',
  'SCULPTURED',
  'SCUM',
  'SCUM OF THE EARTH',
  'SCYTHE',
  'SCYTHIA',
  'SCYTHIAN',
  'SEA OF DESPERATION',
  'SEA OF SHIT',
  'SEA OF TREACHERY',
  'SEANCE',
  'SEAR',
  'SEAR BLISS',
  'SEASON OF GHOSTS',
  "SEASON'S END",
  'SEASONS',
  'SEBASTIAN BACH',
  'SEBASTIEN',
  'SECRECY',
  'THE SECRET',
  'SECRET DISCOVERY',
  'SECRET SPHERE',
  'SECRETS',
  'SECRETS OF THE MOON',
  'SECRETS SHE KEPT',
  'SECT',
  'SEDITIONIST',
  'SEE THE LIGHT',
  'SEE THE RISE',
  'SEE YOU NEXT TUESDAY',
  'THE SEED OF DATURA',
  'SEEDS OF IBLIS',
  'SEEMLESS',
  'SEETHER',
  'SEETHINGS',
  'SELDON',
  'SELF TORTURE',
  'SEMBLANT',
  'SEMPITERNAL DEATHREIGN',
  'SEND MORE PARAMEDICS',
  'SEND THE ADVOCATE',
  'SENECA',
  'SENGIR',
  'SENOR BIVINS',
  'SENSE VS SANITY',
  'SENSES FAIL',
  'SENSORIUM',
  'SENTENCED',
  'SENTIENCE',
  'SENTINEL',
  'SENTIRE',
  'SEPARATION ANXIETY',
  'SEPARATIST',
  'SEPSISM',
  'SEPT OF MEMNON',
  'SEPTIC FLESH',
  'SEPULTURA',
  'SERAPHIM',
  'SERAPHIM SHOCK',
  'SERDAROTH',
  'SERDCE',
  'SERENITY',
  'SERENITY DIES',
  'SERIANNA',
  'SERINGAI',
  'SERIOUS BLACK',
  'SERJ TANKIAN',
  'SERPENT',
  'SERPENT VENOM',
  'SERPENT WINGS',
  'SERPENTIA',
  'SERPENTINE DOMINION',
  'SERPENTOR',
  'SERPENTS',
  'SERPENTSPIRE',
  'SERRABULHO',
  'SET THINGS RIGHT',
  'SETANERA',
  'SETEKH',
  'SETH',
  'SETHERIAL',
  'SETHIAN',
  'SEVEN',
  'SEVEN ANGELS',
  'SEVEN KINGDOMS',
  'SEVEN NAUTICAL MILES',
  'SEVEN WITCHES',
  'SEVENCHURCH',
  'SEVENDUST',
  'SEVENTH ANGEL',
  'SEVENTH AVENUE',
  'SEVENTH DIMENSION',
  'SEVENTH ONE',
  'SEVENTH VOID',
  'SEVENTH WONDER',
  'SEVER THE KING',
  'SEVERE DEMENTIA',
  'SEVERE TORTURE',
  'SEVERED RESISTENCE',
  'SEVERED SAVIOR',
  'SEVERED TIES',
  'SEVERNIE VRATA',
  'SEVERSUN',
  'SEX PRISONER',
  'SEXTO SONAR',
  'SEXTRASH',
  'SHACKLES',
  'SHADE',
  'SHADE EMPIRE',
  'SHADE OF HATRED',
  'SHADED ENMITY',
  'SHADES OF DUSK',
  'SHADOW FLAG',
  'SHADOW GALLERY',
  'SHADOW HOST',
  'SHADOW KEEP',
  'SHADOW OF DEMISE',
  'SHADOW OF INTENT',
  'SHADOW OF THE COLOSSUS',
  "SHADOW'S PALACE",
  'SHADOWBANE',
  'SHADOWBREED',
  'SHADOWCAST',
  'SHADOWGARDEN',
  'SHADOWICON',
  'SHADOWLORD',
  'SHADOWQUEST',
  'SHADOWS FALL',
  'SHADOWS LAND',
  'SHADOWS OF STEEL',
  'SHADOWS PAST',
  'SHADOWSEEDS',
  'SHADOWSIDE',
  'SHADOWSPHERE',
  'SHAH',
  'SHAI HULUD',
  'SHAKRA',
  'SHALL BE THE CONQUEROR',
  'SHALLOW RIVERS',
  'SHAMAN',
  'SHAMRAIN',
  'SHAOLIN DEATH SQUAD',
  'SHAPE OF DESPAIR',
  'SHAPIST',
  'SHATTER MESSIAH',
  'SHATTERED HOPE',
  'SHATTERED REALM',
  'SHATTERPOINT',
  'SHATTERSPHERE',
  'SHE CRIES WOLF',
  'SHE HAS FALLEN',
  'SHE MUST BURN',
  'SHEER TERROR',
  'SHEHARA',
  'SHELLYZ RAVEN',
  'SHEN',
  'SHERE KHAN',
  'SHERIDAN',
  'SHIHAD',
  'SHINEDOWN',
  'SHINING',
  'SHINING FURY',
  'SHINTO KATANA',
  'SHITFUCKER',
  'SHIVERED',
  'SHOKRAN',
  'SHOOT THE GIRL FIRST',
  'SHORES OF ELYSIUM',
  'SHORT SHARP SHOCK',
  'THE SHOWDOWN',
  'SHREDHEAD',
  'SHRINEBUILDER',
  'SHROUDED MIRROR',
  'SHUB NIGGURATH',
  'SHYLMAGOGHNAR',
  'SIBERIAN',
  'SIBERIAN MEAT GRINDER',
  'SICK OF IT ALL',
  'SICKENING HORROR',
  'A SICKNESS UNTO DEATH',
  'SIDE OF DESPONDENCY',
  'SIDE WINDER',
  'SIDIOUS',
  'SIEBENBURGEN',
  'SIEGE',
  'SIEGES EVEN',
  'SIEGFRIED',
  'SIENNA SKIES',
  'SIERPE',
  'SIGH',
  'A SIGHT FOR SEWN EYES',
  'SIGHT OF EMPTINESS',
  'SIGMA',
  'SIGNAL THE FIRING SQUAD',
  'SIGNS OF DARKNESS',
  'SIGNS OF THE SWARM',
  'SIGNUM REGIS',
  'SIGRBLOT',
  'SIKSAKUBUR',
  'SIKTH',
  'SILENCE',
  'SILENCE THE MESSENGER',
  'SILENCER',
  'SILENT CELL',
  'SILENT CIVILIAN',
  'SILENT CRY',
  'SILENT DESCENT',
  'SILENT EDGE',
  'SILENT FALL',
  'SILENT FORCE',
  'SILENT KINGDOM',
  'SILENT PLANET',
  'SILENT PROPHET',
  'SILENT SCREAMS',
  'SILENT SCYTHE',
  'SILENT STREAM OF GODLESS ELEGY',
  'SILENT VOICES',
  'SILENT WINTER',
  'SILENTIUM',
  'SILVER FIST',
  'SILVERBONES',
  'SILVERLANE',
  'SILVERSTEIN',
  'SILVERTOMB',
  'SIMONIA',
  'SIN OF GOD',
  'SIN ORIGIN',
  'SINAI BEACH',
  'SINAMORE',
  'SINATE',
  'SINBREED',
  'SINCARNATE',
  'SINCE THE FLOOD',
  'SINERGY',
  'SINHERESY',
  'SINI AUTERIA',
  'SINISTER',
  'SINN',
  'SINNER',
  'SINNERS TO SAINTS',
  'SINOATH',
  'SINPHONIA',
  'SINPROPHECY',
  'THE SINS OF THY BELOVED',
  'SINSAENUM',
  'SINSTOK',
  'SINSTORM',
  'SIREN',
  'SIRENIA',
  'SIRENS',
  'SIRENS AND SAILORS',
  'SIRENS FALL SILENT',
  'SIRIUS',
  'SIRRAH',
  'SISTER SIN',
  'SISYPHUS',
  'SIX FEET DEEP',
  'SIX FEET UNDER',
  'SIX MAGICS',
  'SIX MINUTE CENTURY',
  'SIXTY WATT SHAMAN',
  'SJK',
  'SKANNERS',
  'SKARLETT RIOT',
  'SKELETAL EARTH',
  'SKELETONWITCH',
  'SKEPTICISM',
  'SKID ROW',
  'SKILLET',
  'SKILTRON',
  'SKINDRED',
  'SKINLAB',
  'SKINLESS',
  'SKINNY PUPPY',
  'SKIP THE FOREPLAY',
  'SKITARG',
  'SKITLIV',
  'SKITSYSTEM',
  'SKOGEN',
  'SKOLD',
  'SKRAPE',
  'SKREAMER',
  'SKREW',
  'SKULL FIST',
  'SKULLHOG',
  'SKULLVIEW',
  'SKY CRYPT',
  'SKY EATS AIRPLANE',
  'SKYCAMEFALLING',
  'SKYCLAD',
  'SKYDANCER',
  'SKYFIRE',
  'SKYFORGER',
  'SKYHARBOR',
  'SKYLARK',
  'A SKYLIT DRIVE',
  'SKYMNING',
  'SKYNET',
  'SKYSCRAPER',
  'SKYTHRONE',
  'SLAG',
  'SLAPDASH',
  'SLAPSHOT',
  'SLARTIBARTFASS',
  'SLASH',
  'SLAUGHTER',
  'SLAUGHTER THE PROPHETS',
  'SLAUGHTER TO PREVAIL',
  'SLAUGHTERBOX',
  'SLAVES',
  'SLAVES ON DOPE',
  'SLAYER',
  'SLECHTVALK',
  'SLEEP',
  'SLEEP SERAPIS SLEEP',
  'SLEEP SIGNALS',
  "SLEEP WHEN YOU'RE DEAD",
  'SLEEPING GIANT',
  'SLEEPING GODS',
  'SLEEPING PULSE',
  'SLEEPING ROMANCE',
  'SLEEPING WITH SIRENS',
  'SLEEPLESS',
  'SLEEPSCULPTOR',
  'SLEEPWALKERS',
  'SLEEPWAVE',
  'SLICE THE CAKE',
  'SLIPKNOT',
  'SLOTH',
  'SLOWMOTION APOCALYPSE',
  'SLUGDGE',
  'SLUMBER',
  'SLUMPARK CORRECTIONAL',
  'SMASHING PUMPKINS',
  'SMILE EMPTY SOUL',
  'SMILIN LIAR',
  'SMOHALLA',
  'SMOTHERED',
  'SMOULDERING IN FORGOTTEN',
  'SNAIL',
  'SNAPCASE',
  'SNOT',
  'SNOWBLIND',
  'SNOWBLOOD',
  'SNUFF',
  'SO THIS IS SUFFERING',
  'SOBERNOT',
  'SOBRE NOCTURNE',
  "SOCIETY'S PLAGUE",
  'SODOM',
  'THE SODOMITE AGENDA',
  'SOEN',
  'SOFA KING KILLER',
  'SOHRAAB',
  'SOIL',
  'SOILENT GREEN',
  'SOILS OF FATE',
  'SOILWORK',
  'SOJOURNER',
  'SOL',
  'SOL SISTERE',
  'SOLACE',
  'SOLAR DAWN',
  'SOLAR FRAGMENT',
  'SOLARWARD',
  'SOLE REMEDY',
  'SOLEFALD',
  'SOLEKAHN',
  'SOLICIDE',
  'SOLISIA',
  'SOLITARY DEPRESSION',
  'SOLITUDE',
  'SOLITUDE AETURNUS',
  'SOLITUDE WITHIN',
  'SOLIUM FATALIS',
  'SOLSTICE',
  'SOLUS',
  'SOMBRE NOSTALGIE',
  'SOME GIRLS',
  'SOMNENT',
  'SON OF AURELIUS',
  'SON OF SORROW',
  'SONATA ARCTICA',
  'SONETOS',
  'SONIC SKIES',
  'SONIC SYNDICATE',
  'SONIK DEATH MONKEY',
  'SONNE ADAM',
  'SONS OF A WANTED MAN',
  'SONS OF AEON',
  'SONS OF AZRAEL',
  'SONS OF LIBERTY',
  'SONS OF SEASONS',
  'SOPHICIDE',
  'SOPOR AETERNUS',
  'SORATH',
  'SORCERER',
  'SORCERY',
  'SORCIER DES GLACES',
  'SORE PLEXUS',
  'SOREPTION',
  'SORG',
  'SORG INNKALLELSE',
  'SORGSVART',
  'SORHIN',
  'SORROW',
  'THE SORROW',
  'SORROWEAVER',
  'SORROWFUL ANGELS',
  'A SORROWFUL DREAM',
  'SORROWFUL GOD',
  'SORROWS PATH',
  'SORROWSEED',
  'SORS IMMANIS',
  'SORTOUT',
  'SOTAJUMALA',
  'SOTHIS',
  'SOUL DEMISE',
  'SOUL EMBRACED',
  'SOUL REAPER',
  'SOULBLEED',
  'SOULBOUND',
  'SOULBURN',
  'SOULBURNER',
  'SOULDRAINER',
  'SOULDÆMON',
  'SOULFALLEN',
  'SOULFLY',
  'SOULGRIND',
  'SOULITUDE',
  'SOULJOURNERS',
  'SOULLESS',
  'THE SOULLESS',
  'THE SOULLESS ARCHITECT',
  'SOULNERVE',
  'SOULRELIC',
  'SOULREST',
  'SOULS OF ARIES',
  'SOULSCAR',
  'SOULSEARCH',
  'SOULSPELL',
  'SOULSTORM',
  'SOUND BARRIER',
  'A SOUND OF THUNDER',
  'SOUND STORM',
  'SOUNDGARDEN',
  'SOUNDSCAPE',
  'THE SOURCE',
  'SOURCE OF TIDE',
  'SOUTHERN CROSS',
  'SOUTHERN ISOLATION',
  'SOUTHERN STORM',
  'SOVEREIGN',
  'SOVEREIGN STRENGTH',
  'SPACE EATER',
  'SPACE ODYSSEY',
  'SPACEMETAL',
  'SPARZANZA',
  'SPAWN',
  'SPAWN OF POSSESSION',
  'SPAZZ',
  'SPEAR OF LONGINUS',
  'SPEARHEAD',
  'SPECIES',
  'SPECTRAL',
  'SPECTRAL LORE',
  'SPEED KILL HATE',
  'SPEEDBLOW',
  'SPEEED',
  'SPEKTRAL HATCHERY',
  'SPELLBLAST',
  'SPELLCASTER',
  'SPHERIC UNIVERSE EXPERIENCE',
  'SPHINX',
  'SPINA BIFIDA',
  'SPINAL TAP',
  'SPINESHANK',
  'SPIRAL ARCHITECT',
  'SPIRAL MADNESS',
  'THE SPIRIT',
  'SPIRIT CARAVAN',
  'SPIRIT DISEASE',
  'SPIRITBOX',
  'SPIRITUAL',
  'SPIRITUAL BEGGARS',
  'SPIRITUAL RAVISHMENT',
  'SPIRITUS MORTIS',
  'SPITE',
  'SPITE EXTREME WING',
  'SPLATTERHOUSE',
  'SPORTLOV',
  'THE SPUDMONSTERS',
  'SPUN IN DARKNESS',
  'SQUEALER',
  'STAB',
  'STABAT MATER',
  'STAHLHAMMER',
  'STAIND',
  'STAINLESS STEEL',
  "STAMPIN' GROUND",
  'STAND YOUR GROUND',
  'STAPLE',
  'STAR OF ASH',
  'STAR ONE',
  'STAR QUEEN',
  'STARBLIND',
  'STARBREAKER',
  'STARGATE',
  'STARGAZER',
  'STARGAZERY',
  'STARKILL',
  'A STARLESS SKY',
  'STARSET',
  'STARSOUP',
  'STARTLED BY SILENCE',
  'STARWRAITH',
  'STATE FAULTS',
  'STATE OF EAST LONDON',
  'STATE OF ILLUSION',
  'STATE OF NEGATION',
  'STATIC LULLABY',
  'STATIC-X',
  'STATUS MINOR',
  'STEAK NUMBER EIGHT',
  'STEALING AXION',
  'STEEL ATTACK',
  'STEEL PANTHER',
  'STEEL PROPHET',
  'STEEL WARRIOR',
  'STEELER',
  'STEELHEART',
  'STEELPREACHER',
  'STEELWING',
  'STEIGNYR',
  'STERBEND',
  'STERNENSTAUB',
  'STEVE HARRIS',
  'STEVEN WILSON',
  'STICK TO YOUR GUNS',
  'STIGMATA',
  'STILL LIFE DECAY',
  'STILL REMAINS',
  'STILLHET',
  'STILLNESS BLADE',
  'STIMULANS',
  'STITCHED UP HEART',
  'STOA',
  'STOLEN BABIES',
  'STONE',
  'THE STONE',
  'STONE SOUR',
  'STONE TO FLESH',
  'STONE WINGS',
  'STONEHENGE',
  'STONER KINGS',
  'STONY FIELD',
  'STORIES',
  'STORM',
  'STORM CORROSION',
  'STORM LEGION',
  'STORM OF SORROWS',
  'THE STORM PICTURESQUE',
  'STORM THE SKY',
  'STORM UPON THE MASSES',
  'STORMHAMMER',
  'STORMHOLD',
  'STORMING DARKNESS',
  'STORMLORD',
  'STORMRIDER',
  'THE STORMRIDER',
  'STORMWARRIOR',
  'STORMWIND',
  'STORMWITCH',
  'STORTREGN',
  'STORY OF THE YEAR',
  'THE STORY SO FAR',
  'THE STORYTELLER',
  'STRAIGHT LINE STITCH',
  'STRAINS',
  'STRANA OFFICINA',
  'THE STRANDED',
  'A STRANGER TO REMORSE',
  'STRAPPING YOUNG LAD',
  'THE STRATAGEM',
  'STRATOVARIUS',
  'STRATUS',
  'STRAVAGANZZA',
  'STRAY FROM THE PATH',
  'STREAKS',
  'STREAM OF PASSION',
  'STREET CHILD',
  'STRIBOG',
  'STRIDE',
  'STRIDENT',
  'STRIFE',
  'STRIKE MASTER',
  'STRIKER',
  'STROMMOUSSHELD',
  'STRONGARM',
  'STRUCTURAL DISORDER',
  'STRUCTURAL REPAIRS',
  'STRUCTURES',
  'STRUGGLE WITH GOD',
  'STRYKJÄRN',
  'STRYPER',
  'STUCK MOJO',
  'STURM UND DRANG',
  'STURMGEIST',
  'STUTTERFLY',
  'STYGIUS',
  'STYGMA IV',
  'SUASION',
  'SUBAUDITION',
  'SUBHUMAN',
  'SUBLIME CADAVERIC DECOMPOSITION',
  'SUBLIRITUM',
  'SUBLUNAR',
  'SUBMERSED',
  'SUBMISSION',
  'SUBROSA',
  'SUBSCALE',
  'SUBSONIC FALLOUT',
  'SUBSTANCE BLACK',
  'SUBSTANCE FOR GOD',
  'SUBSTRUCTURE',
  'SUBTERA',
  'SUBTERRANEAN MASQUERADE',
  'SUBURBAN SCUM',
  'SUBWAY TO SALLY',
  'SUCCESS WILL WRITE APOCALYPSE ACROSS THE SKY',
  'SUFFER WELL',
  'SUFFERING SOULS',
  'SUFFOCATION',
  'SUFFOCATION OF SOUL',
  'SUFFOKATE',
  'SUICIDAL ANGELS',
  'SUICIDAL TENDENCIES',
  'SUICIDAL WINDS',
  'SUICIDE',
  'THE SUICIDE FILE',
  'SUICIDE NOTE',
  'SUICIDE SILENCE',
  'SUIDAKRA',
  'SULACO',
  'SULLEN GUEST',
  'SULPHUR',
  'SULPHUR AEON',
  'SUMAC',
  'SUMATRA',
  "SUMMER'S END",
  'SUMMON',
  'SUMMONER',
  'SUMMONING',
  'SUN CAGED',
  'SUN OF SADNESS',
  'SUN OF THE SLEEPLESS',
  'SUN SETH',
  'SUNCHARIOT',
  'SUNDOWN',
  'SUNDOWNERS',
  'SUNSETH MIDNIGHT',
  'SUNSETH SPHERE',
  'SUNSTORM',
  'SUNTERRA',
  'SUNTORN',
  'SUPARED',
  'SUPER-NOT',
  'SUPERBUTT',
  'SUPERIOR',
  'SUPERJOINT',
  'SUPERJOINT RITUAL',
  'SUPREMACY',
  'SUPREME MAJESTY',
  'SUR AUSTRU',
  'SURGICAL DISSECTION',
  'SURROUNDINGS',
  'SURVIVING IN A WORLD',
  'SUSPERIA',
  'SUSPYRE',
  'SVAFNIR',
  'SVARROGH',
  'SVART',
  'SVART CROWN',
  'SVARTAHRID',
  'SVARTBY',
  'SVARTI LOGHIN',
  'SVARTKRAFT',
  'SVARTSOT',
  'SVARTSYN',
  'SVARTTJERN',
  'SVAVELVINTER',
  'SVEDERNA',
  'SVENIA',
  'SVOID',
  'SVORDOM',
  'SVÖLK',
  'SWALLOW THE SUN',
  'SWALLOWED',
  'SWALLOWING SHIT',
  'A SWARM OF THE SUN',
  'SWASHBUCKLE',
  'THE SWEET APES',
  'SWIATOGOR',
  'SWIFT',
  'SWITCHBLADE',
  'SWITCHBLADE SYMPHONY',
  'SWITCHED',
  'SWORD',
  'THE SWORD',
  'SWORDMASTER',
  'SWORN',
  'SWORN ENEMY',
  'SWORN IN',
  'SYBREED',
  'SYKOSIS',
  'SYLAR',
  'SYLOSIS',
  'SYLVAN',
  'SYLVESTER STALINE',
  'SYMBEL',
  'SYMBIOSIS',
  'SYMBIOTIC',
  'SYMBOLS',
  'SYMFONIA',
  'SYMPATHY',
  'SYMPHONIAN',
  'SYMPHONITY',
  'SYMPHONY IN PERIL',
  'SYMPHONY X',
  'THE SYMPHONYX',
  'SYMPHORCE',
  'SYNCARDION',
  'SYNDEMIC',
  'SYNESTESIA',
  'SYNLAKROSS',
  'SYNSNAKE',
  'SYNTHETIC BREED',
  'SYNTHPHONIA SUPREMA',
  'SYOPSIS',
  'SYRACH',
  'SYRENOMELIA',
  'SYRON VANES',
  'SYSTEM ADDICT',
  'SYSTEM DECAY',
  'SYSTEM DIVIDE',
  'SYSTEM OF A DOWN',
  'SYSTEMATIC',
  'SZRON',
  'SA MEUTE',
  'SEVEN SPIRES',
  'SHADOWMARE',
  'SHADOWS LEGACY',
  'SIC SEMPER TYRANNIS',
  'SILENT PATH',
  'SLAVE TO SIRENS',
  'SLOW',
  'SOLARIS IMPERIUM',
  'SOLE SURVIVOR',
  'SONS OF APOLLO',
  'SOULBURNER',
  'STANBROOK',
  'SUPERCONTINENT',
  'SURU',
  'SVARTKONST'
];

const metalBandsT = [
  'TACIT FURY',
  'TAD MOROSE',
  'TAGADA JONES',
  'TAKE IT BACK',
  'TAKE OFFENSE',
  'TAKE THE EARTH BENEATH US',
  'TAKING DAWN',
  'TALAMYUS',
  'TALBOT',
  'THE TALE OF MY DEFEAT',
  'TALES FOR THE UNSPOKEN',
  'TALES OF DARK',
  'TALES OF DARKNORD',
  'TALES OF PAIN',
  'TALION',
  'TALISMAN',
  'TANGAROA',
  'TANK',
  'TANKARD',
  'TANTRICA',
  'TANZWUT',
  'TAPPING THE VEIN',
  'TAPROOT',
  'TARAXACUM',
  'TARDY BROTHERS',
  'TARJA',
  'TAROT',
  'TARTAROS',
  'THE TASTE OF BLOOD',
  'TASTERS',
  'TAUNUSHEIM',
  'TAURUS',
  'TCHORNOBOG',
  'TEAR OUT THE HEART',
  'TEARS',
  'TEARS OF MAGDALENA',
  'TEARS OF MANKIND',
  'TEARS OF MARTYR',
  'TEARSTAINED',
  'TED MAUL',
  'TED NUGENT',
  'TEETH OF LIONS RULE THE DIVINE',
  'TEITANBLOOD',
  'TELL ME A FAIRYTALE',
  'TEMNOZOR',
  'THE TEMPLE',
  'TEMPLE OF ATHENA',
  'TEMPLE OF BAAL',
  'TEMPLE OF DREAD',
  'TEMUJIN',
  'TENACIOUS D',
  'TENEBRAE IN PERPETUUM',
  'TENEBRE',
  'TENEBROUS',
  'TENHI',
  'TENSION PROPHECY',
  'TENTACLE',
  'TEPHRA',
  'TEPHROS',
  'TERAMAZE',
  'TERAPI SARAF',
  'TERATISM',
  'TERMINAL PROSPECT',
  'TERRA MOURN',
  'TERRA SUR',
  'TERRACIDE',
  'TERRAVORE',
  'TERROR',
  'TERRORIZER',
  'TERRORSCOPE',
  'TERRORTORY',
  'TERRØR PRØPAGANDA',
  'TERSIVEL',
  'TERÄSBETONI',
  'TESLA',
  'TESSERACT',
  'TESTAMENT',
  'TESTIFY',
  'TETHRA',
  'TETRACTYS',
  'TEXAS HIPPIE COALITION',
  'TEXAS IN JULY',
  'A TEXTBOOK TRAGEDY',
  'TEXTURES',
  'THALARION',
  'THALION',
  'THANATEROS',
  'THANATOS',
  'THANATOSCHIZO',
  'THARGOS',
  'THAUROROD',
  'THE SCALAR PROCESS',
  'THEATRE OF TRAGEDY',
  'THEATRES DES VAMPIRES',
  'THEOCRACY',
  'THEORY IN PRACTICE',
  'THEORY OF A DEADMAN',
  'THERGOTHON',
  'THERION',
  'THESE ARE THEY',
  'THESE ARMS ARE SNAKES',
  'THESE HEARTS',
  'THESE STREETS',
  'THESE WINDS ARE NOT HOPE',
  'THESYRE',
  'THEUDHO',
  'THICK AS BLOOD',
  'THIN LIZZY',
  'THINE EYES BLEED',
  'THIRDMOON',
  'THIRTEEN BLED PROMISES',
  'THIRTEENTH EXILE',
  'THIS DAY FORWARD',
  'THIS DEAFENING WHISPER',
  'THIS DIVIDED WORLD',
  'THIS EMPTY FLOW',
  'THIS ENDING',
  'THIS GIFT IS A CURSE',
  'THIS IS HELL',
  'THIS IS SPARTA',
  'THIS OR THE APOCALYPSE',
  "THIS TIME IT'S WAR",
  'THIS, MY VENDETTA',
  'THISIDUP',
  'THOKK',
  "THOR'S HAMMER",
  'THORAZINE',
  'THORIUM',
  'THORNAFIRE',
  'THORNHILL',
  'THORNS',
  'THORNS OF THE CARRION',
  'THORNSPAWN',
  "THORR'S HAMMER",
  'THOSE ENDLESS EYES',
  'THOSE LEFT BEHIND',
  'THOSE WHO FEAR',
  'THOSE WHO LIE BENEATH',
  'THOU',
  'THOU ART LORD',
  'THOUGHT INDUSTRY',
  'A THOUSAND FALLING SKIES',
  'THOUSAND FOOT KRUTCH',
  'A THOUSAND PUNCHES',
  'A THOUSAND TIMES REPENT',
  'THRAGEDIUM',
  'THRASH OR DIE',
  'THRAWSUNBLAT',
  'THREAT SIGNAL',
  'THREE DAYS GRACE',
  'THREESHOLD',
  'THRENODY',
  'THRESHOLD',
  'THRICE',
  'THROANE',
  'THROES OF DAWN',
  'THRONAR',
  'THRONE OF AHAZ',
  'THRONE OF CHAOS',
  'THRONE OF KATARSIS',
  'THRONEAEON',
  'THRONEUM',
  'THROUGH FIRE',
  'THROUGH THE EYES OF THE DEAD',
  'THROUGH YOUR SILENCE',
  'THROWDOWN',
  'THROWN INTO CHAOS',
  'THROWN TO THE SUN',
  'THRUDVANGAR',
  'THRÄNENKIND',
  'THULCANDRA',
  'THUMLOCK',
  'THUNDER LORD',
  'THUNDER, TOMB & THRONE',
  'THUNDERBOLT',
  'THUNDERHEAD',
  'THUNDERSTONE',
  'THUNDERSTORM',
  'THUNDERTALE',
  'THUNDERWORKS',
  'THUNDRA',
  'THURISAZ',
  'THURS',
  'THURSDAY',
  'THUS DEFILED',
  'THY ART IS MURDER',
  'THY CATAFALQUE',
  'THY DARKENED SHADE',
  'THY DISEASE',
  'THY ENDLESS WRATH',
  'THY ETHOS',
  'THY INFERNAL',
  'THY LIGHT',
  'THY MAJESTIE',
  'THY PRIMORDIAL',
  'THY REPENTANCE',
  'THY SERPENT',
  'THY WICKED',
  'THY WILL BE DONE',
  'THY WORSHIPER',
  'THYESTEAN FEAST',
  'THYRANE',
  'THYRESIS',
  'THYRFING',
  'THYRIEN',
  'TIAMAT',
  'TIDAL DREAMS',
  'TIDFALL',
  'TIERRA SANTA',
  'TILES',
  'TIM DONAHUE',
  'TIM RIPPER OWENS',
  'TIME & TIDE',
  'TIME FLIES',
  'TIME HAS COME',
  'TIME MACHINE',
  'TIME REQUIEM',
  'TIME TRAVELLER',
  "TIME'S FORGOTTEN",
  'TIMECODE',
  'TIMEGHOUL',
  'TIMELESS MIRACLE',
  'TIMES OF GRACE',
  'TIMESAILOR',
  'TIMO RAUTIAINEN',
  'TIMO RAUTIAINEN & NELJÄS SEKTORI',
  'TIMO RAUTIAINEN & TRIO NISKALAUKAUS',
  'TIMO TOLKKI',
  "TIMO TOLKKI'S AVALON",
  'TINIEBLAS',
  'TIRED OF EVERYTHING',
  'TITAN FORCE',
  'TITANIUM',
  'TITLE FIGHT',
  'TLEPSH',
  'TNT',
  'TO CAST A SHADOW',
  'TO ELYSIUM',
  'TO KILL ACHILLES',
  'TO SPEAK OF WOLVES',
  'TO THE WIND',
  'TO-MERA',
  'TOARN',
  'TOAST',
  'TODAY IS THE DAY',
  'TODESBONDEN',
  'TODESFAUST',
  'TODESGEIST',
  'TODTGELICHTER',
  'TOKEN',
  'TOKYO BLADE',
  'TOM ANGELRIPPER',
  'TOM KEIFER',
  'TOMAHAWK',
  'TOMB OF DOOM',
  'TOMBS',
  "TOMORROW'S EVE",
  'THE TONY DANZA TAPDANCE EXTRAVAGANZA',
  'TONY IOMMI',
  'TONY MARTIN',
  'TOO PURE TO DIE',
  'TOOL',
  'TOOTHLESS',
  'TORANAGA',
  'TORCHBEARER',
  'TORCHE',
  'TORCHIA',
  'TORMENT',
  'TORMENT THE SKIES',
  'TORMENTED VISION',
  'TORMENTOR',
  'TORNADO',
  'TORQUE',
  'TORRE DE MARFIL',
  'TORSOFUCK',
  'TORTORUM',
  'TORTURE',
  'TORTURE CHAMBER',
  'TORTURE KILLER',
  'TORTURE SQUAD',
  'TORTURED CONSCIENCE',
  'TOTAL DEVASTATION',
  'TOTAL TRAGEDY',
  'TOTALSELFHATRED',
  'TOTALT JÄVLA MÖRKER',
  'TOTEM',
  'TOTENGEFLÜSTER',
  'TOTENMOND',
  'TOTENWACHE',
  'TOUCH OF ETERNITY',
  'TOUCHÉ AMORÉ',
  'TOURNIQUET',
  'TOWER',
  'TOWERS',
  'TOXIC GRIND MACHINE',
  'TOXIC HATE',
  'TOXIC HOLOCAUST',
  'TOXICDEATH',
  'TOXIK',
  'TOXIMIA',
  'TOXOCARA',
  'TRACEDAWN',
  'TRAGEDERIA',
  'TRAGEDY',
  'TRAGUL',
  'TRAIL OF TEARS',
  'TRAILS OF ANGUISH',
  'TRAINING FOR UTOPIA',
  'TRAITOR',
  'TRAITORS',
  'TRALLERY',
  'TRANCE',
  'TRANCE OF MINE',
  'TRANS-SIBERIAN ORCHESTRA',
  'TRANSATLANTIC',
  'TRANSCENDS',
  'TRANSGRESSION',
  'TRANSILVANIAN BEAT CLUB',
  'TRANSMETAL',
  'TRAP THEM',
  'TRAPPED UNDER ICE',
  'TRAPT',
  'TRASH TALK',
  'TRAUMA',
  'TRC',
  'TREASURE LAND',
  'TREASURE SEEKER',
  'A TREE OF SIGNS',
  'TREES OF ETERNITY',
  'TRELLDOM',
  'TREMONTI',
  'TRENCHES',
  'TRENCHGRINDER',
  'TREPALIUM',
  'TREPONEM PAL',
  'TRIA MERA',
  'TRIALS',
  'TRIBE OF PAZUZU',
  'TRIBES OF CAÏN',
  'TRIBULATION',
  'TRIBULATION',
  'TRIBUNE',
  'TRIBUZY',
  'TRIDDANA',
  'TRIFIXION',
  'TRIGGER THE BLOODSHED',
  'TRINACRIA',
  'TRIOSPHERE',
  'TRIPTYKON',
  'TRIST',
  'TRISTANIA',
  'TRISTITIA',
  'TRIUMFALL',
  'TRIUMPHATOR',
  'TRIVIUM',
  'TROGLODYTE DAWN',
  'TROLL',
  'TROLLBAND',
  'TROLLECH',
  'TROLLFEST',
  "TROLLHEIM'S GROTT",
  'TROOPER',
  'TROUBLE',
  'TRUCKFIGHTERS',
  'TRUST',
  'A TRUST UNCLEAN',
  'TRUTH CORRODED',
  'TRYBLITH',
  'TSATTHOGGUA',
  'TSJUDER',
  'TU CARNE',
  'TUATHA DE DANANN',
  'TUHONSIEMEN',
  'TUKKANUOTTA',
  'TULUS',
  'TUNES OF DESPAIR',
  'TUNGSTEN',
  'TUNRIDA',
  'TUOMAS HOLOPAINEN',
  'TURA SATANA',
  'TURBID NORTH',
  'TURBO',
  'TURDUS MUSICUS',
  'TURISAS',
  'TURMION KÄTILÖT',
  'TURMOIL',
  'TURN HOSTILE',
  'TVANGESTE',
  'TWELFTH GATE',
  'TWELFTH OF NEVER',
  'TWELVE FOOT NINJA',
  'TWELVE TRIBES',
  'TWILIGHT FORCE',
  'TWILIGHT GUARDIANS',
  'TWILIGHT OF THE GODS',
  'TWILIGHT OPHERA',
  'TWILIGHTNING',
  'TWIN OBSCENITY',
  'TWIN ZERO',
  'TWINBALL',
  'TWISTED AUTUMN DARKNESS',
  'TWISTED INTO FORM',
  'TWISTED METHOD',
  'TWISTED SISTER',
  'TWISTED TALES',
  'TWISTED TOWER DIRE',
  'TWITCHING TONGUES',
  'TWIZTID',
  'TWO',
  'TYGERS OF PAN TANG',
  'TYKKÜS',
  'TYMAH',
  'TYPE O NEGATIVE',
  'TYPHUS',
  "TYRAN' PACE",
  'TYRANN',
  'TYRANNO',
  'TYRANNY',
  'TYRANT',
  'TYRANT THRONE',
  "TYRANT'S KALL",
  'TYRANTS BLOOD',
  'TYSTNADEN',
  'TANKIST',
  'TANTARA',
  'TENEBRES',
  'TETHYS',
  'THE ORDER OF ISRAFEL',
  'THE SHIVA HYPOTHESIS',
  'THE VICIOUS HEAD SOCIETY',
  'THEOMANIA',
  'TOMB MOLD',
  'TÝR',
  'TŴR',
  'THENAME',
  'THE TRUE FROST'
];

const metalBandsU = [
  'UEICKAP',
  'UFO',
  'UFOMAMMUT',
  'UHRILEHTO',
  'ULCERATE',
  'ULCUS',
  'ULFHETHNAR',
  'ULTRASPANK',
  'ULVEGR',
  'ULVER',
  'ULVSBLAKK',
  'UMBRA NIHIL',
  'UMBRAL PRESENCE',
  'UNANIMATED',
  'UNBREAKABLE HATRED',
  'UNBREAKABLE SOUL',
  'THE UNBROKEN',
  'UNCLE ACID AND THE DEADBEATS',
  'UNCLEAN',
  'UNCREATION',
  'UNDAWN',
  'UNDEAD',
  'UNDEAD KILLER',
  'UNDER BLACK CLOUDS',
  'UNDER BLACKENED SKIES',
  'UNDER EDEN',
  'UNDER THAT SPELL',
  'UNDER THE COMBINE',
  'UNDER THREAT',
  'UNDERCROFT',
  'UNDERDARK',
  'UNDERGANG',
  'UNDERLINED',
  'UNDERNEATH THE GUN',
  'UNDEROATH',
  'UNDERTAKERS',
  'UNDISH',
  'UNDYING',
  'UNEARTH',
  'UNEARTHLY',
  'UNEARTHLY TRANCE',
  'UNEVEN STRUCTURE',
  'UNEXPECT',
  'UNFATHOMABLE RUINATION',
  'UNFINISHED THOUGHT',
  'UNGRACE',
  'UNGRAVED',
  'THE UNGUIDED',
  'UNHOLA',
  'UNHOLY',
  'THE UNHOLY',
  'UNHOLY BAPTISM',
  'UNHOLY GRAVE',
  'UNHOLY MATRIMONY',
  'UNICORN',
  'UNICORN RODEO',
  'UNIDA',
  'UNION UNDERGROUND',
  'UNISONIC',
  'UNIVERSUM',
  'UNLEASH THE ARCHERS',
  'UNLEASHED',
  'UNLEASHED POWER',
  'UNLIGHT',
  'UNLOCO',
  'UNLORD',
  'UNMOORED',
  'UNREAL OVERFLOWS',
  'UNSEEN FAITH',
  'UNSEEN TERROR',
  'UNSILENT PHENOMENON',
  'UNSTABLE',
  'UNSUN',
  'UNTER NULL',
  'UNTIL DEATH OVERTAKES ME',
  'UNTIL RAIN',
  'UNTO THE BEAST',
  'UP IN SMOKE',
  'UPON A BURNING BODY',
  'UPON A RED SKY',
  'UPON THIS DAWNING',
  'UPSIDEDOWN CROSS',
  'UPYR',
  'URGEHAL',
  'URGEIST',
  'URKRAFT',
  'URT',
  'URUK-HAI',
  'THE USED',
  'USNEA',
  'USURPER',
  'UTGARD',
  'UTTER HELL',
  'UTUMNO',
  'ULFVEN',
  'UN',
  'UNCHAINED',
  'UTÓPICA'
];

const metalBandsV = [
  'V SHAPE MIND',
  'VAAKEVANDRING',
  'VACANT STARE',
  'VACCINE',
  'VACUUM',
  'VADER',
  'VAHLADIAN',
  'A VAIN ATTEMPT',
  'VAINGLORY',
  'VALBORG',
  'VALE OF PNATH',
  'VALERIAN',
  'VALHALLA',
  'VALIANCE',
  'VALIDOR',
  'VALIENT THORR',
  'VALIRIA',
  'VALKYNAZ',
  'VALKYREND VARIETÉ',
  'VALKYRJA',
  'VALLE DE LA MUERTE',
  'VALLENDUSK',
  'VALLENFYRE',
  "VALLEY'S EVE",
  'VALLON',
  'VALOTON',
  'VAMPIRE',
  'VAMPIRES EVERYWHERE',
  'VAMPIRIA',
  'VAMPYR',
  'VAN CANTO',
  'VAN HALEN',
  'VANAHEIM',
  'VANDEN PLAS',
  'VANDOR',
  'VANDROYA',
  'VANGOUGH',
  'VANGUARD',
  'VANGUARDIAN',
  'VANHA',
  'VANHELGA',
  'VANIR',
  'VANISHER',
  'VANISHING POINT',
  'VANITAS',
  'VANMAKT',
  'VANNA',
  'VARATHRON',
  'VARG',
  'VARIALS',
  'VARSITY SWIM TEAM',
  'VASARIA',
  'VASSAGO',
  'VAST',
  'VASTUM',
  'VATTNET VISKAR',
  'VAULT',
  'VCTMS',
  'VECTOM',
  'VED BUENS ENDE',
  'VEDONIST',
  'VEHEMAL',
  'VEHEMENCE',
  'VEIL OF MAYA',
  'VEIL OF SORROW',
  'VEILED IN SCARLET',
  'VEIN',
  'VEKTOR',
  'VELD',
  'VELES',
  'VELNEZERS',
  'VELVET SEAL',
  'VELVET VIPER',
  'VEMOTH',
  'VENDAVAL',
  'VENDETTA',
  'VENGEANCE RISING',
  'VENGEANCE TODAY',
  'VENGEFUL GHOUL',
  'VENI DOMINE',
  'VENIN NOIR',
  'VENOM',
  'VENOMOUS CONCEPT',
  'VENTANA',
  'VENTOX',
  'VEONITY',
  'VERBAL DECEPTION',
  'VERDELET',
  'VERDUNKELN',
  'VERGELMER',
  'VERITATEM SOLAM',
  'VERJNUARMU',
  'VERSAILLES',
  'VERSE',
  'VERSUS AFFECT',
  'VERSUS THE WORLD',
  'VESANIA',
  'VESEN',
  'VESPERIAN SORROW',
  'VESTIGES',
  'VETTEN ÄPÄRÄT',
  'VEXATIOUS',
  'VEXILLUM',
  'VEXOVOID',
  'VHÄLDEMAR',
  'VHÖL',
  'VIA DOLOROSA',
  'VIA MISTICA',
  'VIALS OF WRATH',
  'VIAS',
  'VIATROPHY',
  'VICIOUS ART',
  'VICIOUS CRUSADE',
  'VICIOUS RUMORS',
  'VICTIM OF DEPRAVITY',
  'VICTIMS OF CREATION',
  "VICTORIANS - ARISTOCRATS' SYMPHONY",
  'VICTORIUS',
  'VICTORY',
  'VIDAR',
  'VIDRES A LA SANG',
  'VIDSYN',
  'THE VIEW FROM HERE',
  'VIGILANTE',
  'VIGILIA MORTUM',
  'VII ARCANO',
  'VII GATES',
  'VIIKATE',
  'VIKINGORE',
  'VILDHJARTA',
  'VILE',
  'VILIS',
  'VILLAIN OF THE STORY',
  'VILLAINS',
  'VIM PATIOR',
  'VIMIC',
  'VINDICATOR',
  'VINDSVAL',
  'VINNIE VINCENT INVASION',
  'VINTERBLOT',
  'VINTERLAND',
  'VINTERRIKET',
  'VINTERSORG',
  'VIO-LENCE',
  'VIOGRESSION',
  'VIOLATOR',
  'VIOLENT EVE',
  'VIOLENT FORCE',
  'VIOLENT X',
  'VIOLET SUNSET',
  'VIPER',
  'VIRAEMIA',
  'VIRAL LOAD',
  'VIRGIN BLACK',
  'VIRGIN SNATCH',
  'VIRGIN STEELE',
  'VIRGINIA CLEMM',
  'VIRGO',
  'VIRTUAL SYMMETRY',
  'VIRTUE IN MADNESS',
  'VIRTUOCITY',
  'VIRULENCE',
  'VIRUS',
  'VIRVUM',
  'VISCERA',
  'VISCERAL BLEEDING',
  'VISCERAL DISGORGE',
  'VISCERAL EVISCERATION',
  'VISIGOTH',
  'THE VISION BLEAK',
  'VISION DIVINE',
  'VISION OF DISORDER',
  'VISION ÉTERNEL',
  'VISIONS OF ATLANTIS',
  'VITAL REMAINS',
  'VITALIST',
  'VITJA',
  'VITSAUS',
  'VITUPERATION',
  'VIUDA NEGRA',
  'VLAD',
  'VOCIFERIAN',
  'VOGELFREY',
  'VOICE',
  'VOICE OF HATE',
  'VOICE OF INSTINCT',
  'VOICE OF TREASON',
  'VOICES',
  'VOICES OF DESTINY',
  'VOID MOON',
  'VOID OF CHAOS',
  'VOID OF KINGS',
  'VOID OF SILENCE',
  'VOID PROPHET',
  'VOIDEN',
  'VOIVOD',
  'VOKODLOK',
  'VOLA',
  'VOLBEAT',
  'VOLCANO FIST',
  'VOLDT',
  'VOLITION',
  'VOLTAK',
  'VOLTURYON',
  'VOLUME',
  'VOLUMES',
  'VOMITORIAL CORPULENCE',
  'VOMITORY',
  'VOMITURITION',
  'VON',
  'VON DÖBEL',
  'VON HERTZEN BROTHERS',
  'VOND',
  'VORBKT',
  'VORDR',
  'VORGRUM',
  'VORTEX',
  'VORTEX OF CLUTTER',
  'VORVAŇ',
  'VOTUM',
  'VOX DEI',
  'VOXAGER',
  'VOYAGER',
  'VRANI VOLOSA',
  'VREID',
  'VULCANO',
  'VULTURE',
  'VULTURE INDUSTRIES',
  'VULTURE LORD',
  'VULVODYNIA',
  'VUUR',
  'VYNDYKATOR',
  'VYPER',
  'VERTEBRA',
  'VISCERAL',
  'VLTIMAS'
];

const metalBandsW = [
  'WAFFENBRÜDER',
  'WAGE WAR',
  'THE WAKE',
  'A WAKE IN PROVIDENCE',
  'WAKEN EYES',
  'WAKING THE CADAVER',
  'WALDGEFLÜSTER',
  'WALKING WITH STRANGERS',
  'WALKNUT',
  'WALL OF SLEEP',
  'WALL OF THE EYELESS',
  'WALLS OF BLOOD',
  'WALLS OF JERICHO',
  'WALTARI',
  'WALTER GIARDINO',
  'WAPENSPRAAK & DRINKGELAG',
  'WAR',
  'WAR ANGEL',
  'WAR FROM A HARLOTS MOUTH',
  'WAR OF AGES',
  'WARBEAST',
  'WARBELL',
  'WARBREED',
  'WARBRIDE',
  'WARBRINGER',
  'WARCHILD',
  'WARCOLLAPSE',
  'WARCRY',
  'WARCURSED',
  'WARDANCE',
  'WARDRUNA',
  'WARFORGED',
  'WARG',
  'WARGASM',
  'WARHAMMER',
  'WARHEAD',
  'WARHORSE',
  'WARHOUND',
  'WARLOCK',
  'WARLORD',
  'WARMEN',
  'WARNING',
  'WARPATH',
  'WARRANT',
  'WARREL DANE',
  'WARRIOR',
  'WARRIOR SOUL',
  'THE WARRIORS',
  'THE WASTELAND MASSACRE',
  'WATAIN',
  'WATCH ME FALL',
  'WATCH THEM DIE',
  'WATCHA',
  'WATCHMAKER',
  'WATCHTOWER',
  'WATER TORTURE',
  'WAXWOLF',
  'WAYD',
  'WAYLANDER',
  'WAYNE',
  'WAYNE STATIC',
  'WE ARE DEFIANCE',
  'WE ARE OBSCURITY',
  'WE ARE THE END',
  'WE ARE THE FALLEN',
  'WE ARE THE ILLUSION',
  'WE ARE THE OCEAN',
  'WE BUTTER THE BREAD WITH BUTTER',
  'WE CAME AS ROMANS',
  'WE EXIST',
  'WE MADE GOD',
  'WE NEVER LEARNED TO LIVE',
  'WE SHALL DIE FIRST',
  'WE STILL STAND ALIVE',
  'WE THE GATHERED',
  'WEAPON',
  'WEEDEATER',
  'WEEKEND NACHOS',
  'WEENA MORLOCH',
  'WEHRMACHT',
  'WEHRWOLFE',
  'WEIDENBAUM',
  'WELCOME TO YOUR LIFE',
  'WELKIN',
  'WELL OF SOULS',
  'WELTENBRAND',
  'WEREWORLD',
  'WESTWORLD',
  'WETO',
  'WHAT AWAITS US',
  'WHAT IS TEC',
  'WHAT TOMORROW BRINGS',
  "WHAT WE'RE AFRAID OF",
  'WHEN AMBER SLEEPS',
  'WHEN NOTHING REMAINS',
  'WHEN PLAGUES COLLIDE',
  'WHEN YOU SCREAM',
  'WHERE EAGLES DARE',
  'WHICHHEAVEN',
  'WHILE HEAVEN WEPT',
  'WHILE SHE SLEEPS',
  'WHIPLASH',
  'WHISPERED',
  'WHISPERING FOREST',
  'WHISPERING GALLERY',
  'WHISPERING WOODS',
  'WHISTERIA COTTAGE',
  'WHITE ARMS OF ATHENA',
  'WHITE LION',
  'WHITE SKULL',
  'WHITE WILLOW',
  'WHITE WIZZARD',
  'WHITE ZOMBIE',
  'WHITECHAPEL',
  'WHITECROSS',
  'WHITESNAKE',
  'WHOCARES',
  'WHORE',
  'WHORETOPSY',
  'WHYTHRE',
  'WHYZDOM',
  'WICKED ANGEL',
  'WICKED ASYLUM',
  'WIDOW SUNDAY',
  'WIDOWMAKER',
  'WIEGEDOOD',
  'WIGRID',
  'WIJLEN WIJ',
  'WILD',
  'WILD DOGS',
  'WILDERNESSKING',
  'WILDERUN',
  'THE WILDHEARTS',
  'WILDPATH',
  'WILL HAVEN',
  'WILL OF THE ANCIENTS',
  'WILSON',
  'WILSON, STEVEN',
  'WIND OF THE BLACK MOUNTAINS',
  'WIND ROSE',
  'WINDHAM HELL',
  'WINDHAND',
  'WINDIR',
  'WINDS',
  'WINDS OF PLAGUE',
  'WINE FROM TEARS',
  'THE WINERY DOGS',
  'WINTER',
  'WINTER HAVEN',
  'WINTER OF APOKALYPSE',
  'WINTER SOLSTICE',
  'WINTER SOUL',
  "WINTER'S BANE",
  "WINTER'S VERGE",
  'WINTERBURST',
  'WINTERFYLLETH',
  'WINTERHORDE',
  'WINTERLONG',
  'WINTERMOND',
  'WINTEROPERA',
  'WINTERS',
  'WINTERSOUL',
  'WINTERSTORM',
  'WINTERSUN',
  'WINTERUS',
  'WIRGHATA',
  'WISDOM',
  'WISDOM CALL',
  'WISDOM IN CHAINS',
  "THE WISE MAN'S FEAR",
  'WISH FOR WINGS',
  'WITCH CROSS',
  'WITCH MOUNTAIN',
  'WITCH-HUNT',
  'WITCHBANE',
  'WITCHBREED',
  'WITCHCRAFT',
  'WITCHERY',
  'WITCHFINDER GENERAL',
  'WITCHFYNDE',
  'WITCHTRAP',
  'WITH BLOOD COMES CLEANSING',
  'WITH DEAD HANDS RISING',
  'WITH HONOR',
  'WITH LIFE IN MIND',
  'WITH PASSION',
  'WITH WHAT REMAINS',
  'WITHERED',
  'WITHERED BEAUTY',
  'WITHERED EARTH',
  'WITHERING SURFACE',
  'WITHERSCAPE',
  'WITHERSHIN',
  'WITHIN DESTRUCTION',
  'WITHIN OUR GATES',
  'WITHIN TEMPTATION',
  'WITHIN THE FALL',
  'WITHIN THE RUINS',
  'WITHIN Y',
  'WITHOUT FACE',
  'WITNESS THE FALLACY',
  'WIZ',
  'WIZARD',
  'WIZARDS',
  'WIZARDTHRONE',
  'WIZZARD',
  'WODENSTHRONE',
  'WOE',
  'WOE OF TYRANTS',
  'WOE, IS ME',
  'WOLF',
  'WOLF DOWN',
  'WOLF EYES',
  'WOLF SKIN',
  'WOLF SPIDER',
  'WOLFCHANT',
  'WOLFCRY',
  'WOLFHEART',
  'WOLFINGAR',
  'WOLFMOTHER',
  'WOLFNACHT',
  'WOLFPACK UNLEASHED',
  'WOLFPAKK',
  'WOLFSANGEL',
  'WOLFSKIN',
  'WOLFSMOND',
  'WOLFSWORD',
  'WOLVEN ANCESTRY',
  'WOLVERINE',
  'WOLVES AT THE GATE',
  'WOLVES IN THE THRONE ROOM',
  'WOLVES LIKE US',
  'WOLVES SCREAM',
  'WOMB OF DECAY',
  'WOMBWRECKER',
  'WONDERBEAST',
  'WONDERLAND',
  'WOOD OF SUICIDES',
  'WOODS OF BELIAL',
  'WOODS OF DESOLATION',
  'WOODS OF YPRES',
  'WOODTEMPLE',
  'THE WORD ALIVE',
  'WORD UP',
  'WORDS OF FAREWELL',
  'WORLD BELOW',
  'A WORLD EXTINCT',
  'WORLD OF SILENCE',
  'WORLD UNDER BLOOD',
  'THE WORLD WE KNEW',
  'WORMEATEN',
  'WORMED',
  'WORMLUST',
  'WORMPHLEGM',
  'WORMROT',
  'WORMWOOD',
  'WORSHIP',
  'WORST',
  'WORTH DYING FOR',
  'WOTAN',
  'WOTANS WILLE',
  'WOUNDED',
  'THE WOUNDED',
  'THE WOUNDED KINGS',
  'WOVENWAR',
  'WRAITH OF THE ROPES',
  'WRAITHS',
  'WRATH',
  'WRATH OF KILLENSTEIN',
  'WRATH OF THE WEAK',
  'WRATH OF VESUVIUS',
  'WRATHCHILD AMERICA',
  'WRECKING TANGANYIKA',
  'WRENCH IN THE WORKS',
  'WRETCHED',
  'WRETCHED SOUL',
  'WRVTH',
  'WULFGAR',
  'WURDULAK',
  'WUTHERING HEIGHTS',
  'WYKKED WYTCH',
  'WYRD',
  'WYTCHFYNDE',
  'WARMARSHAL',
  'WILLIAM WALLACE',
  "WINTER'S EMBRACE",
  'WITHERFALL',
  'WOODEN BRIDGE',
  'WRATH SINS'
];

const metalBandsX = [
  'X JAPAN',
  'X-COPS',
  'X-WILD',
  'XANDRIA',
  'XANTHOCHROID',
  'XASTHUR',
  'XE-NONE',
  'XENOCIDE',
  'XENOS',
  'XENTRIX',
  'XEPER',
  'XERATH',
  'XIBALBA',
  'XIV DARK CENTURIES',
  'XORDEAL',
  'XTYRANTX',
  'XXX MANIAK',
  'XYPHOS',
  'XYSMA',
  'XYSTER',
  'XYSTUS',
  'XZORIATH',
  'XAFBX',
  'XDEATHSTARX',
  'XKINGX',
  'XVICIOUSX'
];

const metalBandsY = [
  'YAOYOTL',
  'YASHIRA',
  'YATTERING',
  'YAWARHIEM',
  'YEAR OF CONFESSION',
  'YEAR OF DESOLATION',
  'YEAR OF NO LIGHT',
  'YEAR OF THE GOAT',
  'YEARNING',
  'YEARS SINCE THE STORM',
  'THE YELLOW SIGN',
  'YGGDRASIL',
  'YIANNIS TZIALLAS',
  'YNGWIE MALMSTEEN',
  'YOB',
  'YOUNG AND IN THE WAY',
  'YOUR BAD KARMA',
  'YOUR CHANCE TO DIE',
  'YOUR DEMISE',
  'YOUR MEMORIAL',
  'YOUR SHAPELESS BEAUTY',
  'YYRKOON'
];

const metalBandsZ = [
  'ZAFIRA',
  'ZAKK WYLDE',
  'ZAMIEĆ',
  'ZANDELLE',
  'ZANISTER',
  'ZAO',
  'ZAPRUDER',
  'ZARGOF',
  'ZARPA',
  'ZAT',
  'ZAVORASH',
  'ZED',
  'ZED YAGO',
  'ZEMIAL',
  'ZENI GEVA',
  'THE ZENITH PASSAGE',
  'ZERAKIEL',
  'ZERAPHINE',
  'ZERO CIPHER',
  'ZERO DEGREE',
  'ZERO HOUR',
  'ZEROKARMA',
  'ZEROMANCER',
  "ZIMMER'S HOLE",
  'ZIX',
  'ZNICH',
  'ZNOWHITE',
  'ZOETROPE',
  'ZOMBIE APOCALYPSE',
  'ZOMBIEKRIG',
  'ZONARIA',
  'ZONATA',
  'ZONE KILLER',
  'ZORAKARER',
  'ZOZOBRA',
  'ZUBROWSKA',
  'ZURZIR',
  'ZUUL FX',
  'ZYGNEMA',
  'ZYKLON',
  'ZØRORMR',
  'ŽALVARINIS'
];

const metalBands = [
  ...metalBandsA,
  ...metalBandsB,
  ...metalBandsC,
  ...metalBandsD,
  ...metalBandsE,
  ...metalBandsF,
  ...metalBandsG,
  ...metalBandsH,
  ...metalBandsI,
  ...metalBandsJ,
  ...metalBandsK,
  ...metalBandsL,
  ...metalBandsM,
  ...metalBandsN,
  ...metalBandsO,
  ...metalBandsP,
  ...metalBandsQ,
  ...metalBandsR,
  ...metalBandsS,
  ...metalBandsT,
  ...metalBandsU,
  ...metalBandsV,
  ...metalBandsW,
  ...metalBandsX,
  ...metalBandsY,
  ...metalBandsZ
];

export default metalBands;
